import { useId } from "react";

import { cn } from "@/lib/utils";

export function HeroIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[794px] w-[6000px]", className)}
      fill="none"
      viewBox="0 0 6000 794"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h6000v793.658H0z" fill="#fff" />
        <path d="M0 0h6000v737.145H0z" fill={`url(#${id}-b)`} />
        <path
          clipRule="evenodd"
          d="M5744.08 257.665s67.54 0 193.57-33.602c12.71-3.388 31.81-15.471 55.04-13.266 23.22 2.214 29.24 11.936 29.24 11.936s10.31-5.303 23.21-5.303c12.91 0 33.55 11.052 33.55 11.052 29.1-56.695 63.48-72.549 119.16-62.341 55.68 10.209 62.28 60.127 62.28 60.127s18.26-8.742 31.6-6.747c15.47 2.319 13.12 16.031 13.12 16.031s55.9-.446 88.79 10.833c0 0-1.94-39.412 78.72-23.495 0 0 59.02-100.74 161.67-94.798 98.47 5.696 105.93 94.798 105.93 94.798s44.51-5.591 61.92 0c17.41 5.592-5.81 23.495-5.81 23.495s52.24-8.619 88.37-8.619 39.98 19.899 39.98 19.899 34.82-7.298 45.15-6.633c10.31.665 20.64 6.633 20.64 6.633H5744.08z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="1150.35"
            cy="305.799"
            fill="#31C7ED"
            rx="588.137"
            ry="590.185"
          />
        </g>
        <g filter={`url(#${id}-d)`}>
          <ellipse
            cx="2346.89"
            cy="420.457"
            fill="#3E2AA3"
            rx="706.417"
            ry="689.108"
          />
        </g>
        <path
          d="M2065.43 373.608a4.86 4.86 0 009.72 0 4.861 4.861 0 00-4.86-4.857 4.861 4.861 0 00-4.86 4.857z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M1954.53 397.108c0 2.216 1.8 4.012 4.01 4.012 2.22 0 4.01-1.796 4.01-4.012a4.007 4.007 0 00-4.01-4.012 4.014 4.014 0 00-4.01 4.012z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M2102.27 335.509a2.835 2.835 0 005.67 0 2.835 2.835 0 00-5.67 0z"
          fill={`url(#${id}-g)`}
        />
        <path
          d="M1904.5 299.871c0 1.955 1.58 3.54 3.54 3.54 1.95 0 3.54-1.585 3.54-3.54s-1.59-3.54-3.54-3.54a3.537 3.537 0 00-3.54 3.54z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M1832.54 255.604c0 2.346 1.9 4.248 4.25 4.248s4.25-1.902 4.25-4.248c0-2.347-1.9-4.249-4.25-4.249a4.247 4.247 0 00-4.25 4.249z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M1863.17 151.184c0 1.955 1.58 3.54 3.54 3.54s3.54-1.585 3.54-3.54a3.537 3.537 0 00-3.54-3.541 3.537 3.537 0 00-3.54 3.541z"
          fill={`url(#${id}-j)`}
        />
        <path
          d="M1974.55 107.714c0 1.303 1.05 2.36 2.36 2.36 1.3 0 2.36-1.057 2.36-2.36 0-1.304-1.06-2.36-2.36-2.36a2.355 2.355 0 00-2.36 2.36z"
          fill={`url(#${id}-k)`}
        />
        <path
          d="M1849.93 66.411a3.073 3.073 0 003.07 3.069c1.7 0 3.07-1.374 3.07-3.069a3.066 3.066 0 00-3.07-3.068 3.073 3.073 0 00-3.07 3.068z"
          fill={`url(#${id}-l)`}
        />
        <path
          d="M2039.02 209.522a2.602 2.602 0 002.6 2.596c1.43 0 2.6-1.163 2.6-2.596a2.602 2.602 0 00-2.6-2.597c-1.43 0-2.6 1.163-2.6 2.597z"
          fill={`url(#${id}-m)`}
        />
        <path
          d="M2143.27 149.273a3.284 3.284 0 006.57 0 3.282 3.282 0 00-3.28-3.282 3.284 3.284 0 00-3.29 3.282z"
          fill={`url(#${id}-n)`}
        />
        <path
          d="M2040.68 149.02a3.535 3.535 0 107.07 0 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-o)`}
        />
        <path
          d="M1805.4 400.781a3.665 3.665 0 107.33 0 3.665 3.665 0 10-7.33 0z"
          fill={`url(#${id}-p)`}
        />
        <path
          d="M1747.85 191.52a3.283 3.283 0 003.28 3.284c1.81 0 3.28-1.47 3.28-3.284a3.283 3.283 0 00-3.28-3.283c-1.81 0-3.28 1.47-3.28 3.283z"
          fill={`url(#${id}-q)`}
        />
        <path
          d="M1717.7 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-r)`}
        />
        <path
          d="M1690.39 445.626a5.949 5.949 0 005.95 5.952c3.29 0 5.95-2.665 5.95-5.952a5.949 5.949 0 00-5.95-5.952 5.949 5.949 0 00-5.95 5.952z"
          fill={`url(#${id}-s)`}
        />
        <path
          d="M2634.11 373.608a4.86 4.86 0 009.72 0 4.861 4.861 0 00-4.86-4.857 4.861 4.861 0 00-4.86 4.857z"
          fill={`url(#${id}-t)`}
        />
        <path
          d="M2523.21 397.108c0 2.216 1.8 4.012 4.01 4.012 2.22 0 4.01-1.796 4.01-4.012a4.007 4.007 0 00-4.01-4.012 4.014 4.014 0 00-4.01 4.012z"
          fill={`url(#${id}-u)`}
        />
        <path
          d="M2670.95 335.509a2.835 2.835 0 005.67 0 2.835 2.835 0 00-5.67 0z"
          fill={`url(#${id}-v)`}
        />
        <path
          d="M2473.18 299.871c0 1.955 1.58 3.54 3.54 3.54 1.95 0 3.54-1.585 3.54-3.54s-1.59-3.54-3.54-3.54a3.537 3.537 0 00-3.54 3.54z"
          fill={`url(#${id}-w)`}
        />
        <path
          d="M2401.22 255.604c0 2.346 1.9 4.248 4.25 4.248s4.25-1.902 4.25-4.248c0-2.347-1.9-4.249-4.25-4.249a4.247 4.247 0 00-4.25 4.249z"
          fill={`url(#${id}-x)`}
        />
        <path
          d="M2409.64 183.753a4.487 4.487 0 004.49 4.484c2.48 0 4.48-2.008 4.48-4.484 0-2.477-2-4.484-4.48-4.484a4.486 4.486 0 00-4.49 4.484z"
          fill={`url(#${id}-y)`}
        />
        <path
          d="M2480.26 151.184c0 1.955 1.58 3.54 3.54 3.54 1.95 0 3.54-1.585 3.54-3.54a3.544 3.544 0 00-3.54-3.541 3.537 3.537 0 00-3.54 3.541z"
          fill={`url(#${id}-z)`}
        />
        <path
          d="M2518.96 238.992a4.13 4.13 0 108.261-.001 4.13 4.13 0 00-8.261.001z"
          fill={`url(#${id}-A)`}
        />
        <path
          d="M2543.23 107.714c0 1.303 1.05 2.36 2.36 2.36 1.3 0 2.36-1.057 2.36-2.36 0-1.304-1.06-2.36-2.36-2.36a2.355 2.355 0 00-2.36 2.36z"
          fill={`url(#${id}-B)`}
        />
        <path
          d="M2345.3 149.059a3.064 3.064 0 106.13 0 3.066 3.066 0 10-6.13 0z"
          fill={`url(#${id}-C)`}
        />
        <path
          d="M2607.7 209.522a2.596 2.596 0 105.192 0 2.596 2.596 0 00-5.192 0z"
          fill={`url(#${id}-D)`}
        />
        <path
          d="M2711.95 149.273a3.284 3.284 0 006.57 0 3.282 3.282 0 00-3.28-3.282 3.284 3.284 0 00-3.29 3.282z"
          fill={`url(#${id}-E)`}
        />
        <path
          d="M2673.58 15.732a3.532 3.532 0 003.53 3.534 3.534 3.534 0 100-7.069 3.532 3.532 0 00-3.53 3.535z"
          fill={`url(#${id}-F)`}
        />
        <path
          d="M2374.08 400.781a3.665 3.665 0 107.33 0 3.665 3.665 0 10-7.33 0z"
          fill={`url(#${id}-G)`}
        />
        <path
          d="M2316.53 191.52a3.283 3.283 0 003.28 3.284c1.81 0 3.28-1.47 3.28-3.284a3.283 3.283 0 00-3.28-3.283c-1.81 0-3.28 1.47-3.28 3.283z"
          fill={`url(#${id}-H)`}
        />
        <path
          d="M2234.94 267.397a3.444 3.444 0 003.45 3.444c1.9 0 3.44-1.542 3.44-3.444a3.441 3.441 0 00-3.44-3.443 3.443 3.443 0 00-3.45 3.443z"
          fill={`url(#${id}-I)`}
        />
        <path
          d="M2209.07 161.655a2.508 2.508 0 002.51 2.512c1.39 0 2.51-1.124 2.51-2.512a2.509 2.509 0 10-5.02 0z"
          fill={`url(#${id}-J)`}
        />
        <path
          d="M2286.38 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-K)`}
        />
        <path
          d="M2259.07 445.626a5.949 5.949 0 005.95 5.952c3.28 0 5.95-2.665 5.95-5.952a5.955 5.955 0 00-5.95-5.952 5.949 5.949 0 00-5.95 5.952z"
          fill={`url(#${id}-L)`}
        />
        <g filter={`url(#${id}-M)`}>
          <ellipse
            cx="3355.48"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <g filter={`url(#${id}-N)`}>
          <ellipse
            cx="4363.73"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <path
          clipRule="evenodd"
          d="M4104.89 172.944l81.63.234 651.52 1.893 130.61.38 265.75.771 64.19.185 36.18.108 137.72.39 52.3.156c-13.15-2.732-26.12-4.829-38.77-6.41-73.99-9.248-136.7-.741-157.72 2.8-4.9.83-7.55 1.386-7.55 1.386s-2.54-3.093-9.53-6.517c-5.66-2.81-14.32-5.834-26.94-7.581-21.19-2.936-42.85-.048-55.89 2.449-7.55 1.454-12.18 2.781-12.18 2.781s1.84-4.215 2.71-9.278c1.11-6.449.61-14.293-7.32-16.576-14.11-4.068-32.27 0-32.27 0s-24.22-28.79-82.76-33.18c-55.98-4.185-100.87 3.649-104.69 4.351-.17.02-.26.039-.26.039l-.79-.683a87.73 87.73 0 00-4.25-3.483c0-.019-.06-.048-.09-.068a115.595 115.595 0 00-12.13-8.146c-25.54-14.946-51.99-31.146-113.38-27.38-83.44 5.112-108.38 45.78-108.38 45.78-95.04-13.971-168.71 11.502-168.71 11.502s-38.33-4.654-74.69 4.663c-19.47 4.986-26.76 13.668-29.32 20.664a19.888 19.888 0 00-1.26 5.902c-1.08-1.385-3.29-2.781-7.52-3.776a2.536 2.536 0 00-.23-.058c-12.13-2.742-32.3-1.093-32.3-1.093v-.019c-26.31-44.095-95.37-44.76-115.63-45.134-56.76-1.054-82.87 22.548-122.37 38.363-14.4 5.756-25.39 10.722-31.37 13.522a217.652 217.652 0 00-5.13 2.439c-28.31-8.907-59.18 8.624-59.18 8.624z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M3421.87 372.286v240.998h92.91V337.422h-62.64v34.864h-30.27z"
          fill={`url(#${id}-O)`}
        />
        <path
          clipRule="evenodd"
          d="M-255.466 257.966s67.543 0 193.571-33.602c12.706-3.388 31.809-15.471 55.04-13.266 23.214 2.214 29.239 11.936 29.239 11.936s10.313-5.303 23.213-5.303 33.545 11.052 33.545 11.052c29.103-56.696 63.479-72.549 119.161-62.341 55.682 10.208 62.279 60.127 62.279 60.127s18.261-8.742 31.604-6.747c15.47 2.319 13.122 16.031 13.122 16.031s55.89-.446 88.788 10.833c0 0-1.94-39.412 78.713-23.495 0 0 59.028-100.74 161.67-94.798 98.472 5.696 105.937 94.798 105.937 94.798s44.505-5.591 61.915 0c17.411 5.592-5.803 23.495-5.803 23.495s52.231-8.619 88.363-8.619c36.131 0 39.977 19.899 39.977 19.899s34.821-7.298 45.152-6.633c10.313.665 20.644 6.633 20.644 6.633h-1246.13z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M4354.86 350.876v321.341h-71.88V325.72h49.87v25.156h22.01z"
          fill={`url(#${id}-P)`}
        />
        <path
          d="M4212.64 380.229v200.025h-78.03V412.557h18.36v-32.328h59.67z"
          fill={`url(#${id}-Q)`}
        />
        <path
          d="M4009.38 309.515v272.759h87.21V309.515h-22.04v-33.337h-12.85l-8.26-43.44h-8.26l-8.26 43.44h-11.02v33.337h-16.52z"
          fill={`url(#${id}-R)`}
        />
        <path
          d="M3601.73 462.569v120.715h98.22V457.517h-19.28v-15.153h-63.34v20.205h-15.6z"
          fill={`url(#${id}-S)`}
        />
        <path
          d="M3961.78 442.286v140.998h-92.91V442.286h19.53l10.78-34.864h32.33l11.94 34.864h18.33z"
          fill={`url(#${id}-T)`}
        />
        <path
          d="M3832.2 342.286v240.998h-92.91V307.422h62.64v34.864h30.27z"
          fill={`url(#${id}-U)`}
        />
        <path
          d="M3133.98 373.608a4.854 4.854 0 004.86 4.856c2.68 0 4.85-2.174 4.85-4.856a4.855 4.855 0 10-9.71 0z"
          fill={`url(#${id}-V)`}
        />
        <path
          d="M3023.08 397.108a4.007 4.007 0 004.01 4.012c2.22 0 4.01-1.796 4.01-4.012a4.007 4.007 0 00-4.01-4.012 4.007 4.007 0 00-4.01 4.012z"
          fill={`url(#${id}-W)`}
        />
        <path
          d="M3170.82 335.509a2.835 2.835 0 005.67 0 2.835 2.835 0 00-5.67 0z"
          fill={`url(#${id}-X)`}
        />
        <path
          d="M2973.04 299.871c0 1.955 1.59 3.54 3.54 3.54 1.96 0 3.54-1.585 3.54-3.54s-1.58-3.54-3.54-3.54a3.543 3.543 0 00-3.54 3.54z"
          fill={`url(#${id}-Y)`}
        />
        <path
          d="M2901.09 255.604c0 2.346 1.9 4.248 4.25 4.248 2.34 0 4.25-1.902 4.25-4.248a4.254 4.254 0 00-4.25-4.249 4.247 4.247 0 00-4.25 4.249z"
          fill={`url(#${id}-Z)`}
        />
        <path
          d="M2931.72 151.184c0 1.955 1.58 3.54 3.54 3.54 1.95 0 3.54-1.585 3.54-3.54a3.544 3.544 0 00-3.54-3.541 3.537 3.537 0 00-3.54 3.541z"
          fill={`url(#${id}-aa)`}
        />
        <path
          d="M3043.1 107.714c0 1.303 1.05 2.36 2.36 2.36 1.3 0 2.36-1.057 2.36-2.36 0-1.304-1.06-2.36-2.36-2.36a2.355 2.355 0 00-2.36 2.36z"
          fill={`url(#${id}-ab)`}
        />
        <path
          d="M2918.48 66.411a3.066 3.066 0 003.07 3.069c1.69 0 3.07-1.374 3.07-3.069a3.073 3.073 0 00-3.07-3.068c-1.7 0-3.07 1.374-3.07 3.068z"
          fill={`url(#${id}-ac)`}
        />
        <path
          d="M3107.57 209.522a2.596 2.596 0 105.192 0 2.596 2.596 0 00-5.192 0z"
          fill={`url(#${id}-ad)`}
        />
        <path
          d="M3211.82 149.273a3.284 3.284 0 006.57 0 3.284 3.284 0 00-3.29-3.282 3.282 3.282 0 00-3.28 3.282z"
          fill={`url(#${id}-ae)`}
        />
        <path
          d="M3109.23 149.02a3.532 3.532 0 003.53 3.535c1.95 0 3.54-1.583 3.54-3.535a3.54 3.54 0 00-3.54-3.534 3.532 3.532 0 00-3.53 3.534z"
          fill={`url(#${id}-af)`}
        />
        <path
          d="M2873.95 400.781a3.665 3.665 0 107.33 0 3.665 3.665 0 10-7.33 0z"
          fill={`url(#${id}-ag)`}
        />
        <path
          d="M2816.39 191.52a3.285 3.285 0 006.57 0 3.285 3.285 0 00-6.57 0z"
          fill={`url(#${id}-ah)`}
        />
        <path
          d="M2786.25 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-ai)`}
        />
        <path
          d="M2758.93 445.626a5.955 5.955 0 0011.91 0 5.955 5.955 0 00-11.91 0z"
          fill={`url(#${id}-aj)`}
        />
        <path
          d="M3702.66 373.608a4.854 4.854 0 004.86 4.856c2.68 0 4.85-2.174 4.85-4.856a4.855 4.855 0 10-9.71 0z"
          fill={`url(#${id}-ak)`}
        />
        <path
          d="M3591.76 397.108a4.007 4.007 0 004.01 4.012c2.21 0 4.01-1.796 4.01-4.012 0-2.216-1.8-4.012-4.01-4.012a4.007 4.007 0 00-4.01 4.012z"
          fill={`url(#${id}-al)`}
        />
        <path
          d="M3739.5 335.509a2.833 2.833 0 002.83 2.832c1.57 0 2.83-1.268 2.83-2.832a2.827 2.827 0 00-2.83-2.833 2.833 2.833 0 00-2.83 2.833z"
          fill={`url(#${id}-am)`}
        />
        <path
          d="M3541.72 299.871c0 1.955 1.59 3.54 3.54 3.54 1.96 0 3.54-1.585 3.54-3.54s-1.58-3.54-3.54-3.54a3.543 3.543 0 00-3.54 3.54z"
          fill={`url(#${id}-an)`}
        />
        <path
          d="M3469.77 255.604c0 2.346 1.9 4.248 4.25 4.248 2.34 0 4.25-1.902 4.25-4.248a4.254 4.254 0 00-4.25-4.249 4.247 4.247 0 00-4.25 4.249z"
          fill={`url(#${id}-ao)`}
        />
        <path
          d="M3478.19 183.753a4.485 4.485 0 108.97-.002 4.485 4.485 0 00-8.97.002z"
          fill={`url(#${id}-ap)`}
        />
        <path
          d="M3548.8 151.184c0 1.955 1.59 3.54 3.54 3.54 1.96 0 3.54-1.585 3.54-3.54a3.537 3.537 0 00-3.54-3.541 3.544 3.544 0 00-3.54 3.541z"
          fill={`url(#${id}-aq)`}
        />
        <path
          d="M3587.51 238.992a4.13 4.13 0 108.261-.001 4.13 4.13 0 00-8.261.001z"
          fill={`url(#${id}-ar)`}
        />
        <path
          d="M3611.77 107.714c0 1.303 1.06 2.36 2.36 2.36 1.31 0 2.36-1.057 2.36-2.36 0-1.304-1.05-2.36-2.36-2.36-1.3 0-2.36 1.056-2.36 2.36z"
          fill={`url(#${id}-as)`}
        />
        <path
          d="M3413.84 149.059a3.073 3.073 0 003.07 3.068c1.7 0 3.07-1.374 3.07-3.068a3.066 3.066 0 00-3.07-3.068 3.072 3.072 0 00-3.07 3.068z"
          fill={`url(#${id}-at)`}
        />
        <path
          d="M3676.25 209.522a2.596 2.596 0 105.188 0 2.596 2.596 0 00-5.188 0z"
          fill={`url(#${id}-au)`}
        />
        <path
          d="M3780.5 149.273a3.282 3.282 0 003.28 3.282 3.282 3.282 0 000-6.564 3.282 3.282 0 00-3.28 3.282z"
          fill={`url(#${id}-av)`}
        />
        <path
          d="M3742.13 15.732a3.532 3.532 0 003.53 3.534 3.54 3.54 0 003.54-3.534 3.54 3.54 0 00-3.54-3.535 3.532 3.532 0 00-3.53 3.535z"
          fill={`url(#${id}-aw)`}
        />
        <path
          d="M3442.63 400.781a3.665 3.665 0 107.33 0 3.665 3.665 0 10-7.33 0z"
          fill={`url(#${id}-ax)`}
        />
        <path
          d="M3385.07 191.52a3.285 3.285 0 006.57 0 3.285 3.285 0 00-6.57 0z"
          fill={`url(#${id}-ay)`}
        />
        <path
          d="M3303.49 267.397a3.442 3.442 0 003.44 3.444 3.444 3.444 0 100-6.887c-1.9 0-3.44 1.541-3.44 3.443z"
          fill={`url(#${id}-az)`}
        />
        <path
          d="M3277.61 161.655a2.515 2.515 0 005.03 0 2.515 2.515 0 00-5.03 0z"
          fill={`url(#${id}-aA)`}
        />
        <path
          d="M3354.93 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-aB)`}
        />
        <path
          d="M3327.61 445.626a5.955 5.955 0 0011.91 0 5.955 5.955 0 00-11.91 0z"
          fill={`url(#${id}-aC)`}
        />
        <path
          clipRule="evenodd"
          d="M2768.52 225.361l401.67-1.823 697.14-3.177 49.77-.222 38.18-.394 90.14-.912c-14.45-4.483-37.28-9.878-64.06-12.489-34.81-3.399-76.34-2.118-114.94 12.021-.17-.172-.33-.345-.52-.492-6.14-6.06-12.57-10.888-19.13-14.706-48.99-28.723-105.72-1.552-113.05 2.192-.56.271-.82.419-.82.419s.07-.468.17-1.355c.16-1.33.35-3.572.42-6.429.1-4.434-.07-10.346-1.1-16.628-2.41-13.795-9.19-29.387-27.18-34.881-28.18-8.621-55.52 21.308-70 41.089-6.66 9.114-10.59 16.085-10.59 16.085s0-3.375-1.39-8.695c-4.71-18.081-43.3-88.854-145.94-88.854-102.65 0-127.72 62.383-165.18 110.851l-51.69-11.183c-.72-.148-1.43-.296-2.14-.444-52.25-10.321-150.2 5.346-150.2 5.346s-18.61-18.796-71.57-21.086c-52.95-2.316-129.12 29.239-129.12 29.239-72.51-3.744-138.87 6.528-138.87 6.528z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          clipRule="evenodd"
          d="M806.263 578.571l-4.221 15.415h11.582l1.243-15.415-.932-23.238 8.981-11.596 16.657-12.88 2.258-11.884h-1.307l-3.466 11.162-18.306 12.55-2.555 5.424-3.815 1.012-2.485-9.836 12.321-22.986-.651-7.377 12.379-6.366 9.863-15.818-.652-.651-9.863 15.074-11.951 5.212-1.5-16.994-19.433-10.727-.938.633 17.63 11.011 2.019 24.776-11.295 19.346-9.638-1.177-16.464-11.959h.43l-2.149-5.993-24.583-22.164-1.018.298 22.843 21.866 1.443 5.884-17.023 4.91v1.652l19.086-3.881 25.51 22.967v31.75z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M617.979 604.833H1620.38L1220.97 168.8l-48.02 16.918-80.08 72.573-85.39 9.963-389.501 336.579z"
          fill={`url(#${id}-aD)`}
        />
        <path
          clipRule="evenodd"
          d="M1141 545.114l.27-7.33-6.52-31.858-13.85-15.43-4.95-11.222h1.02l5.97 9.91 14.58 14.72 9.91-9.91 2.48-8.307 9.61-9.765.71 1.24-8.31 9.169-2.01 9.264-9.93 12.321 5.16 27.411.86 3.82 7.68-10.41.72-17.765 16.24-9.656 6.29-15.629 14.92-12.085-.27 1.663-12.56 11.267-4.12 11.924 7.32-8.343 15.94-7.323v1.112l-14.83 7.954-9.36 10.957-16.96 9.826v12.884l26.79-21.783 19.56-3.708v1.112l-19.56 5.339-26.14 23.675-9.92 16.222 1.86 44.582h-10.33l1.49-39.623-23.81-24.963-.93-6.052-15.94-8.739v-1.779l18.09 9.488.89 5.781 12.16 12.156 9.78 7.883z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M900.729 422.306c-1.148-4.592-6.198-13.259-17.219-11.193-13.775 2.583-11.623 15.498 0 13.345 9.299-1.722 3.874-5.94 0-7.834m18.819-6.156h-34.517m77.629-27.429c-8.893-7.991-27.451-25.518-30.544-31.704m9.928 11.921v11.081m10.432-.334v11.081"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          d="M913.676 360.842c-3.873 31.334-20.684 68.799-28.606 83.615h117.94l-18.481-27.725c-41.544-22.18-64.545-46.502-70.853-55.89z"
          fill="#DAA1B5"
        />
        <path
          d="M857.005 577.005c12.872-14.009 5.401-71.51 5.401-71.51l71.821-16.511 8.7 88.021h-85.922z"
          fill="#4D0D54"
        />
        <path
          d="M902.93 428.71c4.825-12.203 10.998-42.926 13.481-56.762l61.375 119.556s-70.616 18.703-68.801 13.861c0-47.807-6.055-76.655-6.055-76.655z"
          fill={`url(#${id}-aE)`}
        />
        <path
          d="M922.262 411.203l3.946 37.241h-6.815l-4.283-38.041a2.809 2.809 0 012.791-3.123 4.385 4.385 0 014.361 3.923z"
          fill={`url(#${id}-aF)`}
        />
        <path
          d="M1045.63 422.306c1.15-4.592 6.2-13.259 17.22-11.193 13.78 2.583 11.62 15.498 0 13.345-9.3-1.722-3.87-5.94 0-7.834m-18.82-6.156h34.52"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          clipRule="evenodd"
          d="M922.666 448.444l-3.539-29.189h-3.02l-.074-.654h3.015l-1.371-11.312c.074-.006.149-.009.224-.009.147 0 .293.007.436.022l1.37 11.299h3.339l.069.654h-3.329l3.538 29.189h-.658z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M991.153 371.07c6.573-2.343 34.647-15.401 36.447-17.432v9.785M999.027 368v7.291m9.593-12.035v8.39"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          clipRule="evenodd"
          d="M954.806 444.458c-17.487-19.233-32.389-46.347-41.152-83.436l.022-.18c6.308 9.389 29.31 33.711 70.854 55.891l18.48 27.725h-48.204z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M1027.59 362.602c-9.94 5.96-23.02 10.52-28.81 12.412l-30.51 63.503h89.27c-13.62-21.57-25.1-59.36-29.95-75.915z"
          fill="#DAA1B5"
        />
        <path
          d="M883.831 456.275h66.674l-17.369 54.779h-90.724c19.24-11.045 35.629-41.122 41.419-54.779z"
          fill="#A36281"
        />
        <path d="M1018.41 358.795v8.39" stroke="#fff" strokeWidth="1.307" />
        <path
          d="M1097.68 577.005c-12.87-14.009-5.4-71.51-5.4-71.51l-71.83-16.511-8.7 88.021h85.93z"
          fill="#4D0D54"
        />
        <path
          d="M1039.86 412.861c-6.82-14.475-12.54-36.305-14.55-45.41l-49.312 92.948s79.712 43.823 68.562 34.141c-11.14-9.683-4.7-81.679-4.7-81.679z"
          fill={`url(#${id}-aG)`}
        />
        <path
          d="M1024.75 411.203l-3.94 37.241h6.81l4.28-38.041a2.804 2.804 0 00-2.79-3.123 4.39 4.39 0 00-4.36 3.923z"
          fill={`url(#${id}-aH)`}
        />
        <path
          clipRule="evenodd"
          d="M1024.35 448.444l3.54-29.189h3.02l.07-.654h-3.01l1.37-11.312a4.128 4.128 0 00-.66.013l-1.37 11.299h-3.34l-.07.654h3.33l-3.54 29.189h.66z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M1027.52 362.336c-9.92 5.921-30.412 13.11-36.175 14.992l-23.973 61.542h40.868c6.6-19.709 14.46-53.746 19.28-76.534z"
          fill="#fff"
        />
        <path
          d="M1070.85 456.275h-47.06l17.37 54.779h71.11c-19.24-11.045-35.63-41.122-41.42-54.779z"
          fill="#CE9FB6"
        />
        <path
          d="M947.589 447.52l-5.652-116.094 8.847-9.584 40.55 2.457V447.52l-34.406 4.424-9.339-4.424z"
          fill={`url(#${id}-aI)`}
        />
        <path
          d="M978.477 393.37h-4.935l-1.632-39.983a32.547 32.547 0 013.409-15.88l.546 1.296a33.343 33.343 0 012.612 12.937v41.63z"
          fill={`url(#${id}-aJ)`}
        />
        <path
          d="M947.755 305.788l-14.491 27.74 25.876-7.263h43.74l-16.205-20.477-22.772-67.903-16.148 67.903z"
          fill={`url(#${id}-aK)`}
        />
        <path
          d="M1047.13 506.145c-34.72-32.762-56.642-74.365-63.264-91.072l9.252-14.87s22.762 50.969 73.262 105.942h-19.25z"
          fill="#A36281"
        />
        <path
          d="M956.191 322.169l-5.407-.327-8.847 9.584 5.652 116.094 13.757 6.679-5.155-132.03z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M964.006 238.192l-1.671 71.853-5.195 16.781-23.876 6.702 14.491-27.74 16.148-67.903.103.307z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M964.002 436.772c-22.004 46.453-43.804 63.567-51.954 66.318 0 0 7.987 59.728 0 86.661H1056.9c-9.03-18.074-5.31-86.661-5.31-86.661-37.61-40.128-47.35-63.363-61.917-89.544-7.335 9.535-20.17 19.457-25.671 23.226z"
          fill={`url(#${id}-aL)`}
        />
        <circle cx="1001.58" cy="488.511" fill="#4D0D54" r="13.138" />
        <path
          d="M990.685 533.117v56.572h24.035v-56.572c0-6.636-5.38-12.016-12.02-12.016-6.635 0-12.015 5.38-12.015 12.016z"
          fill={`url(#${id}-aM)`}
        />
        <path
          clipRule="evenodd"
          d="M952.505 589.751v-95.079l-32.228 3.606c-3.428 2.608-6.236 4.139-8.229 4.812 0 0 7.987 59.728 0 86.661h40.457z"
          fill={`url(#${id}-aN)`}
          fillRule="evenodd"
        />
        <path
          d="M976.745 528.123l1.367 28.953h-10.885l-2.135-30.054a4.951 4.951 0 014.939-5.303 6.72 6.72 0 016.714 6.404z"
          fill={`url(#${id}-aO)`}
        />
        <path
          d="M970.66 521.719l2.39 35.227m-6.999-15.705h11.204"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          d="M1028.97 528.123l-1.37 28.953h10.89l2.13-30.054a4.945 4.945 0 00-4.94-5.303 6.724 6.724 0 00-6.71 6.404z"
          fill={`url(#${id}-aP)`}
        />
        <path
          d="M1035.06 521.719l-2.39 35.227m6.99-15.705h-11.2"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          d="M1062.88 528.123l-1.37 28.953h10.89l2.13-30.054a4.945 4.945 0 00-4.94-5.303 6.717 6.717 0 00-6.71 6.404zm-161.251 0l1.366 28.953h-10.884l-2.136-30.054a4.953 4.953 0 014.94-5.303 6.721 6.721 0 016.714 6.404z"
          fill="#4D0D54"
        />
        <path
          d="M943.22 504.312c29.583-25.182 45.536-79.968 49.814-104.213l-49.814 12.837s-22.955 69.664-63.474 94.432l63.474-3.056z"
          fill="#fff"
        />
        <path
          d="M1025.88 355.564l1.68 8.557 1.56-8.557-1.56-22.69-1.68 22.69z"
          fill={`url(#${id}-aQ)`}
        />
        <path
          d="M962.385 232.362l1.685 8.557 1.556-8.557-1.556-22.69-1.685 22.69z"
          fill={`url(#${id}-aR)`}
        />
        <path
          d="M912.033 354.045l1.686 8.557 1.556-8.557-1.556-22.69-1.686 22.69z"
          fill={`url(#${id}-aS)`}
        />
        <path
          d="M975.156 338.006l.854 55.364m-4.115-38.011h6.582m-5.709 21.223h5.716"
          stroke="#fff"
          strokeWidth="0.654"
        />
        <path
          d="M1071.81 538.543l-3.06 28.759m10.47-27.97l-3.06 28.758m10.47-27.969l-3.06 28.758m10.47-27.97l-3.06 28.759m9.26-16.57l-1.85 17.359m10.05-24.004l-2.64 24.792m10.05-24.002l-2.64 24.792m10.05-24.004l-2.64 24.792m-51.96-29.194l28.34 3.017m-8.34 15.791l35.62 3.792m-236.222-30.967l4.392 41.265m-15.026-40.133l4.393 41.265m-15.026-40.134l4.392 41.265m-15.026-40.133l4.393 41.265m-13.285-23.776l2.651 24.908m-14.42-34.441l3.786 35.573m-14.42-34.441l3.787 35.573m-14.42-34.442l3.786 35.574m74.56-41.89l-40.663 4.328m11.964 22.659l-51.109 5.441"
          stroke="#FFEDED"
          strokeWidth="1.238"
        />
        <path
          d="M4268.64 687.704h1002.4l-399.4-436.032-48.02 16.918-80.08 72.573-85.4 9.963-389.5 336.578z"
          fill={`url(#${id}-aT)`}
        />
        <path
          d="M1244.7 647.704h1002.4l-399.41-436.032-48.02 16.918-80.08 72.573-85.39 9.963-389.5 336.578z"
          fill={`url(#${id}-aU)`}
        />
        <path
          d="M3399.34 627.704h-1002.4l399.41-436.032 48.02 16.918 80.08 72.573 85.39-50.037 389.5 396.578z"
          fill={`url(#${id}-aV)`}
        />
        <path
          clipRule="evenodd"
          d="M1205.27 222.944l81.63.234 651.53 1.893 130.6.38 265.75.771 64.2.185 36.17.108 137.72.39 52.3.156c-13.15-2.732-26.12-4.829-38.77-6.41-73.99-9.248-136.7-.741-157.72 2.8-4.9.83-7.55 1.386-7.55 1.386s-2.53-3.093-9.53-6.517c-5.66-2.81-14.32-5.834-26.94-7.581-21.19-2.936-42.85-.048-55.88 2.449-7.55 1.454-12.19 2.781-12.19 2.781s1.84-4.215 2.71-9.278c1.11-6.449.61-14.293-7.32-16.576-14.1-4.068-32.27 0-32.27 0s-24.22-28.79-82.76-33.18c-55.97-4.185-100.87 3.649-104.69 4.351-.17.02-.26.039-.26.039-.26-.224-.52-.458-.79-.683a87.73 87.73 0 00-4.25-3.483c0-.019-.06-.048-.09-.068a115.563 115.563 0 00-12.13-8.146c-25.54-14.946-51.99-31.146-113.38-27.381-83.44 5.113-108.38 45.781-108.38 45.781-95.04-13.971-168.71 11.502-168.71 11.502s-38.33-4.654-74.68 4.663c-19.48 4.986-26.77 13.668-29.33 20.664a19.888 19.888 0 00-1.26 5.902c-1.07-1.385-3.29-2.781-7.52-3.776a1.89 1.89 0 00-.23-.058c-12.13-2.742-32.3-1.093-32.3-1.093v-.019c-26.3-44.095-95.37-44.76-115.63-45.134-56.76-1.054-82.87 22.548-122.37 38.363-14.4 5.756-25.39 10.722-31.37 13.522a217.652 217.652 0 00-5.13 2.439c-28.31-8.907-59.18 8.624-59.18 8.624z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M2334.95 254.509c0-.809-.58-1.83-.87-2.239l-.23 2.239-.27.843v1.711l-1.31.385c-.42.511-1.41 1.534-2.04 1.534-.64 0-1.48-1.023-1.82-1.534v1.534l-2.62 2.556c-.45 1.951-1.45 6.068-1.81 6.931-.37.864.6.89 1.13.796.29.416.9 1.284 1.08 1.42.23.17 8.47 1.988 9.32 2.159.85.17 4.15 3.636 7.33 6.647 3.18 3.011 6.19 2.67 7.21 2.67.82 0 1.22 1.25 1.31 1.875l1.19.398 3.18-2.273c1.05.5.97 2.026.8 2.727l-7.5 7.045-1.02-1.818c-.68-.182-6.19-3.863-8.86-5.681l-14.72-2.898c-3.77 4.716-7.45 14.183-11.31 13.892-3.86-.292-11.08-13.381-11.08-13.892 0-.409 1.37-1.534 2.22-2.272v-1.477c-3.95.772-3.8-1.572-3.24-2.841l3.24-2.102 2.05 1.022v2.955l5.51 7.613c-.32-2.746-.97-8.488-.97-9.488s2.5-10.681 3.75-15.396c-1.59-.534-13.59.533-14.18.533-.47 0-2.98-2.392-4.18-3.589.07-.307.2-.968.2-1.152 0-.184.96-.362 1.45-.428l4.54 2.733 5.66-1.712-6.48.23c-.89-.538-2.67-1.745-2.67-2.272 0-.658 1.02-2.634 1.48-2.667.37-.026 2.09 1.175 2.9 1.778l13.54-1.35v-1.514l2.53-1.699 6.45 4.727v-.898c.44-2.047 2.21-5.679 5.85-3.829 3.65 1.849 3.69 4.816 3.26 6.068zm-283.75-18.426c.7-.742 1.02-2.161 1.08-2.954-.43.176-1.64.069-2.96-.352-1.32-.422-3.16-2.232-3.92-3.085-.43-3.306 1.74-4.568 3.92-4.307 1.74.209 2.98 2.494 3.39 3.611l1.04.261c0-.362.15-1.296.75-2.132.59-.835 4.02-3.568 5.65-4.829l2.48-5.004c1.48-2.001 4.51-6.056 4.79-6.265.28-.209.46-1.537.52-2.176.65-.638 2.05-1.888 2.44-1.783.38.104 1.49 1.232 2 1.783h-1.13c-.35 1.393-1.88 2.872-2.6 3.438-1.96 4.859-5.41 9.906-6.89 11.823l-.33 3.85c2.37 3.037 8.51 4.954 11.28 5.532 1.54-.669 4.11-1.566 8.02.685 1.74.998 4.24 5.046 4.89 6.854v2.549c1.03.542 5.37 3.797 3.74 5.206-1.3 1.127-4.19-1.193-5.47-2.495-1.78 0-3.31-2.169-3.85-3.254-1.49.651-4.79 1.953-6.13 1.953-1.35 0-4.07.578-5.26.867-4.08.131-8.48-2.668-10.17-4.083l-.39-2.164c-.52.1-1.58.448-1.58 1.043s.33 4.731.5 6.724c-.37 2.867-1.3 8.705-2.04 9.122-.74.418-4.83.6-6.79.638l-.34-.638c1.76-.406 5.4-1.299 5.91-1.624.51-.325.21-7.444 0-10.963h-.64l-.4-4.002c-.79-.967-2.21-3.086-1.51-3.829z"
          fill="#4D0D54"
        />
        <path d="M0 576.435h6000V830.9H0z" fill="#B8E6FF" />
        <path
          clipRule="evenodd"
          d="M511.122 385.175c-.241.202-4.622 3.838-12.862 7.341-8.482 3.612-23.815-4.376-23.815-4.376l-125.239 5.8s-5.952 26.242 1.611 34.371c7.563 8.128 52.314-15.562 52.314-15.562s4.812 2.83 10.894.976c6.083-1.841 9.699-14.776 9.699-14.776s.919 1.286 2.621 3.108c.121.12.23.254.365.375 2.376 2.49 6.088 5.836 10.831 8.33 3.261 1.707 6.99 3.022 11.119 3.381 15.023 1.321 22.53-10.3 22.53-10.3s8.356 36.507 24.46 35.955c16.091-.565 17.02-54.307 17.02-54.307l-1.534-.343-.014.027zm-35.529 17.063c-1.311-1.554-1.831-3.716-2.025-5.114a15.356 15.356 0 01-.127-1.411c1.509.599 3.21 5.553 2.973 6.737-.079.363-.321.378-.821-.212z"
          fill={`url(#${id}-aW)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M368.621 394.255l148.452-10.388.009 2.17-148.45 10.819-.011-2.601z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M511.672 511.995s-58.738-9.149-118.416-27.827c0 0 8.666 49.708.228 53.965 0 0 62.525-10.872 111.95-3.834l6.238-22.304z"
          fill="#093046"
          fillRule="evenodd"
        />
        <path
          d="M425.02 517.968l-.23-.349c26.694-17.617 50.316-52.485 65.425-78.618 16.377-28.33 26.572-52.802 26.678-53.044l.391.16c-.107.242-10.302 24.741-26.705 53.098-15.136 26.173-38.798 61.094-65.559 78.753z"
          stroke="#fff"
          strokeWidth="1.68"
        />
        <path
          clipRule="evenodd"
          d="M418.995 527.068l11-202.925 1.802-.007-5.97 203.32s-3.85 2.02-6.832-.388z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M330.366 466.013l175.517 5.913.014 3.376-175.516-5.846-.015-3.443z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M498.609 475.01s-.179 5.486-2.687 10.055c-1.468 2.668-3.73 5.017-7.209 5.798-9.456 2.083-28.671-14.507-28.671-14.507s-3.211 3.698-13.785 5.41c-10.574 1.698-16.094-3.522-16.094-3.522s-5.133 26.265-43.007 22.97c-37.887-3.295-41.936-29.279-41.936-29.279s-6.044 4.61-10.516 2.72c-4.471-1.891-4.33-6.704-4.33-6.704l48.946 1.823 40.017 1.484s1.128-3.5 4.679-3.206c3.537.308 6.1 2.435 6.1 2.435s9.51 1.035 12.13.661c2.607-.374 13.791-.771 16.4-.5 2.623.272 5.888 2.893 5.888 2.893s6.069 1.386 13.037 2.19c.498.052.968.104 1.426.155l.86.077c1.695.168 3.43.282 5.097.315.296-.001.619.024.915.023.497.011.981.009 1.438-.006.269-.001.551-.002.793-.017 1.318-.059 2.554-.172 3.683-.365.147-.028.282-.055.403-.082 1.679-.33 3.088-.834 4.08-1.591.121-.081.228-.175.335-.27l1.334.707.647.347.027-.014z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M498.609 475.01s-.179 5.486-2.687 10.055c-1.468 2.668-3.73 5.017-7.209 5.798-9.456 2.083-28.671-14.507-28.671-14.507s-3.211 3.698-13.785 5.41c-10.574 1.698-16.094-3.522-16.094-3.522s-5.133 26.265-43.007 22.97c-37.887-3.295-41.936-29.279-41.936-29.279s-6.044 4.61-10.516 2.72c-4.471-1.891-4.33-6.704-4.33-6.704l48.946 1.823 40.017 1.484s1.128-3.5 4.679-3.206c3.537.308 6.1 2.435 6.1 2.435s9.51 1.035 12.13.661c2.607-.374 13.791-.771 16.4-.5 2.623.272 5.888 2.893 5.888 2.893s6.069 1.386 13.037 2.19c.498.052.968.104 1.426.155l.86.077c1.695.168 3.43.282 5.097.315.296-.001.619.024.915.023.497.011.981.009 1.438-.006.269-.001.551-.002.793-.017 1.318-.059 2.554-.172 3.683-.365.147-.028.282-.055.403-.082 1.679-.33 3.088-.834 4.08-1.591.121-.081.228-.175.335-.27l1.334.707.647.347.027-.014z"
          fill={`url(#${id}-aX)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M498.609 475.01s-.179 5.486-2.687 10.055c-1.468 2.668-3.73 5.017-7.209 5.798-9.456 2.083-28.671-14.507-28.671-14.507s-3.211 3.698-13.785 5.41c-10.574 1.698-16.094-3.522-16.094-3.522s-5.133 26.265-43.007 22.97c-37.887-3.295-41.936-29.279-41.936-29.279s-6.044 4.61-10.516 2.72c-4.471-1.891-4.33-6.704-4.33-6.704l48.946 1.823 40.017 1.484s1.128-3.5 4.679-3.206c3.537.308 6.1 2.435 6.1 2.435s9.51 1.035 12.13.661c2.607-.374 13.791-.771 16.4-.5 2.623.272 5.888 2.893 5.888 2.893s6.069 1.386 13.037 2.19c.498.052.968.104 1.426.155l.86.077c1.695.168 3.43.282 5.097.315.296-.001.619.024.915.023.497.011.981.009 1.438-.006.269-.001.551-.002.793-.017 1.318-.059 2.554-.172 3.683-.365.147-.028.282-.055.403-.082 1.679-.33 3.088-.834 4.08-1.591.121-.081.228-.175.335-.27l1.334.707.647.347.027-.014z"
          fill={`url(#${id}-aY)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M339.008 382.743l126.594-12.783.013 3.113-126.593 12.904-.014-3.234z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M369.632 528.353l25.961-171.891 2.319-.01-20.179 171.867-8.101.034z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M347.273 381.674s-.041.068-.054.109c0-.055.04-.095.054-.123v.014z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M458.241 371.618s-5.716 15.391-2.35 48.209v-.014c3.352 32.791 19.71 60.512 19.71 60.512l-1.224.005s-10.01-6.013-27.969-11.602l-7.624-28.392 4.481 27.443c-9.96-2.915-22.105-5.61-36.13-7.135l4.02-29.211-4.605 17.499-13.864 10.619-.565-.023v-6.605l-2.847 6.508a185.7 185.7 0 00-16.21.231l2.787-30.378-4.999 30.52c-2.17.153-4.29.343-6.36.565v-7.446c0 1.702-1.338 4.76-2.945 7.787-3.351.418-6.566.919-9.642 1.486v-9.273l3.07-19.341-6.447 15.35-3.991 13.815-.604 1.125c-26.142 6.197-40.153 16.574-40.153 16.574l.053-.121c.465-1.252 4.361-11.621 10.735-27.042 1.105-2.667 2.276-5.468 3.528-8.418v-.027h.013a888.735 888.735 0 014.913-11.435l.026-.067a1082.18 1082.18 0 0111.948-26.442l.56-1.173c.708-1.518 1.434-3.037 2.163-4.563v-.001l.003-.006.526-1.101a764.433 764.433 0 018.984-18.269c-.039.162.042.457.797.777 2.02.811 8.759 1.724 30.656.556 23.939-1.271 52.122-6.809 67.113-10.085l.094-.028c2.982-.644 5.44-1.206 7.226-1.617 2.136-.493 3.331-.794 3.331-.794l1.792 1.028zM332.43 444.053c-.764.379-1.426-.087-1.932-.945-.88-1.479-1.292-4.135-.953-5.644.531-2.361 3.387-8.581 4.733-9.821 1.448-1.342 3.883-1.125 4.316-.545.442.581.433 1.268-.722 2.042-1.087.734-3.683 2.782-4.003 3.041.4-.227 4.515-2.554 4.442-.462-.05 1.257-1.271 4.744-2.703 7.702-.525 1.055-1.894 3.459-3.178 4.632zm112.269-12.242c1.393-3.623 3.344-11.984 0-16.444-3.345-4.459-1.394 9.105 0 16.444z"
          fill={`url(#${id}-aZ)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M415.168 400.773c5.714 16.024-3.81 28.708-13.268 28.748l-2.454 8.957-4.735.02-.031-7.192-2.02 7.201-4.07.017-1.068-6.826-1.729 6.838-3.742.016-2.09-6.366.027 6.374-2.954.013-1.507-12.372c-16.198-37.435 32.787-44.649 39.641-25.428zm-23.822 11.582c-1.486 5.297-.155 10.302 2.971 11.178 3.126.877 6.865-2.706 8.351-8.003 1.485-5.298.155-10.302-2.971-11.179-3.127-.877-6.866 2.706-8.351 8.004zm-4.848 2.455c.326 4.753-1.631 8.758-4.37 8.945-2.74.188-5.224-3.513-5.549-8.266-.326-4.752 1.631-8.757 4.37-8.945 2.739-.187 5.224 3.514 5.549 8.266zm3.619 14.68c-.839.003-1.523-.779-1.528-1.747-.004-.969.674-1.757 1.513-1.76.84-.004 1.524.778 1.528 1.747.004.968-.673 1.756-1.513 1.76zm-5.724-1.941c.004.763.542 1.379 1.203 1.376.661-.003 1.195-.623 1.191-1.386-.003-.762-.541-1.378-1.202-1.375-.662.002-1.195.623-1.192 1.385z"
          fill={`url(#${id}-ba)`}
          fillRule="evenodd"
        />
        <path
          d="M239.655 408.681a1.818 1.818 0 01-.834-.185c-.701-.374-.731-1.167-.745-1.207l.417-.002s.029.578.528.845c.472.253 1.493.276 3.612-1.037l.217.349c-1.328.825-2.402 1.233-3.208 1.237h.013z"
          fill="#7C3858"
        />
        <path
          clipRule="evenodd"
          d="M428.539 331.232c7.273-1.961 23.821-5.47 31.828-3.819 3.609.744 5.956 2.588 8.519 4.6 4.545 3.57 9.767 7.671 23.902 7.106l.424 4.357c-.714.881-2.66 2.603-4.882 2.603-2.239 0-8.28-3.266-11.021-4.898h-16.793c.699 0 11.487 1.516 16.793 2.274 4.384 1.511 11.695 4.208 16.528 6.452l.273 2.802c-2.731-1.51-8.458-4.222-12.077-4.356 1.228.534 5.311 2.642 12.331 6.97l.496 5.095-10.903-5.068c-2.974-.816-9.901-2.449-13.82-2.449-3.919 0-11.312-2.332-14.52-3.498 6.181 4.956 19.173 14.554 21.692 13.295 1.942-.971 10.871.629 17.986 2.188l.794 8.169c-7.463-1.46-23.708-5.321-28.988-9.089-1.356-.968-2.39-1.826-3.29-2.573-3.48-2.889-4.969-4.126-15.422-3.664-10.525.466-18.59 1.833-21.307 2.459 4.102-4.93 10.137-17.623 1.457-28.956z"
          fill={`url(#${id}-bb)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M425.884 401.01c.095.201.352.737.826 1.448-.122-.134-.243-.254-.365-.375a18.773 18.773 0 01-.461-1.06v-.013z"
          fill={`url(#${id}-bc)`}
          fillRule="evenodd"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M237.583 401.913l-.083-.403c58.65-11.635 107.838-32.091 138.764-47.212 33.515-16.383 53.422-30.194 53.623-30.33l.243.336c-.201.135-20.121 13.959-53.663 30.342-30.966 15.135-80.181 35.618-138.884 47.267z"
          stroke="#fff"
          strokeWidth="1.68"
        />
        <path
          clipRule="evenodd"
          d="M337.756 512.73s127.92 5.2 169.576 15.78c0 0-12.84 15.878-52.664 15.455-39.838-.423-83.959-5.87-83.959-5.87l-32.953-25.351v-.014z"
          fill="#BBEFFE"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M517.982 516.297c-1.706 9.728-3.821 18.368-6.195 26.015-12.268 39.834-30.929 52.645-30.929 52.645l-167.691.709s-.233-7.447-6.123-20.504c-3.04-6.723-9.522-13.417-25.951-41.985-13.896-24.128-9.045-46.95-6.076-60.246 1.174-5.249.727-12.426.727-12.426l-42.887-60.104 3.182-1.049 48.552 58.091c.486.293.971.574 1.456.827.054.027.094.053.148.08.323.173.633.333.957.493.229.12.471.227.7.334.027.013.041.026.068.026.161.08.336.147.511.227 15.557 6.683 36.736 1.283 77.39 6.879 28.29 3.886 43.442 10.329 44.803 10.915a.19.19 0 00.094.027c.294 5.941.854 11.209 1.546 15.804.082.497.152.967.234 1.451 1.422 8.733 3.317 14.977 4.772 18.87.123.322.231.617.34.899 1.06 2.711 1.805 4.026 1.805 4.026l31.528 3.281 8.151.853 3.39.349c3.236-3.994 6.081-8.523 8.336-12.539.467-.822.894-1.617 1.308-2.385 2.681-5.013 4.238-8.744 4.238-8.744s6.633 1.209 20.001 5.388c20.382 6.367 21.642 11.793 21.642 11.793h-.027z"
          fill={`url(#${id}-bd)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M471.988 508.118c15.668 4.621 30.615 10.346 44.151 17.574a233.35 233.35 0 01-.48 2.153c-13.654-7.351-28.799-13.151-44.715-17.819.367-.653.711-1.289 1.044-1.908zm10.577 85.477c-1.087.936-1.707 1.362-1.707 1.362l-1.707.007c-21.589-5.036-43.742-7.654-65.288-9.256-14.544-1.081-28.792-1.699-42.399-2.289h-.001l-.014-.001h-.007c-3.119-.135-6.204-.269-9.252-.407-16.335-.737-31.589-1.584-45.048-3.354a1.062 1.062 0 11.277-2.107c13.358 1.757 28.529 2.601 44.867 3.339 3.039.137 6.119.271 9.234.406h.009l.014.001h.003c13.608.59 27.896 1.209 42.475 2.293 22.562 1.678 45.869 4.471 68.544 10.006zm14.42-17.723a106.31 106.31 0 01-1.171 1.85c-28.626-9.484-59.081-13.546-88.411-15.727-14.544-1.082-28.792-1.7-42.399-2.29h-.014l-.008-.001h-.01c-3.115-.135-6.197-.269-9.242-.406-16.335-.738-31.589-1.585-45.048-3.355a1.062 1.062 0 01.277-2.106c13.358 1.756 28.529 2.6 44.867 3.338 3.035.137 6.111.27 9.221.405l.013.001h.009l.014.001h.001c13.609.59 27.897 1.21 42.477 2.294 29.561 2.198 60.401 6.31 89.424 15.996zm9.164-17.956c-.278.661-.557 1.312-.837 1.953-33.299-14.082-71.104-19.939-107.298-23.104-15.912-1.391-31.494-2.261-46.238-3.084-2.347-.131-4.672-.26-6.974-.391-16.753-.95-32.283-1.939-45.735-3.708a1.062 1.062 0 11.277-2.106c13.363 1.757 28.818 2.742 45.579 3.693 2.294.13 4.613.259 6.955.39h.012c14.742.823 30.361 1.695 46.309 3.09 36.264 3.17 74.338 9.051 107.95 23.267zm5.698-15.798c-20.583-9.781-44.035-16.497-68.196-21.295l7.292.759 8.151.853 3.085.317c17.732 4.37 34.798 9.979 50.29 17.309a181.96 181.96 0 01-.622 2.057zm-93.307-25.614a51.235 51.235 0 01-.93-2.229l-.023-.059a687.61 687.61 0 00-17.785-2.353c-20.659-2.472-40.85-4.052-59.214-5.454l-2.581-.196c-17.343-1.323-32.948-2.512-45.692-4.188a1.061 1.061 0 10-.277 2.106c12.803 1.684 28.462 2.878 45.777 4.198l2.611.199c18.366 1.402 38.515 2.979 59.123 5.444a688.094 688.094 0 0118.991 2.532zm-5.497-18.884c-.135-.718-.266-1.455-.395-2.211a745.836 745.836 0 00-10.552-1.543c-17.544-2.444-34.803-4.277-50.909-5.987h-.003c-3.382-.359-6.713-.713-9.985-1.065-18.874-2.035-35.768-4.039-49.229-6.879a1.063 1.063 0 00-.439 2.079c13.582 2.865 30.58 4.879 49.44 6.912 3.28.354 6.616.708 10.002 1.068h.001c16.104 1.709 33.323 3.538 50.829 5.976 3.738.521 7.487 1.069 11.24 1.65z"
          fill="#FFD0BA"
          fillRule="evenodd"
          opacity="0.4"
        />
        <path
          clipRule="evenodd"
          d="M275.744 460.491s1.002 46.111 16.833 76.254c15.83 30.143 19.294 38.383 20.59 58.921 0 0 2.756-12.757-18.899-34.002-29.107-28.554-31.792-56.238-26.663-86.631 0 0 5.513-2.861 6.501-4.586 1.962-3.396 1.638-9.956 1.638-9.956z"
          fill={`url(#${id}-be)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M313.167 595.667l1.654-.007s.267-9.937-6.114-27.899c-6.382-17.962-13.537-28.216-19.799-52.982-7.411-29.264-5.516-51.711-3.036-56.629l-49.833-58.811-3.182 1.049 45.106 60.081s-.778 38.778 7.192 60.201c7.982 21.424 26.245 48.169 28.012 74.983v.014z"
          fill="#2C788C"
          fillRule="evenodd"
        />
        <path
          d="M319.738 463.315c.576 11.818 2.998 35.454 8.071 35.454 6.341 0 7.206-35.454 10.953-35.454 2.998 0 6.63 46.12 8.071 69.179m35.808-63.628c2.292-.955 6.877 2.277 6.877 20.159.001 22.352-1.719 42.412 2.866 42.412 3.668 0 4.773-38.958 4.867-58.773m90.83 29.535c-1.714 10.627-4.114 31.831 0 31.625 4.114-.205 10.284-18.598 12.856-27.769"
          stroke="#134157"
          strokeLinecap="round"
          strokeWidth="1.344"
        />
        <path
          clipRule="evenodd"
          d="M249.655 423.939s24.053 31.896 24.631 38.32c.579 6.424-1.046 38.711 9.166 65.88 10.211 27.155 26.981 37.732 29.715 67.541 0 0 3.332-6.952-10.334-37.037-13.869-30.527-24.62-38.858-22.975-98.155l-30.203-36.536v-.013z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M286.082 501.628c2.1.677 4.2 1.273 6.313 1.788-5.597-.931-6.313-1.788-6.313-1.788z"
          fill={`url(#${id}-bf)`}
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M236.845 420.105c.695-2.284 1.962-5.572 3.493-8.033.77-1.237 1.57-2.206 2.353-2.751.755-.527 1.412-.615 2.051-.282.228.119.494.509.548 1.561l1.233 2.182c.099-.829.142-1.583.109-2.237-.055-1.11-.341-2.213-1.269-2.697-1.212-.633-2.41-.348-3.441.371-1.004.7-1.921 1.851-2.725 3.143-1.617 2.599-2.925 6.009-3.638 8.351a.673.673 0 001.286.392zm8.801-2.684c-.512 2.184-1.17 4.607-1.84 7.081h-.001c-.197.728-.396 1.461-.593 2.194-1.145 4.268-2.219 8.527-2.612 11.949-.196 1.713-.216 3.17-.01 4.292.207 1.127.619 1.805 1.185 2.141.605.359 1.305.412 2.147.164.858-.252 1.822-.807 2.87-1.605 2.098-1.596 4.361-4.027 6.581-6.442l.304-.33c1.253-1.365 2.494-2.716 3.666-3.863l.814 1.084c-1.106 1.093-2.299 2.391-3.547 3.749l-.247.269c-2.2 2.393-4.546 4.92-6.757 6.603-1.106.841-2.221 1.506-3.305 1.825-1.101.323-2.208.298-3.212-.298-1.043-.619-1.58-1.746-1.821-3.054-.241-1.313-.205-2.922-.003-4.688.406-3.536 1.507-7.889 2.65-12.145.199-.743.4-1.483.599-2.216v-.001c.789-2.909 1.547-5.703 2.073-8.119l1.059 1.41zm12.774 16.407l-.682-1.207a21.153 21.153 0 011.829-1.579c.909-.684 1.841-1.206 2.727-1.282.464-.039.922.042 1.34.287.413.242.74.616.996 1.083.217.396.382.926.513 1.534.082.381.155.809.218 1.279l-2.107-2.487-.008.01a1.075 1.075 0 00-.292-.259.881.881 0 00-.545-.108c-.491.042-1.166.364-2.034 1.017-.61.459-1.265 1.042-1.955 1.712zm6.008 8.611c.012 4.713-.184 10.533-.5 16.759-.688 13.576-1.944 29.045-2.849 39.098a.671.671 0 101.338.121c.906-10.061 2.164-25.55 2.853-39.151.278-5.473.464-10.648.497-15.043l-1.339-1.784z"
          fill="#134157"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M300.711 568.534l2.917-3.266.867 1.623-3.784 1.643z"
          fill={`url(#${id}-bg)`}
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M476.339 499.117l-5.825-.662s-.661 12.144-8.058 24.315l1.452-.006s9.067-11.587 12.431-23.647z"
          fill="#BBEFFE"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M366.591 556.356s5.406-9.232 8.077-22.957l22.474 1.908s-.182 14.091-3.971 24.338l-26.58-3.289zm78.396-15.671s-.142 1.305-.523 3.457l-.078.471a64.862 64.862 0 01-.435 2.22c-.092.404-.184.821-.277 1.265a85.792 85.792 0 01-2.145 7.807c-.265.822-.557 1.67-.876 2.518v.027a75.81 75.81 0 01-.971 2.532c-.067.161-.133.309-.2.471a39.87 39.87 0 01-.852 1.94l-17.121-1.353s.318-1.184.794-3.055c.317-1.306.714-2.948 1.123-4.764.554-2.503 1.147-5.329 1.592-8.06.145-.862.276-1.696.393-2.53.261-1.91.428-3.712.449-5.218 0 0 13.677.977 19.114 2.285l.013-.013zm34.345 8.123a88.292 88.292 0 01-.685 3.404c-.013.054-.026.121-.039.162-.159.686-.317 1.372-.476 2.045-.066.256-.118.498-.185.754-.462 1.83-.939 3.54-1.363 5.034-.146.458-.279.902-.398 1.319 0 0-.013.054-.013.068-.265.834-.491 1.575-.703 2.194-.027.094-.053.188-.093.269a158.111 158.111 0 01-.638 1.885l-15.329-.54c.427-.849.88-1.872 1.318-3.017.346-.889.692-1.845 1.051-2.828.983-2.827 1.938-5.924 2.693-8.481l.119-.445c.861-2.988 1.43-5.141 1.43-5.141 3.429.133 13.338 3.304 13.338 3.304l-.027.014zm-205.046-86.562l5.572-1.772-45.953-60.427-1.048.341s38.372 52.905 41.429 61.858z"
          fill="#0C3A53"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M383.968 538.819l-2.488-.137a29.8 29.8 0 012.394.137h.094z"
          fill={`url(#${id}-bh)`}
          fillRule="evenodd"
          opacity="0.2"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M367.067 555.491c1.17-2.206 4.258-8.484 6.504-17.23l7.074.41h.054l2.393.138.094-.001h.068l7.934.464.013.013-1.297 17.443-6.993-.373-15.844-.864z"
          fill="#3D4C85"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M387.162 537.542c-3.826 1.307-5.95 4.569-6.546 9.708-.597 5.138 2.994 11.724 10.386 11.169 7.701-.584 9.371-9.317 7.761-15.105-1.611-5.774-6.982-7.338-11.601-5.772z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M397.441 548.886a8.626 8.626 0 01-.131.82c-.368 1.911-1.222 3.568-2.402 4.299-3.768 2.329-8.709.561-9.401-3.993a9.823 9.823 0 01-.089-1.976c.012-.269.038-.552.077-.821 0-.013 0-.027.014-.054.509-3.592 3.011-6.278 5.565-6.53 5.187-.493 6.848 4.219 6.367 8.255z"
          fill="#0C3A53"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M440.903 544.534l-.089 1.157-.089 1.17-.649 8.822-.203 2.73-.115 1.52-3.738-.199-2.004-.113-.417-.025-11.296-.624c.317-1.306.713-2.948 1.123-4.764.554-2.503 1.147-5.329 1.592-8.06.145-.862.275-1.696.393-2.53l6.172.351.054-.001 2.112.126h.08l.054-.001.511.039.013-.001 2.354.138.228-.001.431.039 3.442.201.041.026z"
          fill="#3D4C85"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M436.662 542.993c-3.384 1.143-5.254 4.042-5.786 8.575-.518 4.533 2.652 10.354 9.171 9.87 6.801-.513 8.274-8.223 6.854-13.339-1.42-5.09-6.171-6.481-10.239-5.106z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M445.738 553.011a6.772 6.772 0 01-.118.726c-.329 1.696-1.075 3.151-2.121 3.801-3.326 2.044-7.702.489-8.297-3.528a7.652 7.652 0 01-.075-1.748c.013-.242.039-.484.065-.726a.088.088 0 01.013-.054c.443-3.175 2.665-5.537 4.91-5.761 4.582-.437 6.038 3.725 5.623 7.29z"
          fill="#0C3A53"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M474.812 551.247l-.077.888-.064.901-.509 6.818-.152 2.098-.089 1.184-2.878-.149-1.533-.088-.336.001-8.459-.475c.346-.888.692-1.844 1.05-2.827.983-2.828 1.938-5.924 2.694-8.482l.119-.444 3.053.175h.053l1.628.087h.107l.39.025h.014l1.815.1.188-.001.31.026h.013l2.663.15v.013z"
          fill="#3D4C85"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M471.526 550.051c-2.604.885-4.06 3.11-4.462 6.607-.402 3.497 2.037 7.991 7.077 7.606 5.241-.398 6.386-6.346 5.28-10.294-1.092-3.934-4.753-4.994-7.895-3.932v.013z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M478.523 557.779a6.958 6.958 0 01-.091.551c-.25 1.306-.837 2.437-1.628 2.925-2.575 1.584-5.941.388-6.398-2.729a6.459 6.459 0 01-.059-1.345 3.639 3.639 0 01.051-.551v-.04c.352-2.449 2.052-4.271 3.786-4.44 3.534-.337 4.664 2.871 4.339 5.629z"
          fill="#0C3A53"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M367.223 556.301s18.728 22.319 27.869 21.971c9.141-.348-9.75-19.803-9.75-19.803l-18.119-2.168zm56.183 5.893s5.803 14.671 9.888 14.183c4.085-.488 3.399-13.109 3.399-13.109l-13.287-1.074zm43.441 16.299c-4.948.075-6.119-13.082-6.119-13.082l11.793.461s-.727 12.547-5.674 12.621z"
          fill="#44A8AA"
          fillRule="evenodd"
          opacity="0.6"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M265.941 487.885c.076-.902.163-1.807.258-2.713a98.787 98.787 0 016.576-3.857 1.063 1.063 0 11.993 1.879c-1.536.811-4.882 2.7-7.827 4.691zm.292 21.375c-.1-.788-.19-1.577-.269-2.367a98.811 98.811 0 016.902-4.067 1.063 1.063 0 01.993 1.878c-1.501.793-4.731 2.615-7.626 4.556zm6.738 23.354a76.64 76.64 0 01-.882-1.958 98.694 98.694 0 016.257-3.653 1.062 1.062 0 11.993 1.878 97.312 97.312 0 00-6.368 3.733zm14.547 21.912c-.477-.547-.946-1.094-1.405-1.64a87.351 87.351 0 013.091-1.729 1.063 1.063 0 11.993 1.879c-.636.335-1.581.855-2.679 1.49z"
          fill="#FFD0BA"
          fillRule="evenodd"
          opacity="0.4"
        />
        <path
          d="M474.045 539.241l-6.639 8.674a10.08 10.08 0 00-1.081 10.494l6.115 12.718 1.458-7.006 8.371 1.844-3.013-5.914 25.25-4.903-24.438-4.576 5.753-4.831-12.238-.545.462-5.955z"
          fill={`url(#${id}-bi)`}
        />
        <path
          d="M470.697 572.953c.445-2.614-1.11-2.717-1.943-2.441-2.161-1.471-3.684-.387-4.176.338.271-1.204-1.25-2.874-2.045-3.558 1.743-4.155-1.937-7.104-3.995-8.058 2.554-3.121.59-6.686-.712-8.079 1.29-1.522.649-3.769.167-4.703 2.638-.618 3.105-3.09 3.009-4.248.626.786 1.655-.287 2.091-.922.972 1.221 2.056.634 2.477.189.323.684 1.255 1.826 2.394.919 1.139-.907.573-2.341.148-2.944 1.095-3.132-2.12-5.236-3.865-5.897-4.345-3.453-7.296.16-8.228 2.398-4.988.915-5.31 4.949-4.847 6.852-5.628 3.285-2.405 10.058-.09 13.035-1.451 2.352-.558 4.377.069 5.096-3.89 3.63-.268 8.08 2.029 9.852-.028 5.473 4.608 6.69 6.929 6.614 2.816 4.538 7.443.998 9.404-1.34 2.632-.367 1.886-2.222 1.184-3.103z"
          fill="#fff"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M528.648 556.535a8.61 8.61 0 11-15.979-4.455 8.61 8.61 0 0115.979 4.455z"
          fill="#093046"
        />
        <path
          d="M1981.14 256.359l-15.15 41.923h120.76l-15.14-41.923h-90.47z"
          fill="#4D0D54"
        />
        <path
          d="M1930.08 312.09v413.279h143.32V312.09l-122.98-15.405-20.34 15.405z"
          fill={`url(#${id}-bj)`}
        />
        <path d="M2010.09 243.32h29.803v53.127h-29.803z" fill="#4D0D54" />
        <path
          d="M2010.09 243.32h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path d="M2006.53 292.235h36.93v4.211h-36.93z" fill="#DFBFFF" />
        <path
          d="M2010.09 263.541h29.81m-14.58 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M2024.82 242.643v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path
          d="M1953.51 295.689v413.279h143.32V295.689h-143.32z"
          fill={`url(#${id}-bk)`}
        />
        <path
          d="M1953.51 647.612v38.632h143.32v-38.632h-143.32z"
          fill="#DFBFFF"
        />
        <path
          d="M1947.97 295.689v27.246h154.4v-27.246h-154.4z"
          fill="#CD9EFB"
        />
        <path d="M1942.24 303.639v5.29h165.87v-5.29h-165.87z" fill="#fff" />
        <path
          d="M1967.92 363.534h28.029v49.965h-28.029z"
          fill={`url(#${id}-bl)`}
        />
        <path
          d="M1967.92 363.534h28.029v49.965h-28.029z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M1981.76 362.954v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M1964.56 410.962h34.732v3.961h-34.732z" fill="#DFBFFF" />
        <path
          d="M1967.92 466.059h28.029v49.965h-28.029z"
          fill={`url(#${id}-bm)`}
        />
        <path
          d="M1967.92 466.059h28.029v49.965h-28.029z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M1981.76 465.48v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M1964.56 513.488h34.732v3.961h-34.732z" fill="#DFBFFF" />
        <path
          d="M1964.29 579.37h29.803v53.127h-29.803z"
          fill={`url(#${id}-bn)`}
        />
        <path
          d="M1964.29 579.37h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M1964.29 599.591h29.81m-14.58 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path d="M1960.73 629.8h36.93v4.211h-36.93z" fill="#DFBFFF" />
        <path
          d="M1979.02 579.45v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path
          d="M2011.16 363.534h28.029v49.965h-28.029z"
          fill={`url(#${id}-bo)`}
        />
        <path
          d="M2011.16 363.534h28.029v49.965h-28.029z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M2025 362.954v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M2007.8 410.962h34.732v3.961H2007.8z" fill="#DFBFFF" />
        <path
          d="M2011.16 466.059h28.029v49.965h-28.029z"
          fill={`url(#${id}-bp)`}
        />
        <path
          d="M2011.16 466.059h28.029v49.965h-28.029z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M2025 465.48v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M2007.8 513.488h34.732v3.961H2007.8z" fill="#DFBFFF" />
        <path
          d="M2010.27 579.37h29.803v53.127h-29.803z"
          fill={`url(#${id}-bq)`}
        />
        <path
          d="M2010.27 579.37h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M2010.27 599.591h29.8m-14.57 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path d="M2006.71 629.8h36.93v4.211h-36.93z" fill="#DFBFFF" />
        <path
          d="M2024.99 579.45v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path
          d="M2054.4 363.534h28.029v49.965H2054.4z"
          fill={`url(#${id}-br)`}
        />
        <path
          d="M2054.4 363.534h28.029v49.965H2054.4z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M2068.24 362.954v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M2051.05 410.962h34.732v3.961h-34.732z" fill="#DFBFFF" />
        <path
          d="M2054.4 466.059h28.029v49.965H2054.4z"
          fill={`url(#${id}-bs)`}
        />
        <path
          d="M2054.4 466.059h28.029v49.965H2054.4z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.848"
        />
        <path
          d="M2068.24 465.48v-11.483"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.56"
        />
        <path d="M2051.05 513.488h34.732v3.961h-34.732z" fill="#DFBFFF" />
        <path d="M2055.55 579.369h27.919v110.536h-27.919z" fill="#4D0D54" />
        <path
          d="M2053.45 689.622h32.122v6.661h-32.122zm-3.5 6.662h39.11v6.661h-39.11zm-4.28 6.661h47.685v6.661h-47.685z"
          fill="#fff"
        />
        <path
          d="M2055.55 598.055h27.91m-14.77-18.704v18.579"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M2168.35 361.087v320.049h154.81V337.657h-136.71l-18.1 23.43z"
          fill={`url(#${id}-bt)`}
        />
        <path
          d="M2183.97 337.657v343.479h154.81V337.657h-154.81z"
          fill={`url(#${id}-bu)`}
        />
        <path
          d="M2190.65 315.013v22.644h141.45v-22.644h-141.45z"
          fill="#1984C0"
        />
        <path
          d="M2177.98 337.657v22.644h166.79v-22.644h-166.79z"
          fill="#70E7FF"
        />
        <path
          d="M2244.81 459.605h32.823v59.207h-32.823z"
          fill={`url(#${id}-bv)`}
        />
        <path
          d="M2244.81 459.605h32.823v59.207h-32.823z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M2242.72 516.146h36.986v4.058h-36.986z" fill="#33CBE9" />
        <circle cx="2261.37" cy="315.013" fill="#70E7FF" r="27.968" />
        <circle cx="2261.37" cy="315.013" fill="#1889C2" r="15.14" />
        <path
          d="M2261.29 299.972v30.082m15.22-14.797h-30.08"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M2196.73 390.665h34.033v34.033h-34.033z"
          fill={`url(#${id}-bw)`}
        />
        <path d="M2213.22 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M2194.57 421.933h38.349v4.207h-38.349z" fill="#33CBE9" />
        <path d="M2195.99 407.414h34.46" stroke="#fff" strokeWidth="2.104" />
        <path
          d="M2244.25 390.665h34.033v34.033h-34.033z"
          fill={`url(#${id}-bx)`}
        />
        <path d="M2260.74 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M2242.1 421.933h38.349v4.207H2242.1z" fill="#33CBE9" />
        <path d="M2243.51 407.414h34.46" stroke="#fff" strokeWidth="2.104" />
        <path
          d="M2242.92 568.639h36.745v66.28h-36.745z"
          fill={`url(#${id}-by)`}
        />
        <path
          d="M2242.92 568.639h36.745v66.28h-36.745z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path d="M2260.72 590.178v45.474" stroke="#fff" strokeWidth="2.271" />
        <path d="M2240.59 631.934h41.404v4.542h-41.404z" fill="#33CBE9" />
        <path d="M2242.12 590.178h37.21" stroke="#fff" strokeWidth="2.271" />
        <path
          d="M2198.46 459.605h32.823v59.207h-32.823z"
          fill={`url(#${id}-bz)`}
        />
        <path
          d="M2198.46 459.605h32.823v59.207h-32.823z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M2196.38 516.146h36.986v4.058h-36.986z" fill="#33CBE9" />
        <path
          d="M2191.4 568.996h36.031v65.567H2191.4z"
          fill="#D9D9D9"
          stroke="#000"
          strokeWidth="0.714"
        />
        <path d="M2208.84 590.178v45.474" stroke="#000" strokeWidth="2.142" />
        <path
          d="M2189.07 632.291h40.69v3.828h-40.69z"
          fill="#D9D9D9"
          stroke="#000"
          strokeWidth="0.714"
        />
        <path d="M2190.24 590.178h37.21" stroke="#000" strokeWidth="2.142" />
        <path
          d="M2288.26 459.605h32.823v59.207h-32.823z"
          fill={`url(#${id}-bA)`}
        />
        <path
          d="M2288.26 459.605h32.823v59.207h-32.823z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M2286.17 516.146h36.986v4.058h-36.986z" fill="#33CBE9" />
        <path
          d="M2291.56 568.639h36.745v66.28h-36.745z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M2291.56 568.639h36.745v66.28h-36.745z"
          fill={`url(#${id}-bB)`}
        />
        <path d="M2309.36 590.178v45.474" stroke="#fff" strokeWidth="2.271" />
        <path d="M2289.23 631.934h41.404v4.542h-41.404z" fill="#33CBE9" />
        <path d="M2290.76 590.178h37.21" stroke="#fff" strokeWidth="2.271" />
        <path
          d="M2291.78 390.665h34.033v34.033h-34.033z"
          fill={`url(#${id}-bC)`}
        />
        <path d="M2308.26 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M2289.62 421.933h38.349v4.207h-38.349z" fill="#33CBE9" />
        <path d="M2291.03 407.414h34.47" stroke="#fff" strokeWidth="2.104" />
        <circle cx="2209.56" cy="559.709" fill="#33CBE9" r="18.096" />
        <path d="M2188.74 559.708h41.645v87.381h-41.645z" fill="#33CBE9" />
        <path d="M2184.65 559.708h49.826v6.321h-49.826z" fill="#fff" />
        <path
          d="M2197.74 584.138c0-6.707 5.44-12.143 12.15-12.143 6.7 0 12.14 5.436 12.14 12.143v65.443h-24.29v-65.443z"
          fill="#4D0D54"
          stroke="#000"
          strokeWidth="0.757"
        />
        <path d="M2188.71 646.306h60.08v15.483h-60.08z" fill="#fff" />
        <path d="M2188.71 658.411h74.621v12.036h-74.621z" fill="#fff" />
        <path d="M2188.71 669.457h85.661v11.679h-85.661z" fill="#fff" />
        <path
          d="M2407.8 345.526v8.42h160.53v-8.42c-24.19-9.723-39.89-33.323-39.53-59.384l.2-14.183c.27-18.924-15-34.408-33.92-34.408h-11.77c-19.08 0-34.6 15.367-34.8 34.448l-.14 14.141c-.26 26.179-16.28 49.619-40.57 59.386z"
          fill="#F16FCE"
        />
        <path d="M2400.82 344.168h173.465v9.513H2400.82z" fill="#fff" />
        <path
          d="M2400.62 353.945V702.01h145.48V353.945h-145.48z"
          fill={`url(#${id}-bD)`}
        />
        <path
          clipRule="evenodd"
          d="M2456.89 353.946V279.73h61.33v74.216h42.08V702.01h-145.49V353.946h42.08z"
          fill={`url(#${id}-bE)`}
          fillRule="evenodd"
        />
        <path
          d="M2427.28 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-bF)`}
        />
        <path
          d="M2427.28 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M2425.41 532.747h33.367v4.126h-33.367z" fill="#F16FCE" />
        <path
          d="M2471.73 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-bG)`}
        />
        <path
          d="M2471.73 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M2469.85 532.747h33.367v4.126h-33.367z" fill="#F16FCE" />
        <path
          d="M2516.17 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-bH)`}
        />
        <path
          d="M2516.17 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M2514.3 532.747h33.367v4.126H2514.3z" fill="#F16FCE" />
        <path d="M2468.17 295.534v47.193h36.73v-47.193h-36.73z" fill="#fff" />
        <path d="M2471.75 300.135v37.99h29.57v-37.99h-29.57z" fill="#4D0D54" />
        <path
          d="M2429.87 392.922h27.074v48.262h-27.074z"
          fill={`url(#${id}-bI)`}
        />
        <path
          d="M2429.87 392.922h27.074v48.262h-27.074z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M2443.25 392.362v-11.091"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M2426.64 438.734h33.548v3.826h-33.548z" fill="#F16FCE" />
        <path
          d="M2473.2 392.921h27.074v48.262H2473.2z"
          fill={`url(#${id}-bJ)`}
        />
        <path
          d="M2473.2 392.921h27.074v48.262H2473.2z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M2486.58 392.362V381.27"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M2469.97 438.733h33.548v3.826h-33.548z" fill="#F16FCE" />
        <path
          d="M2471.86 577.024h29.803v53.127h-29.803z"
          fill={`url(#${id}-bK)`}
        />
        <path
          d="M2471.86 577.024h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M2471.86 597.245h29.8m-14.57 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M2486.58 577.105v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path d="M2468.3 627.455h36.93v4.211h-36.93z" fill="#F16FCE" />
        <path
          d="M2521.22 392.922h27.074v48.262h-27.074z"
          fill={`url(#${id}-bL)`}
        />
        <path
          d="M2521.22 392.922h27.074v48.262h-27.074z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M2534.59 392.362v-11.091"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M2517.98 438.734h33.548v3.826h-33.548z" fill="#F16FCE" />
        <path
          d="M2517.84 577.024h29.803v53.127h-29.803z"
          fill={`url(#${id}-bM)`}
        />
        <path
          d="M2517.84 577.024h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M2517.84 597.245h29.8m-14.57 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M2532.56 577.105v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path d="M2514.27 627.455h36.93v4.211h-36.93z" fill="#F16FCE" />
        <path d="M2440.23 265.809h94.656v9.513h-94.656z" fill="#fff" />
        <path
          d="M2423.42 605.982c0-10.619 8.61-19.226 19.23-19.226 10.62 0 19.23 8.607 19.23 19.226v62.096h-38.46v-62.096z"
          fill="#F16FCE"
        />
        <path
          d="M2440.48 583.191c0-1.199.97-2.17 2.17-2.17s2.17.971 2.17 2.17v9.299h-4.34v-9.299z"
          fill="#F16FCE"
        />
        <path
          d="M2426.58 606.467c0-8.877 7.19-16.074 16.07-16.074 8.88 0 16.07 7.197 16.07 16.074v51.917h-32.14v-51.917z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M2423.42 658.384h-9.63v43.626h9.63v-43.626zm38.46 43.626h97.4v-43.626h-97.4v43.626z"
          fill="#F16FCE"
          fillRule="evenodd"
        />
        <path d="M2423.42 667.963h38.452v34.047h-38.452z" fill="#fff" />
        <path
          d="M799.588 684.654c166.033 43.931-133.233 115.961-247.86 167.247l1640.392 40.69 48.83-282.846-1648.113-31.717c-70.806 2.566-433.093 2.735-405.597 23.685 34.37 26.186 513.875 43.175 612.348 82.941z"
          fill="#6098B1"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M751.621 720.184c28.186 19.844-142.245 98.623-440.415 98.623S5.327 750.028 14.146 722.42c8.818-27.608 102.711-57.649 297.06-57.649s277.616 8.296 298.17 18.219c20.554 9.922-34.352 20.872-33.968 25.155.339 3.813 148.026-7.804 176.213 12.039z"
          fill="#6098B1"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M825.195 668.103c166.032 43.932-126.465 158.476-311.697 169.951l1678.622 20.513 48.83-282.846H585.982c-70.805 2.566-356.653 1.739-329.157 22.688 34.37 26.187 469.896 29.929 568.37 69.694z"
          fill={`url(#${id}-bN)`}
        />
        <path
          d="M2662.72 476.297c-.24-1.919-2.21-3.787-3.16-4.481-.61-3.077-3.44-4.185-4.79-4.354l1.8-.988c-7.39-.593-10.01-4.644-10.84-5.83-.82-1.185-3.2-6.718-7.82-6.867-4.62-.148-5.84 1.828-6.86 4.101-1.02 2.272-2.52 3.952-2.77 5.731-.24 1.778.78 1.778.78 2.371s-1.65 2.075-1.65 2.865c0 .633.91 1.318 1.36 1.581-.36.346-1.13 1.305-1.36 2.372-.24 1.067 1 2.223 1.65 2.668.16 1.663.59 4.999 1.02 5.039.43.039 2.67-1.301 3.74-1.976-1.67 1.264-3.35 7.015-3.98 9.732l-4.43 1.828.39-1.828c-1.32.672-2.95 3.277-3.59 4.496l-9.68 12.153-2.96 2.618c-.2 1.285-.36 4.288.53 6.027.9 1.739 3.91 1.614 5.3 1.334.65-.741 1.95-2.371 1.95-2.964v-3.409c2.17-1.531 6.61-4.614 7-4.693.48-.099 5-1.285 6.07-1.63.86-.277 3.73-4.463 5.06-6.522l.87 6.126-5.15 5.978h1.99c-2.06 1.225-5.2 5.747-6.51 7.855l1.89-.741c-1.18 1.878-3.68 5.958-4.22 7.263-.55 1.304-.07 11.84.24 16.945-2.19 1.976-6.76 5.928-7.54 5.928-.97 0-3.74-2.371-5.44-2.371-1.7 0-2.14 1.68-2.14 2.371 0 .553 2.56 2.569 3.84 3.508.71.428 2.73 1.294 5.1 1.334 2.97.049 11.87 2.47 13.71 1.729 1.85-.741 1.51-6.521 1.46-8.646-.05-2.124 3.99-8.102 4.23-9.337.19-.988-.5-2.915-.87-3.755h1.94c-.97-.158-1.7-2.601-1.94-3.804 3.85-2.45 5.07-4.742 5.2-5.582l1.16 1.531c-.11-1.739 1.06-4.578 1.66-5.78 2.12 2.026 6.7 6.828 8.07 9.831 1.7 3.755 4.56 4.545 6.46 6.373 1.52 1.463 4.29 4.891 5.49 6.423l.34 4.347-3.45 3.014-4.28 1.037c-2.47 2.717-2.47 4.15-.97 5.089 1.21.751 2.81-.84 3.45-1.729-.89 1.699-.01 2.816.54 3.162h7.92c.54-.247 1.85-.939 2.82-1.73.97-.79 4.29-3.096 5.83-4.149.6-.165 2.05-1.068 3.02-3.36 1.21-2.865-3.02-5.187-4.43-6.225-1.41-1.037-1.79-4.891-1.79-6.323 0-1.146-1.24-2.652-1.85-3.261h1.85c-.73 0-3.8-2.816-4.72-4.792-.74-1.581-2.61-2.273-3.45-2.421-3.03-5.138-5.97-17.851-7.06-23.565l.98.988c-.5-1.146-.86-4.965-.98-6.731l3.48 2.399c-1.18 4.291 7.45 15.525 7.82 16.156.3.505 1.24 2.946 1.68 4.103 1.07.526 3.82 1.451 6.21.946 2.98-.631 2.3-4.354 2.3-5.049 0-.555-1.54-1.704-2.3-2.209h-.87l-2.11-.504c-.31-3.703-1.13-11.916-1.93-15.147-.99-4.039-5.15-5.743-4.72-5.743.35 0 1.68-.337 2.3-.505-2.79 0-7.58-7.953-7.89-10.351z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M971.382 681.116c45.858 43.868-167.817 125.58-266.686 153.829l63.531 6.061 1426.183 4.332 22.26-128.981c-463.23-131.935-897.98-140.185-897.98-140.185l-38-.451H585.982c-14.462.524-37.896.907-65.799 1.362-50.36.822-115.277 1.882-168.28 4.44-18.077 2.83-25.74 5.512-16.23 7.75 11.446 2.693 56.899 5.932 118.283 10.306 165.865 11.818 475.584 41.514 517.426 81.537z"
          fill="#48A3CD"
          fillRule="evenodd"
        />
        <path
          d="M1010.57 662.066c-39.131-.524-83.6-2.449-129.015-7.041 0 0 57.042-4.998 57.92-6.735.333-.665.737-1.408 1.196-2.199 2.881-4.849 13.34-11.288 21.73-10.617 12.021.959 18.427 15.873 20.516 18.753l.01-.001c.218.306.328.464.328.464s3.598-11.523 11.147-.527l.084.111s.058-.188.177-.535c1.627-4.889 14.937-42.109 39.917-39.467 11.28 1.18 21.21 14.568 27.87 26.337a151.815 151.815 0 017.73 15.839c.2.489.38.921.51 1.257.28.693.42 1.068.42 1.068s-.06-.304-.13-.8c-.38-2.391-1.01-9.276 4.4-8.789 5.52.504 10.9 7.661 12.44 9.873.27.411.43.643.43.643s.47-.147 1.36-.366c2.97-.749 10.56-2.38 20.57-2.436 12.98-.084 36.15 1.578 36.15 1.578s-21.35 1.735-55.9 2.845c-1.64.056-3.31.096-5 .149-1.66.049-3.34.091-5.06.136-6.35.17-13.06.304-20.1.416-15.18.228-31.88.285-49.7.044z"
          fill="#fff"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M3350.7 878.833c98.87-28.248 45.86 43.868 0 0-41.84-40.023 165.87 11.818 0 0 11.45 2.693-61.38-4.374 0 0-26.57-6.253-343.55-266.364-519.3-302.661h423.21s355.75-25.782 1221.89 14.35c866.13 40.132 1963.65 422.878 1963.65 422.878V852.353l-3025.92 32.542-63.53-6.062z"
          fill={`url(#${id}-bO)`}
        />
        <path
          d="M4685.08 149.498v47.117"
          stroke="#372B76"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4.076"
        />
        <path
          d="M4721.25 169.055a4.176 4.176 0 018.35 0v6.741h-8.35v-6.741z"
          fill={`url(#${id}-bP)`}
        />
        <path
          d="M3790.53-45.728l931.44 212.415v9.136l-931.44 67.168v-288.72z"
          fill={`url(#${id}-bQ)`}
        />
        <path
          d="M4705.91 176.994h11.78m25.45 0h-10.45m0 0v14.059m0-14.059h-15m0 0v14.059"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.966"
        />
        <path
          d="M4763.52 149.498v47.117m-53.87-49.834v47.116m32.01-47.116v47.116"
          stroke="#372B76"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4.076"
        />
        <path
          d="M4681.79 194.07v28.517h84.45V194.07l-26.13-5.435h-32.08l-26.24 5.435z"
          fill="#372B76"
        />
        <path
          d="M4671.22 242.862l-47.67 427.445c75.59 15.575 155.73 6.49 186.36 0l-35.15-427.445 23.79-8.286v-11.492l-75.43-6.649-75.43 6.649v8.704l23.53 11.074z"
          fill={`url(#${id}-bR)`}
        />
        <path
          clipRule="evenodd"
          d="M4701.98 192.318c0-.819-.67-1.483-1.48-1.483-.82 0-1.49.664-1.49 1.483v4.545c-.06.081-.12.169-.17.264-13.21 4.597-30.4 4.537-38.68 3.817v-3.51c0-.819-.67-1.483-1.49-1.483s-1.48.664-1.48 1.483v25.093c0 .819.66 1.483 1.48 1.483s1.49-.664 1.49-1.483v-7.737c8.41.701 25.33.751 38.85-3.719v6.34a1.485 1.485 0 002.97 0v-6.849c5.07 1.027 12.53 2.101 20.67 2.447 8.61.365 18.08-.078 26.33-2.31v7.149c0 .819.67 1.483 1.49 1.483s1.48-.664 1.48-1.483v-6.957c13.61 4.651 30.87 4.609 39.39 3.898v7.738c0 .819.66 1.482 1.48 1.482s1.49-.663 1.49-1.482v-25.093c0-.819-.67-1.483-1.49-1.483s-1.48.664-1.48 1.483v3.509c-8.43.733-26.08.782-39.39-4.066v-4.122a1.48 1.48 0 00-1.48-1.483c-.82 0-1.49.664-1.49 1.483v3.996c-8 2.303-17.45 2.797-26.2 2.425-8.31-.352-15.88-1.481-20.8-2.511v-4.347zm89.36 19.495v-7.893c-8.52.711-25.78.752-39.39-3.898v7.724c13.31 4.849 30.96 4.8 39.39 4.067zm-92.5-3.816c-13.22 4.596-30.4 4.536-38.68 3.816v-7.893c8.41.702 25.33.752 38.85-3.718v7.53c-.06.081-.12.17-.17.265zm23.94 2.048c-8.31-.352-15.88-1.481-20.8-2.511v-7.841c5.07 1.027 12.53 2.101 20.67 2.447 8.61.365 18.08-.078 26.33-2.31v7.79c-8 2.303-17.45 2.797-26.2 2.425z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M4777.99 282.198h-111.15l-6.28 56.3h122.06l-4.63-56.3zm12.15 147.725h-139.78l-6.28 56.3h150.69l-4.63-56.3zm10.32 125.509h-164.1l-4.25 38.109v18.191h172.98l-4.63-56.3z"
          fill="#BAD7FF"
          fillRule="evenodd"
          style={{ mixBlendMode: "hard-light" }}
        />
        <path
          clipRule="evenodd"
          d="M4703.05 218.205l-55.36 4.879v8.704l16.5 7.763c4.2 1.98 6.69 6.418 6.17 11.04l-46.81 419.716c16.61 3.422 33.43 5.654 49.91 6.984l29.59-459.086z"
          fill="#4AABFF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M4698.92 282.198h-32.08l-6.28 56.3h34.73l3.63-56.3zm-9.52 147.725h-39.04l-6.28 56.3h41.69l3.63-56.3zm-8.09 125.509h-44.94l-6.28 56.3h47.59l3.63-56.3z"
          fill="#fff"
          fillRule="evenodd"
          style={{ mixBlendMode: "hard-light" }}
        />
        <path
          clipRule="evenodd"
          d="M4753.56 677.545l-8.51-459.179 53.5 4.716v11.492l-13.86 4.827a13.58 13.58 0 00-9.07 13.944l34.29 416.96c-12.13 2.571-32.04 5.549-56.35 7.24z"
          fill="#2165C3"
          fillRule="evenodd"
        />
        <path
          d="M4647.69 236.414l59.83-5.273c10.38-.916 20.82-.916 31.21 0l59.82 5.273"
          stroke="#372B76"
          strokeLinecap="round"
          strokeWidth="6.665"
        />
        <path
          clipRule="evenodd"
          d="M4800.46 555.432l4.63 56.3h-52.75l-1.04-56.3h49.16zm-10.32-125.509l4.63 56.3h-44.75l-1.05-56.3h41.17zm-12.15-147.725l4.63 56.3h-35.34l-1.05-56.3h31.76z"
          fill="#87B1EB"
          fillRule="evenodd"
          style={{ mixBlendMode: "hard-light" }}
        />
        <path
          d="M4769.26 277.005l-12.33-.651.66 30.453 12.34.991-.67-30.793zm5.32 119.528l-12.33-.651.86 39.432 12.34.99-.87-39.771zm11.08 137.579l-17.58.472 1.23 56.424 17.59.014-1.24-56.91zm-63.79 23.198l-17.58.471-.01 35.448 17.59.014V557.31z"
          fill="#372B76"
        />
        <path
          clipRule="evenodd"
          d="M4725.04 116.107c-1.7 0-3.07 1.373-3.07 3.067v7.346l-45.22 24.721 33.2-4.709h30.28l32.53 4.709-44.66-24.412c0-.049.01-.098.01-.147v-7.508a3.072 3.072 0 00-3.07-3.067z"
          fill="#372B76"
          fillRule="evenodd"
        />
        <path
          d="M4540.1 659.347l-5.23 19.425 74.75 13.156 73.79-4.908 47-27.673-68.62-51.537-26.35 2.659-21.27 10.394-10.16 18.614-11.27 1.302-31.6 11.192v4.021l-21.04 3.355z"
          fill="#392F6C"
        />
        <path
          d="M4661.97 685.948v18.618h81.55l17.97 19.125 29.14 6.615 145.93-6.615 20.69-67.447-85.65-48.434-90.43 16.683-15.26 27.634-73.83 14.024-30.11 19.797z"
          fill="#392F6C"
        />
        <path
          clipRule="evenodd"
          d="M4748.01 696.208l15.16 19.52 84.69-103.538-66.69 12.303-15.26 27.634-73.83 14.024-29.94 19.689 71.3-15.86 31.89-14.606-17.32 40.834zm69.95-38.162l53.61-50.231.03-.005.29.166-53.24 90.027 29.22-18.623 2.15 1.347-43.87 35.735-15.63 13.818-19.48-4.422-5.52-7.107 52.44-60.705z"
          fill={`url(#${id}-bS)`}
          fillRule="evenodd"
        />
        <path
          d="M4661.79 609.477l-21.8 12.608-21.14 22.67h-9.27l-27.52 7.085-20.92.728v-.079l1.81-1.159 29.79-10.551 11.27-1.302 10.71-19.687 20.86-10.313 26.21-1.667v1.667z"
          fill={`url(#${id}-bT)`}
        />
        <path
          d="M4590.86 662.532l2.83-2.478-32.58-4.15-20.96 3.402-3.45 7.65 18.94-6.902 35.22 2.478z"
          fill={`url(#${id}-bU)`}
        />
        <path
          d="M4190 661.629l235.22-230.258 41.08 13.394-64.47 328.663L4190 661.629z"
          fill={`url(#${id}-bV)`}
        />
        <path
          clipRule="evenodd"
          d="M4494.58 445.456h-4.92v183.115c-.62.078-1.23.187-1.84.325a2.703 2.703 0 00-2.09 2.634v42.42c0 .973.65 1.825 1.59 2.073 3 .789 6.15.816 9.16.077l.29-.072a2.282 2.282 0 001.74-2.214v-42.111c0-1.357-.95-2.529-2.27-2.811l-.27-.056c-.46-.099-.92-.18-1.39-.243V445.456z"
          fill={`url(#${id}-bW)`}
          fillRule="evenodd"
        />
        <path d="M4488.68 460.477h6.885v44.259h-6.885z" fill="#0B548E" />
        <path
          d="M4456.98 445.376l-26.17-8.088a10.742 10.742 0 01-6.24-5.087l43.94 12.175a15.354 15.354 0 01-11.53 1z"
          fill="#FFD168"
        />
        <path
          d="M4490.19 446.991l-59.92-18.802"
          stroke="#F4F2FA"
          strokeWidth="2.611"
        />
        <rect
          fill="#0B548E"
          height="10.655"
          rx="5.327"
          transform="rotate(17.158 4419.34 419.436)"
          width="61.537"
          x="4419.34"
          y="419.436"
        />
        <path
          d="M2859.21 876.471c62.44-28.744 28.97 44.638 0 0-26.42-40.725 104.75 12.026 0 0 7.23 2.741-38.76-4.45 0 0-16.78-6.363-216.96-271.039-327.95-307.972l29.05-17.041s873.31-9.194 1420.29 31.642c546.98 40.837 1711.43 430.3 1711.43 430.3l-691.76-163.874-2100.93 33.113-40.13-6.168z"
          fill="#4E4288"
        />
        <path
          clipRule="evenodd"
          d="M3361.87 556.583c-.01.072-.02.147-.02.224 0 .552.45 1 1 1 525.28 0 1164.41 178.901 1390.1 257.924a1.01 1.01 0 001.28-.614c.18-.521-.1-1.091-.62-1.274-203.69-71.322-744.06-223.986-1233.79-253.162-52.73-1.595-105.61-2.95-157.95-4.098zm190.59 5.118c22.08.711 44.1 1.466 66.03 2.267 476.38 35.883 988.15 180.908 1185.12 249.875.52.183.8.753.62 1.274a1.01 1.01 0 01-1.28.614c-206.01-72.135-756.54-227.494-1250.49-254.03z"
          fill="#F1953E"
          fillRule="evenodd"
        />
        <path
          d="M3735.13 496.131h4.792v181.41h-4.792z"
          fill={`url(#${id}-bX)`}
          transform="rotate(-8.39 3735.13 496.131)"
        />
        <path
          d="M3723.22 430.7c1.48-4.066 6.57-4.817 9.17-1.352l52.27 69.852c2.59 3.465.74 8.547-3.34 9.148l-82.15 12.116c-4.07.601-7.31-3.73-5.83-7.796l29.88-81.968z"
          fill={`url(#${id}-bY)`}
        />
        <path
          d="M3725.52 440.344c1.2-3.302 5.34-3.913 7.45-1.098l42.46 56.742c2.1 2.815.6 6.943-2.71 7.432l-66.73 9.842c-3.31.488-5.95-3.03-4.74-6.333l24.27-66.585z"
          stroke="#4D0D54"
          strokeWidth="3.714"
        />
        <path
          d="M3729.99 460.666a2.529 2.529 0 115-.738l3.07 27.133a1.608 1.608 0 01-3.18.47l-4.89-26.865z"
          fill="#4D0D54"
        />
        <circle
          cx="3737.56"
          cy="494.672"
          fill="#4D0D54"
          r="2.615"
          transform="rotate(-8.39 3737.56 494.672)"
        />
        <path
          clipRule="evenodd"
          d="M4489.65 857.574l-33.98-8.048-1599.06 25.203c-7.11-5.883-23.96-25.284-46.93-51.719-70.3-80.906-197.86-227.703-278.42-254.511l27.5-16.135c279.61 3.124 615.73 11.212 877.25 30.736 311 23.219 821.6 159.14 1204.3 272.1l-150.66 2.374z"
          fill="#4E6EC0"
          fillRule="evenodd"
        />
        <path
          d="M3762.92 728.227l24.44 62.141-20.25 37.704-143.83 5.586-46.78-27.231v-54.461l73.31-37.703 113.11 13.964z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M3762.89 728.223l-23.01 43.992-113.81 12.568-8.08 45.796-41.49-24.152v-54.461l73.31-37.703 113.08 13.96z"
          fill={`url(#${id}-bZ)`}
          fillRule="evenodd"
        />
        <path
          d="M4318.07 746.328c0 5.583-52.63 10.109-117.56 10.109-64.92 0-117.55-4.526-117.55-10.109s52.63-10.109 117.55-10.109c64.93 0 117.56 4.526 117.56 10.109z"
          fill={`url(#${id}-ca)`}
          opacity="0.8"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="3510.79"
          cy="616.953"
          fill={`url(#${id}-cb)`}
          rx="178.909"
          ry="10.997"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="4130.51"
          cy="682.964"
          fill={`url(#${id}-cc)`}
          rx="319.106"
          ry="29.164"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="3904.74"
          cy="646.786"
          fill="#292151"
          rx="36.594"
          ry="41.982"
        />
        <ellipse
          cx="4097.43"
          cy="642.184"
          fill="#292151"
          rx="38.525"
          ry="37.896"
        />
        <path
          d="M4228.49 663.78c0 22.056-27.81 23.243-40.41 21.12-16.38-2.759-30.08-17.879-30.08-39.935s13.47-39.935 30.08-39.935 40.41 36.695 40.41 58.75zm-224.47-12.848c0 25.651 15.24 50.78-34.98 46.446-19.25-1.661-34.98-20.795-34.98-46.446 0-25.651 15.66-46.446 34.98-46.446 19.32 0 34.98 20.795 34.98 46.446z"
          fill="#292151"
        />
        <path
          clipRule="evenodd"
          d="M4268.34 649.528V497.729l-224.48-5.625-82.9 8.181-17.83 56.246-60.13 17.392a21.517 21.517 0 00-15.5 19.336l-.81 12.961c-3.3 3.258-6.94 9.981-5.7 21.084h4.38l-.75 12.033v15.748l161.58 4.367 242.14-9.924z"
          fill={`url(#${id}-cd)`}
          fillRule="evenodd"
        />
        <path
          d="M4181.85 522.745c13.72 1.959 23.65-5.652 27.83-10.885.44-.549 1.3-.549 1.74 0 4.19 5.233 14.11 12.844 27.83 10.885 1.02-.146 2.02 1.425 1.54 2.338-1.37 2.645-2.48 6.564-1.63 11.304 1.65 9.113 8.76 22.782 3.29 32.805-4.34 7.958-22.74 19.323-31.9 24.422-9.05-5.042-27.52-16.403-31.9-24.422-5.46-10.023 1.65-23.692 3.29-32.805.85-4.74-.25-8.659-1.63-11.304-.48-.913.52-2.484 1.54-2.338z"
          fill="#9AAAF1"
        />
        <path
          d="M4188.92 529.25c10.1 1.102 17.46-4.399 20.75-8.373a1.156 1.156 0 011.76 0c3.3 3.974 10.66 9.475 20.75 8.373 1.03-.111 2.09 1.532 1.67 2.473-.9 2.031-1.51 4.811-.91 8.096 1.28 7.129 6.84 17.822 2.56 25.663-3.39 6.225-17.79 15.116-24.95 19.105-7.08-3.944-21.53-12.831-24.95-19.105-4.28-7.841 1.28-18.534 2.57-25.663.59-3.285-.02-6.065-.92-8.096-.41-.941.65-2.584 1.67-2.473z"
          stroke="#768BF3"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          clipRule="evenodd"
          d="M4047.86 492.204l-21.03 67.203c-29.63 5.376-110.82 38.311-110.82 68.912h-50.7l.06-1.015h-4.38c-1.24-11.103 2.4-17.826 5.7-21.084l.81-12.961a21.517 21.517 0 0115.5-19.336l60.13-17.392 17.83-56.246 82.9-8.181 4 .1z"
          fill={`url(#${id}-ce)`}
          fillRule="evenodd"
        />
        <path
          d="M3931.83 612.821c-2.22.704-4.49 3.718-6.14 6.38-.95 1.538.21 3.458 2.02 3.458h17.59c.9 0 1.77-.323 2.38-.974 2.35-2.496 5.15-6.762 3.72-9.479-2.05-3.894-15.37-.718-19.57.615z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M3860.75 622.659h4.82c1.81 0 2.98-1.92 2.02-3.458-1.42-2.304-3.32-4.871-5.24-5.977-.94 2.562-1.57 5.69-1.6 9.435z"
          fill="#fff"
          fillRule="evenodd"
        />
        <circle cx="4160.33" cy="510.998" fill="#fff" r="2.326" />
        <circle cx="4160.33" cy="558.349" fill="#733070" r="2.326" />
        <circle cx="4160.33" cy="618.614" fill="#fff" r="2.326" />
        <circle cx="4260.77" cy="512.381" fill="#fff" r="2.326" />
        <circle cx="4260.77" cy="555.427" fill="#fff" r="2.326" />
        <circle cx="4260.77" cy="612.823" fill="#fff" r="2.326" />
        <path
          d="M4048.59 514.646l41.72.793-.83 103.682-49.39 1.011-6.91-13.056 1.45-46.585 13.96-45.845zm50.11.85l43.16.817-.38 132.748-42.47.913-.31-134.478z"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="1.905"
        />
        <ellipse
          cx="3985.74"
          cy="650.932"
          fill={`url(#${id}-cf)`}
          rx="34.978"
          ry="46.446"
        />
        <path
          d="M4028.97 659.694c0-39.62-10.34-71.739-60.23-71.739-33.26 0-60.22 32.119-60.22 71.739"
          stroke="#374DB3"
          strokeWidth="1.905"
        />
        <path
          d="M4036.42 522.295h3.27c1.59 0 2.87 1.285 2.87 2.869v40.24a2.866 2.866 0 01-2.87 2.869h-3.27"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="2.858"
        />
        <path
          d="M4049.55 528.94l-5.59 26.332a2.875 2.875 0 002.76 3.465l35.97.61a1.43 1.43 0 001.46-1.411l.5-29.289a1.439 1.439 0 00-1.41-1.459l-30.83-.522a2.873 2.873 0 00-2.86 2.274z"
          fill="#372B76"
        />
        <rect
          fill="#fff"
          height="32.319"
          rx="4.305"
          width="12.736"
          x="4038.22"
          y="528.122"
        />
        <path
          d="M3853.81 626.853c2.61.326 72.25 1.902 106.3 2.837l-3.2 31.064c-.15 1.444-1.34 2.548-2.79 2.548-15.62.006-72.98-1.264-96.59-5.268-2.35-.399-4.28-2.04-4.81-4.364-2.34-10.172-1.79-27.177 1.09-26.817z"
          fill="#fff"
        />
        <path
          d="M4109.96 533.62l-.25 14.566a2.877 2.877 0 002.82 2.918l16.13.273a2.87 2.87 0 002.92-2.821l.25-14.566a2.877 2.877 0 00-2.82-2.918l-16.13-.273a2.87 2.87 0 00-2.92 2.821zm-44.6 100.989v6.141c0 1.585 1.29 2.87 2.87 2.87h16.13c1.59 0 2.87-1.285 2.87-2.87v-7.199c0-1.659-1.4-2.973-3.05-2.864l-16.13 1.058a2.876 2.876 0 00-2.69 2.864zm60.7-56.753l-.17 9.74c-.01.792.62 1.446 1.41 1.459l2.16.037c.79.013 1.44-.619 1.46-1.411l.16-9.74a1.431 1.431 0 00-1.41-1.459l-2.16-.037a1.427 1.427 0 00-1.45 1.411zm-46.92-.398l-.16 9.741c-.02.792.61 1.445 1.41 1.459l2.15.036c.8.013 1.45-.618 1.46-1.41l.17-9.741a1.439 1.439 0 00-1.41-1.459l-2.16-.036a1.441 1.441 0 00-1.46 1.41z"
          fill="#413776"
        />
        <ellipse
          cx="3987.65"
          cy="651.896"
          fill="#91A1E9"
          rx="18.898"
          ry="25.093"
        />
        <ellipse
          cx="3987.65"
          cy="651.896"
          fill="#413776"
          rx="7.314"
          ry="9.712"
        />
        <path
          d="M4024.05 547.534l15.94-49.589-76.02 6.539-13.75 43.294a2.867 2.867 0 002.73 3.739h65.63c2.5 0 4.71-1.609 5.47-3.983z"
          fill="#372B76"
        />
        <path
          clipRule="evenodd"
          d="M3995.08 551.517l-33.82-38.482 2.71-8.55 5.78-.497 52.79 45.947a5.737 5.737 0 01-3.96 1.582h-23.5z"
          fill={`url(#${id}-cg)`}
          fillRule="evenodd"
        />
        <path
          d="M3904.49 582.939c-3.22-1.97-14.55-1.627-22.78-.812-3.92.388-7.15 3.049-7.88 6.919-1.5 7.878-2.48 20.04-2.37 29.246.04 2.806 2.23 5.052 5.03 5.269 8.71.676 26.41 1.746 29.55-.41 4.2-2.882 2.63-37.649-1.55-40.212z"
          fill="#606CBB"
        />
        <path
          clipRule="evenodd"
          d="M3879.57 582.584c-.71.24-1.38.561-2 .955v40.104c.63.047 1.3.096 2 .144v-41.203zm7 41.616c-.67-.032-1.34-.066-2-.102v-42.224c.66-.052 1.33-.099 2-.142V624.2zm7 .221c-.66-.008-1.32-.021-2-.038v-42.874c.68-.016 1.34-.025 2-.028v42.94zm7-.143c-.63.043-1.3.076-2 .101v-42.74c.71.054 1.38.122 2 .206v42.433z"
          fill="#4F4F96"
          fillRule="evenodd"
        />
        <path
          d="M3943.08 556.41h72.57c5.54 0 10.04 4.497 10.04 10.044v59.73"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="1.905"
        />
        <ellipse
          cx="4206.73"
          cy="644.422"
          fill={`url(#${id}-ch)`}
          rx="30.076"
          ry="39.935"
        />
        <ellipse
          cx="4209.46"
          cy="643.965"
          fill="#91A1E9"
          rx="16.349"
          ry="21.708"
        />
        <ellipse
          cx="4209.46"
          cy="643.965"
          fill="#413776"
          rx="5.206"
          ry="6.912"
        />
        <path
          d="M4244.19 654.682v-25.437h28.77v24.203l-28.77 1.234z"
          fill="#fff"
        />
        <path
          d="M4159.57 554.228c-1.09 10.308-8.77 17.636-18.7 16.59-9.92-1.047-17.08-10.252-16-20.56 1.09-10.309 10.02-17.817 19.94-16.77 9.92 1.046 15.84 10.432 14.76 20.74z"
          fill="#733070"
        />
        <path
          d="M4158.3 527.665c-7.96.038-10.46 7.994-10.72 11.967l1.29.86c2.07-2.243 7.56-4.836 13.02 2.728 5.47 7.563 13.41 6.154 16.7 4.504-7.81 1.39-10.34-20.107-20.29-20.059z"
          fill="#733070"
        />
        <path
          d="M1730.59 535.006c-33.11-11.5-32.96 14.306-28.75 28.646 120.72 12.321 237.41 3.618 280.67-2.274-.93-16.646-14.46-18.074-21.11-16.707 8.6-34.189-17.95-54.782-41.57-18.269-3.78-10.204-15.01-8.545-20.15-6.44-.99-52.876-44.07-49.208-48.06-10.165-13.16-9.76-24.02-2.452-27.8 2.422-9.42-13.585-28.45-12.722-34.75 5.1-23.21-45.205-54.42-22.09-43.82 5.412-12.87-2.124-15.13 7.298-14.66 12.275z"
          fill="#209F99"
        />
        <path
          d="M1818.3 536.264c-1.31-7.397-5.19-21.272-10.15-17.602-4.96 3.67 4.7 13.264 10.15 17.602z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M1909.34 568.19c.2-19.026-15.78-27.433-30.98-4.181-2.53-7.676-10.63-6.571-14.37-5.059.27-39.549-30.77-37.328-34.37-8.183-9.28-7.457-17.22-2.125-20.03 1.474-6.52-10.272-20.22-9.857-25.08 3.392-15.85-34.082-38.72-17.176-31.61 3.516-8.43-1.596-10.66 4.14-10.79 7.983 65.57 5.226 126.59 3.797 167.23 1.058zm-171.32-1.393c-3.59-.975-6.53-1.174-8.91-.786 2.98.276 5.95.538 8.91.786z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          d="M2609.6 551.136c-353.39-38.88-1091.88-7.447-1121.81 23.392l864.89 401.614c923.16-162.483 610.31-386.127 256.92-425.006z"
          fill="#4E4288"
        />
        <path
          d="M4223.64 699.337c-22.99-10.899-12.28-47.427-11.15-58.638.15-3.236-.12-8.814 1.8-8.459 3.62 5.322 39.39 18.35 51.08 34.207 11.69 15.857-13 46.514-41.73 32.89z"
          fill="#FFA670"
        />
        <path
          clipRule="evenodd"
          d="M4220.85 636.873c2.27 1.278 4.99 2.706 7.96 4.267 12.4 6.517 29.22 15.355 36.56 25.307 8.24 11.182-1.6 29.724-18.2 34.907 3.55-4.706 7.99-13.245 5.53-20.974-1.74-5.456-4.2-7.168-6.27-8.606-2.18-1.515-3.92-2.726-3.92-7.689 0-7.44-13.55-20.603-21.66-27.212z"
          fill="#E3854C"
          fillRule="evenodd"
        />
        <path
          d="M4188.36 735.218l-1.96-6.669 7.71-2.615 2.23 7.323-7.98 1.961zm-37.74 4.585l-.17-6.95 8.13-.529.26 7.649-8.22-.17z"
          fill="#F3898A"
        />
        <path
          d="M4130.33 678.381l12.96-44.924h39.37c-.92 8.491-7.46 34.671-10.61 46.7l25.16 47.188-13.39 2.794-28.67-42.035a12.384 12.384 0 01-1.99-8.969l4.16-25.398-9.2 30.28 13.57 49.595h-13.57l-17.51-47.524a12.389 12.389 0 01-.28-7.707z"
          fill="#CCDAFF"
        />
        <path
          clipRule="evenodd"
          d="M4181.85 638.599c-11.37 5.162-30.31-.443-38.82-4.124l4.25-1.018h35.38c-.14 1.324-.42 3.078-.81 5.142zm-24.74 15.829l.16-.596-1.9-9.044-7.05 38.576 8.79-28.936zm-8.94 29.762l.07.26-.13.053.06-.313z"
          fill="#A2B4E4"
          fillRule="evenodd"
        />
        <path
          d="M4195.99 730.327l4.09 11.229-26.82 9.908c-.88-.088-2.35-1.559-1.18-6.738 1.16-5.178 8.85-6.032 12.55-5.812l2.64-6.605 8.72-1.982zm-36.74 6.725l1.05 11.906-28.46 2.629c-.83-.313-1.87-2.114.59-6.815 2.46-4.701 10.11-3.537 13.63-2.367l4.26-5.696 8.93.343z"
          fill="#4D0D54"
        />
        <path
          d="M4215.5 632.238c.05-.669-3.02-4.305-4.56-6.04l-6.69 2.12v6.297c0 1.606 1.48 1.349 1.55 2.056.06.707 1.41 3.791 4.04 3.92 2.64.128 5.59-7.518 5.66-8.353z"
          fill="#F3898A"
        />
        <path
          d="M4075.74 595.05c2.16-2.526 7.09-6.551 9.58-2.451 2.5 4.099 6.39 30.525 8.02 43.226"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="2.18"
        />
        <path
          d="M4095.25 616.06c.41.247 1.29.874 1.68 2.157l1.69 5.177c-2.1.103-6.93.247-9.47 0-3.18-.309-3.44-5.791-3.44-7.334 0-1.543 2.33-1.544 2.33-2.238 0-.695 3.57-.695 5-.695 1.43 0 1.69 2.624 2.21 2.933z"
          fill="#F3898A"
        />
        <path
          d="M4200.01 627.394c1.24 0 4.04 2.073 5.28 3.11 1.83.497 2.21 2.487 2.18 3.42-2.57 1.327-5.63 4.353-6.84 5.701-1.31-1.382-3.94-4.457-3.94-5.701 0-1.244 2.21-1.624 3.32-1.658-.52-1.624-1.25-4.872 0-4.872z"
          fill="#FFA670"
        />
        <path
          d="M4139.15 575.987l10.23-4.957 8.46-2.7a16.5 16.5 0 0115.68 3.131l20.3 17.205a24.654 24.654 0 017.03 9.813l10.9 27.685-8.27 3.289-13.06-27.001-14.66-10.321c8.36 13.321 7.82 30.935 6.84 41.119-11.57 7.921-32.16 2.625-39.45 1.321 1.38-11.47-2.54-23.309-2.95-31.536l-4.68 15.973a5.895 5.895 0 01-5.46 4.231l-32.47 1.05c-.54-.493-.9-4.821-1.01-6.628l29.21-5.093 3.95-23.987a17.117 17.117 0 019.41-12.594z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M4179.57 576.589l-5.67-4.804c-3.41.767-6.82 1.401-10.2 1.905-7.86 1.17-15.56 1.639-22.87 1.485l-1.68.812a17.02 17.02 0 00-5.97 4.81c9.91.789 20.57.44 31.4-1.173 4.96-.739 9.98-1.745 14.99-3.035zm-51.24 20.597l.97-5.923c10.9 1.432 23.15 1.368 35.83-.519a140.438 140.438 0 0024.25-5.845l4.45 3.767c.28.239.55.484.82.735a143.52 143.52 0 01-15.94 4.811l-2.95-2.08c.5.799.97 1.614 1.41 2.443-3.74.854-7.46 1.553-11.16 2.103-13.16 1.96-26.07 2.054-37.68.508zm-5.53 15.903l2.99-.52.8-4.879c3.77.649 7.74 1.111 11.85 1.372l-1.73 5.894c-4.83-.358-9.49-.985-13.91-1.867zm-22.77 3.97l7-1.22c6.13 3.335 13.76 5.874 22.38 7.422l-19.43.628c-3.08-1.289-5.93-2.743-8.53-4.352a3.02 3.02 0 01-1.42-2.478zm83.01 9.843c-4.47 1.1-8.94 1.968-13.37 2.615-8.99 1.314-17.85 1.729-26.25 1.326.06-2.013-.02-4.026-.18-6.014 8.1.418 16.73.043 25.56-1.248 4.74-.694 9.53-1.65 14.31-2.883.05 2.166.02 4.249-.07 6.204zm25.48-8.959c-2.91 1.36-5.85 2.605-8.8 3.739l-2.62-5.421c3.1-1.176 6.18-2.479 9.21-3.912l2.21 5.594zm-7.8-19.786c.05.107.09.215.13.322l2.07 5.262a140.236 140.236 0 01-10.02 3.838l-2.48-5.126-.36-.251c3.59-1.189 7.15-2.536 10.66-4.045zm-19.64 6.693a141.536 141.536 0 01-14.52 2.948c-8.86 1.318-17.51 1.747-25.63 1.397.19 1.221.41 2.485.64 3.784.13.741.26 1.495.39 2.258 8.18.271 16.78-.209 25.48-1.505 4.91-.731 9.87-1.724 14.83-2.995a61.31 61.31 0 00-1.19-5.887z"
          fill="#7469A3"
          fillRule="evenodd"
        />
        <circle cx="4148.11" cy="574.189" fill="#CE5E60" r="6.056" />
        <ellipse
          cx="4156.97"
          cy="559.168"
          fill="#CE5E60"
          rx="2.577"
          ry="4.292"
          transform="rotate(10.913 4156.97 559.168)"
        />
        <path
          d="M4125.77 554.128l25.51-9.49 3.65 10.792c3.14 9.246-1.82 19.279-11.07 22.411l-1.49.506a7.662 7.662 0 01-9.68-4.696l-6.92-19.523z"
          fill="#F3898A"
        />
        <path
          d="M4136.54 565.225c-.31.727-.92 2.417-.92 3.356 0 .94 1.01 1.287 1.51 1.342m5.13 2.839c.98.023 3.13-.382 3.89-2.184"
          stroke="#CE5E60"
          strokeLinecap="round"
        />
        <path
          d="M4129.35 567.578c-1.8-2.32-2.59-7.822-2.77-9.956l29.89-4.658v4.243s-1.49 5.904-5.86 7.911c-3.5 1.606-8.08.911-12.1.354-1.86-.258-3.74.216-5.31 1.26l-1.43.948c-.79.527-1.84.65-2.42-.102z"
          fill="#4D0D54"
        />
        <ellipse
          cx="4130.82"
          cy="562.26"
          fill="#fff"
          rx="0.827"
          ry="1.718"
          transform="rotate(-8.188 4130.82 562.26)"
        />
        <ellipse
          cx="4142.06"
          cy="560.677"
          fill="#fff"
          rx="0.827"
          ry="1.718"
          transform="rotate(-8.188 4142.06 560.677)"
        />
        <path
          d="M4134.18 551.793c-3.37 10.464-6.46 10.287-9.7 9.65-6.7-14.003 11.9-21 25.37-21l6.69 8.922.73 2.428-1.38 10.458c-.96-3.293-2.25-6.887-8.43-8.239-6.18-1.352-11.21-1.369-13.28-2.219z"
          fill="#733070"
        />
        <path
          clipRule="evenodd"
          d="M2485.04 555.874l-40.61.147-324.15 1.189-64.98.239-132.22.484-31.94.117-18 .067-68.51.245-26.02.098a196.591 196.591 0 0119.29-4.027c36.81-5.81 68-.466 78.46 1.759 2.44.521 3.76.871 3.76.871s1.26-1.943 4.74-4.095c2.82-1.765 7.12-3.665 13.4-4.762 10.55-1.845 21.32-.031 27.81 1.538 3.75.914 6.06 1.747 6.06 1.747s-.91-2.648-1.35-5.829c-.55-4.051-.3-8.979 3.64-10.414 7.02-2.556 16.06 0 16.06 0s12.05-18.087 41.17-20.846c27.85-2.629 50.19 2.293 52.09 2.734.09.012.13.025.13.025.13-.141.26-.288.39-.429.67-.73 1.36-1.465 2.12-2.189 0-.012.03-.03.04-.043a59.317 59.317 0 016.04-5.118c12.7-9.39 33.17-16.96 63.71-14.594 41.51 3.212 46.62 26.154 46.62 26.154 47.28-8.777 83.93 7.227 83.93 7.227s19.08-2.924 37.16 2.93c9.69 3.132 13.32 8.587 14.59 12.982.41 1.373.58 2.648.63 3.708.53-.87 1.64-1.747 3.74-2.372.03-.012.07-.025.11-.037 6.04-1.722 16.08-.686 16.08-.686v-.013c-.06-.263-.93-4.456.78-9.476 2.59-7.6 11.11-17.088 37.38-17.701 28.23-.662 60.59 12.988 80.25 22.924 7.16 3.616 12.63 6.736 15.6 8.495 1.67.975 2.56 1.532 2.56 1.532 14.08-5.596 29.44 5.419 29.44 5.419z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M2875.87 520.593h-12.41l-6.87 87.166h162.01l-3.42-50.055-8.97-18.288-44.42-9.276-2.86 5.728h-25.78l-4.29-20.525-11.94 5.25v15.275h-27.68l-4.3-23.389h-9.07v8.114z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M2859.62 607.773l-3.72-139.059 3.72-1.983 3.06-23.053h5.86v46.101H2898l-5.49-16.116h5.49l11.8 4.029v12.087l7.05 1.439v4.317l7.63 1.007-1.87 10.936h-12.81v37.844h29.07l-5.21-26.045h5.21l8.63 1.583v5.899l3.6 2.015v16.548h27.63v-37.844h-16.84l4.03-8.346h14.96l2.74-10.36h9.78v39.224h3.54v17.987h17.03v-28.059h4.08l1.44-16.309h4.07v106.477h-40.29l.03-.19-44.58-.058v-45.111h-29.06l.86 45.076-50.9-.036zm11.74-100.279h27.3v39.432h-26.06l-1.24-39.432zm27.3 54.743h-27.3l1.24 33.655h26.06v-33.655zm79.3 0h-25.28v33.655h25.28v-33.655zm20.14-.257h14.45v32.389h-14.45V561.98z"
          fill={`url(#${id}-ci)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M2854.44 607.773l-3.71-139.059 3.71-1.983v-20.574l8.93-2.479v46.101h29.46v-16.116l11.8 4.029v12.087l7.05 1.439v4.317l7.62 1.007-1.87 10.936h-12.8v37.844h29.06v-26.045l8.64 1.583v5.9l3.59 2.014v16.548h27.63v-37.844h-16.84l4.03-8.346h14.97l2.73-10.36h9.79v119.143l-54.68-.071v-45.111h-29.07l.86 45.076-50.9-.036zm11.75-100.279h27.3v39.432h-26.06l-1.24-39.432zm27.3 54.743h-27.3l1.24 33.655h26.06v-33.655zm79.3 0h-25.28v33.655h25.28v-33.655z"
          fill="#4AABFF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3274.32 607.852l-40.61.147-324.15 1.189-64.98.239-132.22.484-31.94.117-17.99.067-68.52.246-26.02.098a196.3 196.3 0 0119.29-4.027c36.81-5.811 68.01-.466 78.47 1.759 2.43.521 3.75.87 3.75.87s1.26-1.943 4.74-4.094c2.82-1.766 7.13-3.666 13.41-4.763 10.54-1.845 21.32-.031 27.8 1.539 3.76.913 6.06 1.746 6.06 1.746s-.91-2.647-1.35-5.829c-.55-4.051-.3-8.979 3.64-10.413 7.02-2.556 16.06 0 16.06 0s12.05-18.088 41.18-20.846c27.85-2.63 50.18 2.292 52.08 2.733.09.013.13.025.13.025.13-.141.26-.288.39-.429.67-.73 1.37-1.465 2.12-2.188 0-.013.03-.031.04-.043a59.062 59.062 0 016.04-5.118c12.7-9.39 33.17-16.96 63.71-14.594 41.52 3.211 46.62 26.154 46.62 26.154 47.28-8.778 83.94 7.226 83.94 7.226s19.07-2.923 37.15 2.93c9.69 3.132 13.32 8.587 14.6 12.982a15.5 15.5 0 01.62 3.708c.54-.87 1.64-1.747 3.74-2.372a.9.9 0 01.12-.036c6.03-1.723 16.07-.687 16.07-.687v-.012c-.06-.264-.93-4.456.78-9.476 2.6-7.601 11.11-17.089 37.38-17.702 28.24-.662 60.6 12.988 80.25 22.924 7.16 3.616 12.63 6.736 15.61 8.495 1.66.975 2.55 1.533 2.55 1.533 14.08-5.596 29.44 5.418 29.44 5.418z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.7"
          style={{ mixBlendMode: "soft-light" }}
        />
        <ellipse
          cx="2530.52"
          cy="720.212"
          fill={`url(#${id}-cj)`}
          rx="154.611"
          ry="9.416"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M2457.85 720.161v-9.051l6.73-4.446 2.98 2.444a31.343 31.343 0 004.75 3.227l6.93 3.843a3.338 3.338 0 011.72 2.917v1.066h-23.11zm-25.57 0v-9.051l6.74-4.446 2.97 2.444a31.343 31.343 0 004.75 3.227l6.93 3.843a3.338 3.338 0 011.72 2.917v1.066h-23.11z"
          fill="#C05E2F"
        />
        <path
          d="M2442.8 689.334h25.72l3.5-66.908-27.9 4.529-1.32 62.379z"
          fill="#9E5227"
        />
        <path
          d="M2450.8 611.718c5.32-.285 16.84-1.752 20.43-5.341l1.89 6.794c-1.89 30.913-.23 57.255-.05 96.409-2.78 2.949-11.05 5.014-16.75 0-3.08-26.379-3.76-52.453-2.13-68.435-4.66 30.285-6.57 59.25-6.29 68.435-3.21 2.307-13.97 3.495-18.55 0-.34-8.034 5.29-69.795 6.11-75.949.82-6.153 8.9-2.455 15.34-21.913z"
          fill="#4D0D54"
        />
        <path
          d="M2454.53 559.02l-11.22-2.582 3.04 70.106 23.32-5.148-1.82-36.795-6.18-25.581h-7.14z"
          fill="#CCDAFF"
        />
        <path
          d="M2455.26 567.388l-3.5-3.686 2.94-4.504 3.02 4.945-2.46 3.245z"
          fill="#BA3491"
        />
        <path
          d="M2460.22 601.148l-4.02-35.717h-2.36l-1.19 35.717 4.38 9.343 3.19-9.343z"
          fill="#BA3491"
        />
        <path
          clipRule="evenodd"
          d="M2470.8 616.561c-2.78 2.738-13.47 7.239-27.09 2.509-.3-.104-.58-.205-.85-.304-4.59.146-7.86 2.288 1.93 5.686 13.63 4.73 24.32.229 27.1-2.509l-.79-5.466-.31.028.01.056z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M2487.49 632.318c2.64-12.153-5.1-24.835-9.31-29.656l-.51 8.777c5.69 7.217 5.77 16.505 5.1 20.247l4.72.632z"
          fill="#9E5227"
        />
        <path
          d="M2419.82 686.552l10.6-73.415c.38-2.576.55-5.176.52-7.778l-.51-47.637 4.44-6.58 7.64 7.742 4.67 24.865c.32 11.639 1.11 36.858 1.69 44.617.59 7.76-1.85 44.618-3.15 62.077-11.74 2.876-21.7 0-25.9-3.891zm62.08-110.146l-8.54-16.608-8.05 23.239 17.62 19.104c6.35 6.885 17.77 1.331 16.27-7.914l-7.19-44.424-3.79-2.534-10.69 7.667 4.37 21.47z"
          fill="#B2682F"
        />
        <path
          d="M2410.76 583.762l20.49-27.097 8.84 19.067-14.62 18.731 7.97 20.216-11.09 10.466-12.88-31.571a10.01 10.01 0 011.29-9.812z"
          fill="#B2682F"
        />
        <path
          d="M2433.37 637.45c-1.74 0-5.47-5.952-6.04-8.796 0-5.251 4.32-8.428 7.03-9.916l6.25 5.443c-1.4 5.557-3.76 13.269-7.24 13.269zm9.07-81.616l3.12-9.584h13.27l6.57 6.352-3.12 8.916-19.84-5.684z"
          fill="#F3898A"
        />
        <path
          d="M2439.29 600.831c-3.82-.642-6.9-2.382-8.48-3.513-.96 2.399-.4 4.628 0 5.443 2.3 1.93 3.95 1.423 8.48 3.037 4.54 1.613 6.14 6.823 6.06 8.964h4.72c1.09-8.722-6.96-13.289-10.78-13.931zm1.24 15.657c-2.98 6.283-9.06 19.495-9.53 22.078 14.31 8.583 22.98-13.769 9.53-22.078z"
          fill="#9E5227"
        />
        <path
          d="M2475.07 559.928l-6.06-6.3c-4.17 2.1-4.39 10.176-4.39 23.81 6.15 43.151 2.47 79.371 0 111.968h11.12c5.07-31.341 6.1-91.537-.67-129.478z"
          fill="#B2682F"
        />
        <path
          d="M2454.72 559.031l-11.83-5.167-1.73 2.617 10.28 9.689 3.28-7.139z"
          fill="#fff"
        />
        <path
          d="M2454.72 559.031l11.18-6.968 1.99 2.327-9.59 11.461-3.58-6.82z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M2446.8 544.254c-3.06 0-11.96 3.586-15.58 8.396l4.95 11.889 4.66-2.332-3.68 4.688 10.44 25.099c0-5.304-.31-11.278-.62-17.404-.55-10.542-1.12-21.535-.17-30.336zm9.55-1.827c2.25.7 11.58 6.713 14.78 9.738-.62 3.068-1.44 7.427-2.2 12.224l-4.36-2.182 3.93 5.001c-1.37 9.21-2.4 19.368-1.48 24.906-2.26-13.228-4.8-23.563-6.88-32.023-1.71-6.971-3.11-12.67-3.79-17.664z"
          fill="#9E5227"
          fillRule="evenodd"
        />
        <path d="M2446.29 540.527h12.405v13.482h-12.405z" fill="#F3898A" />
        <path
          d="M2460.84 529.486h3.52l.31 1.862.98-10.132-3.45 2.084-1.36 6.186zm-25.86 1.665l-.48-7.682 7.37.224.3 18.659-.79-.491a13.598 13.598 0 01-6.4-10.71z"
          fill="#4D0D54"
        />
        <ellipse
          cx="2439.62"
          cy="532.007"
          fill="#CE5E60"
          rx="2.814"
          ry="4.687"
          transform="rotate(-20.08 2439.62 532.007)"
        />
        <ellipse
          fill="#CE5E60"
          rx="2.814"
          ry="4.687"
          transform="scale(-1 1) rotate(-20.079 271.296 7220.377)"
        />
        <path
          clipRule="evenodd"
          d="M2458.69 552.394c-1.22.582-2.57.941-4.01 1.024a10.772 10.772 0 01-8.39-3.288v-9.603h12.4v11.867z"
          fill="#CE5E60"
          fillRule="evenodd"
        />
        <path
          d="M2439.32 523.979l23.56-1.803.05 13.378.01 3.148c.02 5.737-4.45 10.489-10.17 10.818a10.803 10.803 0 01-11.33-9.375l-2.12-16.166z"
          fill="#F3898A"
        />
        <path
          d="M2449.31 537.291c1.62-.368 3.82 1.308 4.82 2.497.45-.888 1.79-2.818 3.48-2.721 3.22.185 3.89 4.748 7.41 6.076l-10.85-1.75-11.01 2.341c4.54-.965 2.72-5.66 6.15-6.443z"
          fill="#4D0D54"
        />
        <circle
          cx="2464.71"
          cy="527.834"
          r="7.525"
          stroke="#fff"
          strokeWidth="1.667"
          transform="rotate(21.868 2464.71 527.834)"
        />
        <path
          d="M2469.38 533.74l6.88 9.592"
          stroke="#fff"
          strokeWidth="1.667"
        />
        <path
          d="M2472.49 538.239l4.88 6.79"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3.335"
        />
        <path
          d="M2441.3 536.795l.85-13.343-4.99-2.617v5.12l4.14 10.84z"
          fill="#4D0D54"
        />
        <ellipse
          cx="2449.7"
          cy="520.298"
          fill="#4D0D54"
          rx="25.661"
          ry="8.11"
          transform="rotate(-8.223 2449.7 520.298)"
        />
        <path
          d="M2439.5 501.022c-2.17 6.752-4.27 15.148-5.35 19.848 10.42 2.608 22.38 1.06 31.66-3.928l-6.38-14.327c-1.03-2.335-3.96-3.113-6.02-1.602l-.31.222c-1.22.9-2.96.544-3.73-.767-2.8-4.735-8.19-4.681-9.87.554z"
          fill="#F7B119"
        />
        <path
          clipRule="evenodd"
          d="M2464.09 513.067l-4.66-10.452c-1.03-2.335-3.96-3.113-6.02-1.602l-.31.222c-1.22.9-2.96.543-3.73-.767-2.8-4.735-8.19-4.681-9.87.554-1.68 5.231-3.32 11.449-4.48 16.17 9.72 1.887 20.48.329 29.07-4.125z"
          fill={`url(#${id}-ck)`}
          fillRule="evenodd"
        />
        <path
          d="M2433.06 610.873l3.77 7.154c-6.13 3.17-8.83 9.209-9.42 11.833l-7.53-1.856c2.11-9.036 9.67-15.186 13.18-17.131z"
          fill="#9E5227"
        />
        <path
          d="M2487.32 543.134l2.55 6.639-10.78 5.567-6.59-10.812a5.232 5.232 0 015.72-7.796l2.53.621c3 .737 5.46 2.896 6.57 5.781z"
          fill="#F3898A"
        />
        <path
          d="M2474.93 551.252l.58 9.152c10.94 1.32 18.85-6.774 20.72-9.938l-7.03-4.827c-6.6 6.074-12.26 6.273-14.27 5.613z"
          fill="#9E5227"
        />
        <ellipse cx="2448.81" cy="531.5" fill="#4D0D54" rx="0.859" ry="1.684" />
        <ellipse
          cx="2885.61"
          cy="634.034"
          fill={`url(#${id}-cl)`}
          rx="152.476"
          ry="7.725"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M2750.81 631.077l-11.57-274.275"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="7.747"
        />
        <path
          d="M2750.81 631.077l-1.87-45.615"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.292"
        />
        <path
          d="M2695.96 407.094h93.67"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="7.747"
        />
        <path
          d="M2697.48 407.383c7.54 52.129 55.9 118.075 87.93 0m0 1.885c-2.72 31.402-6.53 96.218 0 104.257"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3.467"
        />
        <path
          d="M2698.11 408.011c-.21 15.283.38 49.365 4.4 63.434 4.02 14.068 1.67 49.826 0 65.946"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3.467"
        />
        <path
          d="M2705.15 370.889l70.69 5.172"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="7.747"
        />
        <path d="M1456.67 448.633h172.152v107.426H1456.67z" fill="#9E5227" />
        <path
          d="M1478.32 376.043v81.764l13.05 10.438 13.05-10.438v-81.764h-26.1z"
          fill={`url(#${id}-cm)`}
        />
        <path
          d="M1478.32 376.043v81.764l13.05 10.438 13.05-10.438v-81.764h-26.1z"
          fill={`url(#${id}-cn)`}
        />
        <path
          d="M1491.43 313.836l15.04 61.699h-30.08l15.04-61.699z"
          fill={`url(#${id}-co)`}
        />
        <path
          d="M1491.43 313.836l15.04 61.699h-30.08l15.04-61.699z"
          fill={`url(#${id}-cp)`}
        />
        <path
          d="M1486.05 408.939a5.38 5.38 0 015.38-5.377 5.37 5.37 0 015.37 5.377v17.654h-10.75v-17.654z"
          fill="#4D0D54"
        />
        <path
          d="M1478.33 389l-4.06-8.108h34.31l-4.05 8.108h-26.2z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M1485.95 370.173v4.067h3.42v-4.067h4.11v4.067h3.42v-4.067h4.11v4.067h3.42v-4.067h4.15v10.722h-34.31v-10.722h4.16v4.067h3.42v-4.067h4.1z"
          fill="#D5815D"
          fillRule="evenodd"
        />
        <path d="M1473.47 440.552h35.799v8.08h-35.799z" fill="#CCDAFF" />
        <path
          d="M1581.06 376.043v81.764l13.05 10.438 13.05-10.438v-81.764h-26.1z"
          fill={`url(#${id}-cq)`}
        />
        <path
          d="M1581.06 376.043v81.764l13.05 10.438 13.05-10.438v-81.764h-26.1z"
          fill={`url(#${id}-cr)`}
        />
        <path
          d="M1588.79 408.939a5.38 5.38 0 015.38-5.377 5.38 5.38 0 015.38 5.377v17.654h-10.76v-17.654z"
          fill="#4D0D54"
        />
        <path
          d="M1594.15 313.836l15.03 61.699h-30.07l15.04-61.699z"
          fill={`url(#${id}-cs)`}
        />
        <path
          d="M1594.15 313.836l15.03 61.699h-30.07l15.04-61.699z"
          fill={`url(#${id}-ct)`}
        />
        <path
          d="M1581.07 389l-4.05-8.108h34.3l-4.05 8.108h-26.2z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M1588.7 370.173v4.067h3.42v-4.067h4.1v4.067h3.42v-4.067h4.11v4.067h3.42v-4.067h4.15v10.722h-34.3v-10.722h4.15v4.067h3.42v-4.067h4.11z"
          fill="#D5815D"
          fillRule="evenodd"
        />
        <path d="M1576.21 440.551h35.799v8.08h-35.799z" fill="#CCDAFF" />
        <path d="M1512.25 359.479h60.977v30.651h-60.977z" fill="#4D0D54" />
        <path
          d="M1500.85 388.74h83.783v50.219h-83.783z"
          fill={`url(#${id}-cu)`}
        />
        <path
          d="M1500.85 389h83.783v165.671h-83.783z"
          fill={`url(#${id}-cv)`}
        />
        <path
          d="M1413.82 414.567v140.104h44.72V414.567h-44.72z"
          fill={`url(#${id}-cw)`}
        />
        <path
          d="M1413.82 414.567v140.104h44.72V414.567h-44.72z"
          fill={`url(#${id}-cx)`}
        />
        <path
          d="M1437.54 451.288h12.504v6.614h-12.504zm0 26.891h12.504v6.614h-12.504zm6.62-20.277h12.504v6.614h-12.504z"
          fill="#C67E49"
        />
        <path
          d="M1423.18 451.584a4.309 4.309 0 014.31-4.307c2.38 0 4.31 1.928 4.31 4.307v14.141h-8.62v-14.141zm0 37.495a4.31 4.31 0 018.62 0v14.14h-8.62v-14.14z"
          fill="#4D0D54"
        />
        <path d="M1436.04 403.922V299.114" stroke="#fff" strokeWidth="2.091" />
        <path
          d="M1423.18 532.129a4.309 4.309 0 014.31-4.307c2.38 0 4.31 1.928 4.31 4.307v14.14h-8.62v-14.14z"
          fill="#4D0D54"
        />
        <path
          d="M1436.28 351.193l27.81 61.181h-55.62l27.81-61.181z"
          fill={`url(#${id}-cy)`}
        />
        <path
          d="M1413.83 436.769l-6.94-13.893h58.78l-6.94 13.893h-44.9z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M1426.9 404.51v6.969h5.86v-6.969h7.04v6.969h5.86v-6.969h7.03v6.969h5.86v-6.969h7.12v18.373h-58.78V404.51h7.11v6.969h5.87v-6.969h7.03z"
          fill="#D4815D"
          fillRule="evenodd"
        />
        <path d="M1496.8 380.396h91.876v9.732H1496.8z" fill="#fff" />
        <path
          d="M1626.75 414.566V554.67h44.72V414.566h-44.72z"
          fill={`url(#${id}-cz)`}
        />
        <path
          d="M1626.75 414.566V554.67h44.72V414.566h-44.72z"
          fill={`url(#${id}-cA)`}
        />
        <path
          d="M1651.42 448.632h10.043v5.312h-10.043zm0 21.597h10.043v5.312h-10.043zm5.32-16.285h10.043v5.312h-10.043z"
          fill="#C67E49"
        />
        <path
          d="M1636.11 451.584a4.31 4.31 0 014.31-4.308 4.3 4.3 0 014.3 4.308v14.14h-8.61v-14.14z"
          fill="#4D0D54"
        />
        <path d="M1649.14 413.46V298.7" stroke="#fff" strokeWidth="2.091" />
        <path
          d="M1636.11 489.079a4.31 4.31 0 014.31-4.308 4.3 4.3 0 014.3 4.308v14.14h-8.61v-14.14zm0 43.05a4.31 4.31 0 014.31-4.308 4.3 4.3 0 014.3 4.308v14.14h-8.61v-14.14z"
          fill="#4D0D54"
        />
        <path
          d="M1649.14 352.515l27.8 61.182h-55.61l27.81-61.182z"
          fill={`url(#${id}-cB)`}
        />
        <path
          d="M1649.14 352.515l27.8 61.182h-55.61l27.81-61.182z"
          fill={`url(#${id}-cC)`}
        />
        <path
          d="M1676.3 404.724c-.12-.859 2.13-6.592 4.24-11.849l2.08 1.183-4.51 9.899 1.65 1.403-1.23 1.661c-.03-.262-.09-.838-.14-1.043-.06-.205-1.42-.921-2.09-1.254z"
          fill={`url(#${id}-cD)`}
        />
        <path
          d="M1687.01 388.824c-.41 1.342-2.8-2.223-3.95-2.475-2.18 1.594-.69 7.977 1.07 7.725 1.41-.201 3.09-2.923 3.82-2.476.16-3.607-.54-4.116-.94-2.774zm6.97-6.013l.39 1.214c.09-1.389-.42-3.662-3.14-1.644-3.39 2.522-2.91 9.015.24 8.56 2.51-.364 2.85-5.897 2.51-8.13z"
          fill="#F3898A"
        />
        <path
          clipRule="evenodd"
          d="M1690.06 379.01c2.16-.757 4.98-1.356 5.82-.472 1.27 1.345-.65 4.573-1.77 6.018-.4-.726-1.5-1.182-2.63-.787.41 2.051.9 4.341 1.43 6.81 1.37 6.36 2.99 13.905 4.11 21.595 1.66 11.323 2.29 23.17-.56 32.34-2.39 7.677-5.54 13.149-8.56 18.383-.55.961-1.1 1.915-1.64 2.872-2.13 3.781-4.12 7.658-5.66 12.415-1.92 12.99.16 25.368 2.01 36.391 1.51 9.003 2.87 17.102 1.77 23.892-2.38 14.824 4.66 20.927 8.48 24.13-5.15-.572-16.81-4.53-22.31-15.786-6.86-14.07-6.87-41.028-2.05-71.379 3.93-24.766 7.07-31.944 11.11-41.151.91-2.076 1.86-4.255 2.88-6.762 5.54-13.627 2.82-34.102 1.89-37.911-.92-3.809-1.08-8.496.93-10.156 1.67-1.38 3.38-1.104 4.75-.442zm-4.75 82.832c10.12-22.792 10.3-43.538 8.65-58.069.53 2.814 1.03 5.71 1.46 8.636 1.65 11.288 2.22 22.824-.51 31.623-2.33 7.493-5.39 12.801-8.4 18.03-.56.969-1.12 1.934-1.67 2.911a98.087 98.087 0 00-2.24 4.187 60.055 60.055 0 012.71-7.318z"
          fill={`url(#${id}-cE)`}
          fillRule="evenodd"
        />
        <path
          d="M1683.55 391.998c-.22-1.057.51-4.267 0-5.5-4.07-2.201-3.69 1.264-4.9 2.749-.96 1.188-3.57 2.109-4.95 2.531-.99-.624-3.87-1.452-7.48.22-3.6 1.672-12.99 23.635-13.17 26.293l17.02.55c.88-1.301 2.84-20.298 3.63-20.958.99-.825 5.23-1.65 7.48-1.54 2.26.11 3.96-2.09 3.96-2.695s-1.32-.33-1.59-1.65z"
          fill="#9843EB"
        />
        <path
          d="M1673.57 397.942c-1.05-.268 1.48-1.707 0-6.215"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="0.811"
        />
        <path
          d="M1626.76 436.769l-6.94-13.893h58.78l-6.95 13.893h-44.89z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M1639.83 404.51v6.968h5.86v-6.968h7.03v6.968h5.87v-6.968h7.03v6.968h5.86v-6.968h7.12v18.372h-58.78V404.51h7.11v6.968h5.86v-6.968h7.04z"
          fill="#D5815D"
          fillRule="evenodd"
        />
        <path
          d="M1672.22 404.247c0-.867 5.59-10.938 8.38-15.865l1.9 1.452-8.37 13.897 1.44 1.612-1.44 1.48c.01-.263.02-.842 0-1.052-.03-.211-1.28-1.104-1.91-1.524z"
          fill="#F3898A"
        />
        <path
          d="M1680.59 388.201l2.12 1.659"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="0.811"
        />
        <path
          d="M1510.17 466.688c0-7.893 6.4-14.292 14.29-14.292 7.89 0 14.29 6.399 14.29 14.292v22.236h-28.58v-22.236z"
          fill="#D4815D"
        />
        <path
          d="M1513.02 469.768c0-2.838 2.3-5.139 5.14-5.139s5.14 2.301 5.14 5.139v18.902h-10.28v-18.902zm12.66 0c0-2.838 2.3-5.139 5.14-5.139 2.83 0 5.13 2.301 5.13 5.139v18.902h-10.27v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M1510.17 413.737c0-7.894 6.4-14.293 14.29-14.293 7.89 0 14.29 6.399 14.29 14.293v22.236h-28.58v-22.236z"
          fill="#D4815D"
        />
        <path
          d="M1513.02 416.817c0-2.838 2.3-5.139 5.14-5.139s5.14 2.301 5.14 5.139v18.902h-10.28v-18.902zm12.66 0c0-2.838 2.3-5.139 5.14-5.139 2.83 0 5.13 2.301 5.13 5.139v18.902h-10.27v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M1547.63 466.688c0-7.893 6.4-14.292 14.29-14.292 7.9 0 14.29 6.399 14.29 14.292v22.236h-28.58v-22.236z"
          fill="#D4815D"
        />
        <path
          d="M1550.48 469.768a5.139 5.139 0 1110.28 0v18.902h-10.28v-18.902zm12.66 0c0-2.838 2.3-5.139 5.14-5.139s5.14 2.301 5.14 5.139v18.902h-10.28v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M1547.63 413.737c0-7.894 6.4-14.293 14.29-14.293 7.9 0 14.29 6.399 14.29 14.293v22.236h-28.58v-22.236z"
          fill="#D4815D"
        />
        <path
          d="M1550.48 416.817a5.139 5.139 0 1110.28 0v18.902h-10.28v-18.902zm12.66 0c0-2.838 2.3-5.139 5.14-5.139s5.14 2.301 5.14 5.139v18.902h-10.28v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M1496.8 434.094h91.876v9.732H1496.8zm24.31 91.595c0-11.948 9.68-21.634 21.63-21.634s21.64 9.686 21.64 21.634v28.982h-43.27v-28.982z"
          fill="#fff"
        />
        <path
          d="M1528.53 530.031c0-7.848 6.36-14.211 14.21-14.211 7.85 0 14.21 6.363 14.21 14.211v24.758h-28.42v-24.758z"
          fill={`url(#${id}-cF)`}
        />
        <path
          d="M1474.31 505.717a4.883 4.883 0 014.88-4.879c2.7 0 4.88 2.184 4.88 4.879v17.946h-9.76v-17.946zm127.97 0a4.883 4.883 0 014.88-4.879c2.7 0 4.88 2.184 4.88 4.879v17.946h-9.76v-17.946z"
          fill="#4D0D54"
        />
        <path d="M1496.8 487.705h91.876v9.732H1496.8z" fill="#fff" />
        <path
          d="M1860.61 556.402c-206.12-13.065-710.94 9.415-819.8 19.33 751.15 23.228 652.47 180.446 525.22 232.384l414.74 49.656c195.66-15.181 415.09-267.444-120.16-301.37z"
          fill="#4E6EC0"
        />
        <ellipse
          cx="3310.56"
          cy="744.591"
          fill={`url(#${id}-cG)`}
          rx="167.592"
          ry="10.207"
          style={{ mixBlendMode: "multiply" }}
        />
        <g filter={`url(#${id}-cH)`}>
          <path
            d="M3288.96 650.414l-22.82 16.037c6.27 1.542 19.62 4.935 22.82 6.168 4.01 1.542 17.28 13.57 22.52 13.57 4.19 0 16.14-11.102 21.59-16.654l-11.41 1.542c.2 1.234-1.55 4.441-10.18 7.402-8.64 2.961-16.35-4.729-19.12-8.944l-17.58-4.934 19.74-14.187 4.31-7.094 7.41-7.402-11.72 5.86-5.56 8.636z"
            fill="#2AF5C4"
          />
        </g>
        <path
          d="M3256.87 567.991l6.08 8.65c3.79 5.391 11.23 6.702 16.63 2.93l16.59-11.58"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <path
          d="M3310.32 535.708l-34.9 32.015a28.276 28.276 0 0018.39 20.316l.36.121 34.9-32.015.03-.266c1.56-11.162-7.54-20.932-18.78-20.171z"
          fill={`url(#${id}-cI)`}
        />
        <path
          d="M3316.47 567.991l-.34-.119a27.847 27.847 0 01-18.12-20.009"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="5.299"
        />
        <path
          clipRule="evenodd"
          d="M3310.06 535.943a21.994 21.994 0 0018.66 19.547l.48-.439c1.01-10.812-7.92-20.085-18.88-19.343l-.26.235z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <rect
          fill="#E48E48"
          height="17.53"
          rx="3.001"
          transform="scale(-1 1) rotate(-77.717 -1330.861 2348.872)"
          width="6.003"
        />
        <rect
          fill="#A3551B"
          height="17.53"
          rx="3.001"
          transform="scale(-1 1) rotate(-39.079 -917.454 4965.867)"
          width="6.003"
        />
        <rect
          fill="#E48E48"
          height="17.53"
          rx="3.001"
          transform="scale(-1 1) rotate(.71 -44042.6 -267584.12)"
          width="6.003"
        />
        <path
          d="M3337.86 549.857l-1.24-5.715m-16.81-13.753l-5.85.073m17.92 20.698l-1.25-5.715m-10.75-8.932l-5.84.073"
          stroke="#A3551B"
          strokeWidth="1.196"
        />
        <rect
          fill="#F39D42"
          height="17.53"
          rx="3.001"
          transform="scale(1 -1) rotate(-53.65 1118.605 -3552.548)"
          width="6.003"
        />
        <path
          d="M3160.71 567.991l-6.08 8.65c-3.79 5.391-11.23 6.702-16.63 2.93l-16.59-11.58"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <path
          d="M3112.25 535.708l34.9 32.015a28.276 28.276 0 01-18.39 20.316l-.36.121-34.9-32.015-.04-.266c-1.55-11.162 7.55-20.932 18.79-20.171z"
          fill={`url(#${id}-cJ)`}
        />
        <path
          d="M3107.39 568.786l.35-.119a27.834 27.834 0 0018.11-20.009"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="5.299"
        />
        <path
          clipRule="evenodd"
          d="M3112.5 535.943c-1.01 10.018-8.69 18.072-18.65 19.547l-.48-.438c-1.01-10.812 7.91-20.086 18.88-19.344l.25.235z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <path
          d="M3193.91 633.154l-11.77 90.949"
          stroke="#4D0D54"
          strokeWidth="13.152"
        />
        <path
          d="M3172 714.789c14.57-10.371 22.33-4.321 24.38 0l-2.16 26.546h-29.32c-1.73-10.371 4.01-22.018 7.1-26.546z"
          fill={`url(#${id}-cK)`}
        />
        <path
          d="M3233.34 632.733l16.83 42.595v47.031m-31.7-141.534l-1.91 51.283"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <ellipse
          cx="3219.06"
          cy="593.2"
          fill="#A3551B"
          rx="29.914"
          ry="23.876"
        />
        <path
          d="M3240.64 713.781c14.57-10.372 22.33-4.322 24.38 0l-2.16 26.546h-29.32c-1.73-10.372 4.01-22.019 7.1-26.546z"
          fill={`url(#${id}-cL)`}
        />
        <path
          d="M3240.75 560.159l6.9 12.252c1.8 3.184 6 4.027 8.89 1.78l9.56-7.458c1.97-1.53 2.44-4.335.94-6.321-9.91-13.141-18.61-13.081-24.29-10.272-3.64 1.8-4 6.482-2 10.019z"
          fill="#A3551B"
        />
        <path
          d="M3247.02 634.64c-3.54-6.493-9.97-8.445-12.75-8.61l9.96 25.459a5.973 5.973 0 007.74 3.389l2.57-1.005c-1.03-3.706-3.99-12.74-7.52-19.233z"
          fill={`url(#${id}-cM)`}
        />
        <path
          d="M3242.97 538.566h-63.17c-4.31 0-7.94 3.28-8.19 7.578-1.49 24.8 2.65 39.118 6.03 46.449 2.03 4.385 6.64 6.413 11.47 6.413h56c3.83 0 7.77-1.079 10.14-4.101 10.78-13.765 2.38-38.023-5.25-52.255-1.38-2.577-4.11-4.084-7.03-4.084z"
          fill={`url(#${id}-cN)`}
        />
        <path
          clipRule="evenodd"
          d="M3250.44 598.192l-5.02-16.467a2.653 2.653 0 00-2.54-1.877h-37.82a2.66 2.66 0 00-2.52 1.818l-5.73 17.34h5.58l4.58-13.858h33.95l4.22 13.858c1.8-.004 3.63-.245 5.3-.814zm-57.26-59.626a51.81 51.81 0 013.7 7.574c1.9 4.928 6.32 9.292 11.61 9.292h19.13c5.28 0 9.57-4.313 8.54-9.494-.48-2.387-1.15-4.912-2.06-7.372h-40.92z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <rect
          fill="#4D0D54"
          height="23.838"
          rx="6.429"
          width="12.858"
          x="3210.2"
          y="525.324"
        />
        <rect
          fill="#FFFBFB"
          height="23.838"
          rx="3.263"
          transform="rotate(30 3207.52 526.355)"
          width="6.526"
          x="3207.52"
          y="526.355"
        />
        <rect
          fill="#FFFBFB"
          height="23.838"
          rx="3.263"
          transform="scale(-1 1) rotate(30 -2594.822 -5755.24)"
          width="6.526"
        />
        <path
          d="M3207.64 500.38c24.69.274 27.45 26.28 25.83 38.841h-22.08l-17.1-16.582c-3.27-8.3-1.59-14.051 1.18-17.616 2.79-3.58 7.63-4.694 12.17-4.643z"
          fill="#4D0D54"
        />
        <path
          d="M3199.55 489.567c34.2-5.28 37.95 27.232 36.01 42.271h-24.35l-18.86-18.29c-5.77-14.632 2.4-22.084 7.2-23.981z"
          fill={`url(#${id}-cO)`}
        />
        <path
          d="M3217.06 528.368v3.297m3.89-3.297v3.297m3.89-3.297v3.297m3.9-3.297v3.297"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M3191.41 498.126c8.84 3.992 15.78 18.491 16.85 30.855l-15.91-15.433c-2.57-6.518-2.37-11.61-.94-15.422zM3177 539.049c-2.98 1.062-5.19 3.774-5.39 7.094-1.49 24.801 2.65 39.119 6.03 46.45 1.1 2.386 2.97 4.074 5.23 5.117 1.39-.646 2.63-1.561 3.6-2.805 10.78-13.765 2.38-38.023-5.24-52.255-.93-1.722-2.45-2.965-4.23-3.601z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <path
          d="M3179.43 560.159l-6.91 12.252c-1.79 3.184-6 4.027-8.88 1.78l-9.57-7.458c-1.96-1.53-2.44-4.335-.94-6.321 9.92-13.141 18.62-13.081 24.3-10.272 3.64 1.8 3.99 6.482 2 10.019z"
          fill={`url(#${id}-cP)`}
        />
        <path
          d="M3194.18 625.979c10.65-.951 41.66 0 41.66 0 0 28.816-41.66 29.957-41.66 0z"
          fill="#A3551B"
        />
        <path
          clipRule="evenodd"
          d="M3205.34 625.576c-4.47.043-8.46.162-11.16.403 0 12.615 7.39 19.716 15.94 21.557 8.8-1.873 16.52-9.149 16.52-21.557 0 0-10.45-.32-21.3-.403z"
          fill={`url(#${id}-cQ)`}
          fillRule="evenodd"
        />
        <path
          d="M3191.14 625.511c3.22-.841 5.54 2.08 7.02 5.494 1.69 3.91 1.25 8.375-.26 12.362-8.07 21.344-16.91 16.997-18.75 10.96-1.99-6.562 5.42-27.104 11.99-28.816z"
          fill="#A3551B"
        />
        <path
          clipRule="evenodd"
          d="M3192.05 625.369c1.01 1.039 1.84 2.475 2.51 4.011 1.69 3.91 1.25 8.375-.26 12.362-4.62 12.245-9.51 16.034-13.18 15.9-.91-.891-1.59-2.067-1.97-3.316-1.99-6.561 5.42-27.103 11.99-28.815.31-.082.61-.128.91-.142z"
          fill={`url(#${id}-cR)`}
          fillRule="evenodd"
        />
        <rect
          fill="#F39D42"
          height="17.53"
          rx="3.001"
          transform="rotate(-77.717 3078.59 547.149)"
          width="6.003"
          x="3078.59"
          y="547.149"
        />
        <rect
          fill="#A3551B"
          height="17.53"
          rx="3.001"
          transform="rotate(-39.079 3085.76 530.99)"
          width="6.003"
          x="3085.76"
          y="530.99"
        />
        <rect
          fill="#F39D42"
          height="17.53"
          rx="3.001"
          transform="rotate(.71 3101.69 523.681)"
          width="6.003"
          x="3101.69"
          y="523.681"
        />
        <path
          d="M3083.56 548.239l1.25-5.715m16.81-13.753l5.85.073m-17.92 20.698l1.24-5.715m10.75-8.932l5.85.072"
          stroke="#A3551B"
          strokeWidth="1.196"
        />
        <rect
          fill="#F39D42"
          height="17.53"
          rx="3.001"
          transform="rotate(126.35 3104.58 544.337)"
          width="6.003"
          x="3104.58"
          y="544.337"
        />
        <circle cx="3188.2" cy="676.869" fill={`url(#${id}-cS)`} r="11.781" />
        <circle cx="3249.12" cy="676.869" fill={`url(#${id}-cT)`} r="11.781" />
        <circle cx="3212.59" cy="518.746" fill="#FFFBFB" r="2.799" />
        <path
          d="M3209.2 515.948l6.19 1.048m18.23-2.097l-6.19 1.049"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="1.957"
        />
        <circle cx="3230.53" cy="517.551" fill="#FFFBFB" r="2.799" />
        <path
          d="M3233.22 740.327h34.19c1.53 0 2.76 1.237 2.76 2.762a2.758 2.758 0 01-2.76 2.763h-34.19v-5.525zm-72.87 2.762a2.758 2.758 0 012.76-2.762h31.43c1.52 0 2.76 1.237 2.76 2.762a2.764 2.764 0 01-2.76 2.763h-31.43a2.758 2.758 0 01-2.76-2.763z"
          fill="#4D0D54"
        />
        <rect
          fill="#FFFBFB"
          height="4.418"
          rx="2.209"
          width="15.249"
          x="3191.6"
          y="566.17"
        />
        <rect
          fill="#FFFBFB"
          height="4.418"
          rx="2.209"
          width="15.249"
          x="3246.6"
          y="566.17"
        />
        <g filter={`url(#${id}-cU)`}>
          <path
            d="M3140.94 654.426c-5.77-2.376-20.22-.99-26.73 0 4.62-8.291 21.01-5.301 29.37-6.085 6.69-.627 11.33-18.732 12.81-27.706 3.22.66 9.67-1.5 9.67-15.421 0-13.92-29.62-47.097-44.43-61.945l8.62 2.613c.61-7.318 1.05-22.582-2.09-25.091-3.14-2.51-20.13-12.198-28.23-16.728v-12.285c2.01-1.22 7.22-3.659 12.02-3.659 6.02 0 51.23-21.955 71.36-21.955 16.1 0 42.95-13.592 54.37-20.388-2.1 14.115 6.59 32.672 16.72 36.07 8.11 2.718 21.5-1.133 27.19-3.398 12 0 36.27-9.085 48.35-14.222.66-.72 1.19-.875 1.57-.676-.5.216-1.02.442-1.57.676-2.25 2.442-5.99 11.391-10.19 35.132-5.44 30.737-30.85 48.18-42.87 53.059 3.71 5.804 4.68 22.631 4.71 30.319 27.6 22.374 32.23 49.051 31.1 59.593-.21-27.183-23.96-50.183-35.81-58.286 0-10.664-7.32-29.884-10.98-38.161 41.3-1.568 56.72-61.161 53.85-67.434-2.3-5.018-15.08.174-21.17 3.398-15.69-1.046-31.46 13.33-37.38 20.648-2.62-8.102-18.56-27.967-30.32-36.33-9.41-6.692-19.6-.698-23.52 3.136-1.92.61-9.78 1.83-25.88 1.83s-41.21 12.371-51.75 18.557c-7.15 1.307-21.17 5.646-20.13 12.546 1.05 6.9 15.42 8.451 22.48 8.364 0 5.75 3.14 33.194 3.14 37.115 0 3.137 21.6 31.452 32.41 45.218 2.55.422 8.17 2.879 10.21 9.326 2.03 6.447-10.18 16.259-16.55 20.359-4.38 11.593-14.59 34.186-20.35 31.811z"
            fill="#2AF5C4"
          />
        </g>
        <g filter={`url(#${id}-cV)`}>
          <path
            d="M3061.91 506.534l-.87 5.042c3.76-5.524 9.27-7.504 11.55-7.804l1.13-6.946-2.38-2.577c-13.09 1.21-14.83-2.98-22.13-10.689-7.3-7.709-5.18-32.223 12.14-34.392 13.85-1.735 21.99 7.23 24.33 11.93-.48-3.675-7.02-13.353-9.66-15.385-2.65-2.032-21.83-8.351-24.56-7.143-2.19.967-7.91 13.557-10.5 19.732l2.06 26.069 12.99 14.78 6.18-.812c8.66 4.846 3.42 7.482-.28 8.195z"
            fill="#2AF5C4"
          />
        </g>
        <g filter={`url(#${id}-cW)`}>
          <path
            d="M3375.02 477.461c-1.37 14.635-15.16 17.195-23.77 16.394 3.27 3.586 8.44 4.456 10.61 4.442 3.77-4.221 14.8-10.531 19.84-13.159 1.3-3.26 3.17-10.568.3-13.723-2.88-3.156-8.02-19.604-10.23-27.433l-13.86-4.765c12.08 6.056 18.82 19.95 17.11 38.244z"
            fill="#2AF5C4"
          />
        </g>
        <ellipse
          cx="1294.72"
          cy="705.634"
          fill={`url(#${id}-cX)`}
          rx="88.332"
          ry="9.519"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="1948.85"
          cy="738.343"
          fill={`url(#${id}-cY)`}
          rx="148.833"
          ry="9.064"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M1812.66 576.94c.67-.551 15.32-23.368 22.55-34.708l8.34 13.455c-8.29 8.588-25.23 25.763-26.76 25.763-1.91 0-4.97-3.822-4.13-4.51z"
          fill="#4D0D54"
        />
        <path
          d="M1826.34 546.742c6.37-.489 7.85 6.83 7.8 10.55.61 1.652 5.56 1.351 7.95.994-3.85 4.052-11.39 11.666-10.78 9.709.62-1.957.26-5.402 0-6.88-8.62 5.504-12.2.408-12.92-2.829 4.36.153 7.57-3.134 8.41-4.74.68-1.284-.02-5.071-.46-6.804z"
          fill={`url(#${id}-cZ)`}
        />
        <path
          d="M1820.44 563.245c2.37.264 7.64 4.618 9.98 6.762l-15.09 13.525-5.45-4.618c2.53-5.333 8.18-15.933 10.56-15.669z"
          fill={`url(#${id}-da)`}
        />
        <path
          d="M1801.8 583.773c0-2.628 5.47-4.258 8.21-4.744l5.47 4.744c-1.27 3.588-4.52 10.765-7.29 10.765-3.47 0-6.39-7.481-6.39-10.765z"
          fill={`url(#${id}-db)`}
        />
        <path
          d="M1797.16 576.316h5.807v28.229h-5.807z"
          fill={`url(#${id}-dc)`}
          transform="rotate(-37.023 1797.16 576.316)"
        />
        <path
          d="M1815.56 608.118l-3.88-16.966 15.24 8.395 3.88 16.966-15.24-8.395zm-102.59-146.594a1.168 1.168 0 01.12-1.491c.07-.08.16-.148.26-.203l.02-.011a1.315 1.315 0 011.68.333l56.11 71.252a191.264 191.264 0 0043.02 40.048l-21.49 16.208a195.704 195.704 0 00-26.7-52.295l-53.02-73.841z"
          fill="#FFFBFB"
        />
        <path
          d="M1811.13 621.09c9.54-26.311 22.41-23.381 27.65-18.627l-4.95 5.53c-11.41-3.027-15.14 27.068-3.2 42.784-.88 33.18-13.68 34.635-11.94 31.725 1.75-2.911-19.5-28.523-7.56-61.412z"
          fill="#4E1F0C"
        />
        <path
          d="M1917.26 584.265l-13.48-13.618c-2.14 8.652 5.7 15.621 9.88 18.024l3.6-4.406z"
          fill="#7584D2"
        />
        <path
          d="M1870.54 679.356c-1.38-6.126-7.49-30.217-10.38-41.497 2.72-4.151 31.23-2.032 24.2 20.271-5.62 17.843-6.54 45.818-6.3 57.576 2.62 3.976 2.38 9.576 1.94 11.879l4.94 8.829h-12.43c-.08-16.467-.59-50.933-1.97-57.058z"
          fill={`url(#${id}-dd)`}
        />
        <path
          d="M1870.54 679.356c-1.38-6.126-7.49-30.217-10.38-41.497 2.72-4.151 31.23-2.032 24.2 20.271-5.62 17.843-6.54 45.818-6.3 57.576 2.62 3.976 2.38 9.576 1.94 11.879l4.94 8.829h-12.43c-.08-16.467-.59-50.933-1.97-57.058z"
          fill={`url(#${id}-de)`}
        />
        <path
          d="M1813.69 520.351c-11.22 7.909-21.33 39.847-24.1 49.212-.49 1.667-.26 3.442.6 4.952l.36.63c1.77 3.095 5.85 3.935 8.69 1.788.57-.427.61-1.387.53-2.091-.16-1.434.78-4.195 6.91-8.739 9.81-7.277 14.61 7.649 25.45-17.263 0 0 21.65 14.044 28.42 43.152-24.67 3.813-30.27 12.111-31.4 33.193-1.12 21.082 3.92 32.52 7.36 47.771 2.76 12.2 1.15 26.466 0 38.633l-3.44 11.047 1.06 4.681-3.27 12.277h14.13l-3.8-11.57 1.59-4.328-.76-12.107c1.17-17.095 6.87-27.103 11.76-44.328 3.51-12.387 4.23-22.579 13.6-21.266 22.39 3.137 20.04 22.839 20.43 38.084v49.718l-5.48 11.681h15.86v-19.612l-4.03-14.277v-27.51c0-29.969 6.53-30.443 9.8-33.494 9.12 7.037 11.2 20.888 11.11 33.494l8.51 40.922v10.934h16.15l-10.67-11.944c1.15-6.807-2.41-13.508-4.33-16.007l-2.3-23.905c2.02-22.124 5.98-55.666 5.76-65.32-.22-9.654-11.97-27.61-17.82-35.38-27.87-61.436-83.5-72.326-96.68-63.028z"
          fill={`url(#${id}-df)`}
        />
        <path
          d="M1852.53 661.354l2.16-8.182h5.98l.88 17.278c.12 2.235-2.44 3.578-4.21 2.216l-1.29-.987a9.83 9.83 0 01-3.52-10.325z"
          fill="#7584D2"
        />
        <path
          d="M1853.5 653.16c-1.65-1.408-.2-3.14.73-3.83.24-2.449.96-5.027 5.75-.583 5.88 5.459-4.41 6.173-6.48 4.413z"
          fill="#7584D2"
        />
        <path
          d="M1846.5 630.124c-1.51-3.342-.63-8.82 0-11.141 3.67-1.764 11.18-4.717 11.94-2.414.75 2.302 1.43 7.025 1.67 9.099v25.068c-1.92 1.337-5.55.876-5.86 0-1.96-5.478-6.24-17.269-7.75-20.612z"
          fill={`url(#${id}-dg)`}
        />
        <path
          d="M1848.87 514.078c-.3-.551 1.25-3.442 2.06-4.819 1.36-.55 2.32 2.483 2.63 4.068-1.44.48-4.39 1.302-4.69.751z"
          fill="#D9D9D9"
        />
        <path
          d="M1889.94 511.2l-22.52-3.368-17.14 8.501c-1.34 1.279-4.12 4.24-4.44 5.855-.32 1.615 29.43 8.359 54.91 48.045l5.5-2.482c0-19.713-5.68-40.596-16.31-56.551z"
          fill={`url(#${id}-dh)`}
        />
        <path
          clipRule="evenodd"
          d="M1898.83 528.397l-5.68-1.271-10.84 13.304-.9 5.813c3.36 3.292 6.79 7.035 10.22 11.294h14.12c-.96-9.934-3.3-19.899-6.92-29.14z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M1839.87 499.154l-.16-3.664h5.06l2.14 6.811h-2.49l-4.55-3.147z"
          fill="#6262B7"
        />
        <path
          d="M1851.65 512.172c-4.58-5.692-7.09-13.111-7.77-16.11l13-5.806 7.61 12.512-2.29 7.033-10.55 2.371z"
          fill="#CE5E60"
        />
        <path
          clipRule="evenodd"
          d="M1845.74 501.761c1.31 3.256 3.26 7.122 5.91 10.411l10.55-2.371.81-2.51-3.33-5.478a6.557 6.557 0 00-8.28-2.583l-5.66 2.531z"
          fill="#F3898A"
          fillRule="evenodd"
        />
        <path
          d="M1848.66 513.918c1.08 0 12.42-8.154 17.96-12.231 1.61.675 2.84 4.712 1.74 7.242-1.09 2.531-11.69 9.375-12.7 9.46-.81.067-5.01-2.953-7-4.471z"
          fill={`url(#${id}-di)`}
        />
        <path
          d="M1844.75 618.714V588.92l10.6-9.002 4.42 6.496.86 5.626-1.28 26.674h-14.6z"
          fill={`url(#${id}-dj)`}
        />
        <path
          d="M1892.7 545.762c3.8-6.226 9.01-6.993 12.65-6.278 1.58.309 1.97 2.141 1.27 3.583-1.83 3.747-.97 6.525.65 8.377 1.32 1.502 1.8 4.098.59 5.684-1.23 1.602-1.98 3.14-2.4 4.546-.69 2.277-3.73 5.212-6.01 4.517l-9.14-2.797c-.79-.239-1.43-.826-1.58-1.631-.56-3.026-.31-8.977 3.97-16.001z"
          fill="#7584D2"
        />
        <path
          clipRule="evenodd"
          d="M1879.38 509.576c-4.31 1.636-9.47 5.257-9.95 11.923-.56 7.787-.33 11.975-.09 13.512.44.314.87.636 1.32.966l14.71 6.2 1.44-8.034 3.47 6.531c2.88-.343 8.89-2.131 9.89-6.531.35-1.534.14-4-.6-6.813-.37-.897-.74-1.788-1.13-2.67-3.47-7.879-10.77-12.972-19.06-15.084z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M1870.4 522.483c.63-8.745 9.3-12.249 13.56-12.907 12.6 2.588 18.42 20.05 17.17 25.551-.99 4.4-7.01 6.188-9.89 6.531l-3.46-6.531-1.45 8.034-15.93-6.717c-.27-1.01-.64-5.216 0-13.961z"
          fill="#7584D2"
        />
        <path
          clipRule="evenodd"
          d="M1894.67 516.596c.2.243.39.491.58.741-2.79.61-6.75 2.304-9.82 5.468-3.14 3.244-5.37 8.049-4.45 14.89a.419.419 0 01-.36.48.427.427 0 01-.48-.365c-.97-7.112 1.36-12.175 4.68-15.599 3.06-3.159 6.96-4.909 9.85-5.615zm-5.78-5.109c.34.199.67.408 1 .628-2.79.631-6.68 2.321-9.71 5.442-3.14 3.244-5.37 8.05-4.44 14.89a.433.433 0 01-.37.48.427.427 0 01-.48-.365c-.96-7.112 1.36-12.175 4.68-15.599 2.88-2.969 6.5-4.693 9.32-5.476z"
          fill="#6262B7"
          fillRule="evenodd"
        />
        <path
          d="M1863.11 507.06l-5.64-11.99 9.52-4.584c1.7 0 3.37.497 4.79 1.43l9.67 6.328-18.34 8.816z"
          fill={`url(#${id}-dk)`}
        />
        <path
          clipRule="evenodd"
          d="M1876.22 494.822l.82.533-15.56 8.241-.36-.772 15.1-8.002zm-3.94-2.579l.82.534-13.39 7.066-.36-.772 12.93-6.828z"
          fill="#6262B7"
          fillRule="evenodd"
        />
        <path
          d="M1849.89 604.815l-7 9.206a2.615 2.615 0 00.2 3.401l6.99 7.318a2.627 2.627 0 003.76.037l7.28-7.322a2.625 2.625 0 00.2-3.478l-7.28-9.202c-1.06-1.344-3.11-1.324-4.15.04z"
          fill="#7584D2"
        />
        <path
          d="M1862.76 476.38c-4.18-3.103-9.88-1.528-12.2-.352l4.58 13.823 2.33 5.501 10.29-4.796c.08-3.432-.83-11.072-5-14.176z"
          fill={`url(#${id}-dl)`}
        />
        <path
          d="M1866.99 468.792c-2.37 1.544-5.04 4.997-6.08 6.531 0 .936 1.28 1.281 1.93 1.336 3.56-5.581 8.41-3.216 10.39-1.336 0 6.532 3.11 16.477 10.54 16.032 7.42-.445.29-8.758 0-18.852-.24-8.075-7.13-6.927-10.54-5.344-2.81-4.727-7.86-1.734-6.24 1.633z"
          fill="#E6882B"
        />
        <path
          d="M1814.89 519.223c-3.48-3.898-4.61-9.363-1.91-17.735 4.79 2.138 7.77 5.137 1.91 17.735z"
          fill="#9B5F2B"
        />
        <path
          d="M1844.88 484.343l-5.3 11.356 12.33 2.703c.43-2.941 5.62-5.98 7.46-7.422l-1.41-5.772c2.17.577 6.62 1.212 7.14-.865.65-2.595-1.3-3.244-5.73-3.785-4.44-.541-1.62-3.569-6.71-4.542-2.95-.565-5.24 1.566-6.62 3.647-.91 1.369-1.16 3.037-1.16 4.68z"
          fill={`url(#${id}-dm)`}
        />
        <path
          clipRule="evenodd"
          d="M1845.1 481.996l10.1 2.537c.23.058.46-.081.52-.309a.424.424 0 00-.31-.518l-10.09-2.534c-.09.269-.16.544-.22.824z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M1858.05 582.317c.64 1.465 1.23 2.857 1.75 4.152l-3.18 3.835a8.528 8.528 0 01-11.74 1.33l-5.45-4.163 10.68-19.692c1.6 2.827 3.51 5.175 4.85 7.899l3.09 6.639z"
          fill={`url(#${id}-dn)`}
        />
        <path
          clipRule="evenodd"
          d="M1822.91 536.243s-14.98-1.673-16.65-9.052c-.89-3.933 1.25-7.269 3.55-9.465 1.68-1.601 3.97-2.338 6.28-2.611 55.57-6.578 86.74 41.746 94.74 66.842-2.58.169-5.68.05-9.08-.382-1.19-6.259-3.22-13.05-4.98-18.21a35.151 35.151 0 00-1.84-5.065c.53 1.372 1.17 3.1 1.84 5.065 1.71 6.093 1.95 12.527 1.62 17.699a78.24 78.24 0 01-10.87-2.757c-.31-3.191-1.39-6.339-2.14-7.978.84 2.809.88 5.467.65 7.47a76.923 76.923 0 01-4.75-1.851c-.64-6.499-1.87-15.565-2.85-22.339-.14-1.746-.35-3.235-.64-4.331.19 1.275.41 2.74.64 4.331.45 5.807.13 14.451-.29 20.905-3.76-1.833-7.4-4.02-10.72-6.585a614.14 614.14 0 00-5.65-29.51c-.16-.895-.35-1.74-.57-2.538.16.696.35 1.548.57 2.538 1.1 5.939 1.15 14.038.43 24.858-3.23-3.347-5.92-7.182-7.77-11.535a402.7 402.7 0 01-1.3-3.044v-.008c-8.35-19.582-8.74-20.511-15.69-23.942-5.38-2.658-13.62-4.775-17.06-5.661l-.77-.196c-3.59 8.3 3.3 17.352 3.3 17.352z"
          fill="#FFFBFB"
          fillRule="evenodd"
        />
        <path
          d="M1820.24 520.382c-2.13-4.771 1.02-13.036 6.13-20.193 3.92 3.494 2.84 16.777-6.13 20.193z"
          fill="#9B5F2B"
        />
        <path
          d="M1803.97 563.595c48.74 40.72 77.75 4.615 86.19-18.615l-4.79-5.268c-17.11 34.962-53.21 44.896-79.55 21.814-.89-.788-2.35-.169-2.35 1.026 0 .398.19.787.5 1.043z"
          fill="#E6882B"
        />
        <path
          clipRule="evenodd"
          d="M1841.31 727.716h-7.29l-3.16 11.878h14.13l-3.8-11.57.12-.308z"
          fill="#4E1F0C"
          fillRule="evenodd"
        />
        <path
          d="M1880.14 726.697c-.04.333-.09.631-.14.888l4.94 8.829h-12.43c-.01-2.796-.04-6.11-.08-9.717h7.71z"
          fill="#4E1F0C"
        />
        <path
          clipRule="evenodd"
          d="M1898.19 732.256h-10.38v1.541l-5.48 11.681h15.86v-13.222z"
          fill="#4E1F0C"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M1929.52 724.516h-6.05l.11.485v10.934h16.15l-10.21-11.419z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M1240.34 698.196c-2.22 4.181-8.15 11.934-14.08 9.491-4.08-1.677 1.41-6.032 3.66-4.258"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="3.225"
        />
        <path
          d="M1303.71 639.298c-4.66-1.685-9.62 2.354-11.52 4.585 0 .991 1.4 1.652 2.11 1.859 2.1-2.231 6.94-4.09 6.94-1.859 0 1.784-1.82 4.626-2.73 5.824l2.73 1.735c2.6-.992 8.3-10.037 2.47-12.144z"
          fill="#413776"
        />
        <path
          d="M1261.11 589.332c-18.01 5.812-16.58 51.028 14.65 40.53-22.3-5.396 17.71-15.79 10.05-38.04s-15.98-22.228-22.52-24.649c4.36 2.179 20.35 14.893-2.18 22.159z"
          fill={`url(#${id}-do)`}
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M1222.66 639.298c4.66-1.685 9.62 2.354 11.52 4.585 0 .991-1.4 1.652-2.1 1.859-2.11-2.231-6.94-4.09-6.94-1.859 0 1.784 1.82 4.626 2.72 5.824l-2.72 1.735c-2.6-.992-8.3-10.037-2.48-12.144z"
          fill="#413776"
        />
        <path
          d="M1281.29 634.06h-37.04l-4.05 5.924c-14.7 5.924-24.68 17.46-24.68 30.72 0 19.306 21.15 34.956 47.25 34.956 26.09 0 47.24-15.65 47.24-34.956 0-13.26-9.97-24.795-24.68-30.72l-4.04-5.924z"
          fill={`url(#${id}-dp)`}
        />
        <path
          d="M1286.92 698.196c2.22 4.181 8.15 11.934 14.09 9.491 4.07-1.677-1.41-6.032-3.67-4.258"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="3.225"
        />
        <path
          d="M1233.26 632.828c-.36-1.517.8-2.966 2.35-2.966h54.31a2.42 2.42 0 012.36 2.966l-.71 3.058a2.415 2.415 0 01-2.36 1.872h-52.89c-1.12 0-2.1-.776-2.35-1.872l-.71-3.058z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M1246.76 703.602c5 1.332 10.39 2.058 16.01 2.058 26.09 0 47.24-15.65 47.24-34.956 0-13-9.59-24.342-23.82-30.365 6.19 22.103 2.59 55.861-39.43 63.263z"
          fill="#413776"
          fillRule="evenodd"
        />
        <ellipse
          cx="1600.39"
          cy="601.576"
          fill={`url(#${id}-dq)`}
          rx="124.645"
          ry="18.862"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M1209.29 540.509c-30.17-10.481-30.04 13.038-26.2 26.108 110.02 11.229 216.38 3.297 255.8-2.072-.84-15.172-13.18-16.473-19.24-15.227 7.84-31.16-16.36-49.929-37.89-16.651-3.44-9.3-13.67-7.788-18.36-5.869-.9-48.191-40.17-44.848-43.8-9.264-12-8.895-21.9-2.235-25.34 2.207-8.59-12.381-25.93-11.595-31.67 4.648-21.16-41.199-49.6-20.132-39.94 4.933-11.73-1.936-13.79 6.651-13.36 11.187z"
          fill="#3FC7C0"
        />
        <path
          d="M1289.23 541.656c-1.2-6.741-4.73-19.387-9.25-16.042-4.52 3.345 4.29 12.088 9.25 16.042z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M1372.21 570.753c.17-17.341-14.39-25.003-28.25-3.811-2.3-6.995-9.68-5.989-13.09-4.611.25-36.044-28.04-34.02-31.32-7.457-8.46-6.797-15.7-1.937-18.26 1.343-5.94-9.362-18.43-8.984-22.86 3.092-14.44-31.062-35.28-15.655-28.81 3.204-7.68-1.455-9.71 3.773-9.83 7.275 59.76 4.764 115.38 3.461 152.42.965zm-156.15-1.27c-3.27-.888-5.95-1.07-8.12-.716 2.71.251 5.42.49 8.12.716z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          d="M1325.99 704.272c-41.85 11.158-64.28 11.158-64.28 11.158h226.28c-10.93-3.745-40.06-7.343-40.06-7.343s.78-4.553-4.36-5.323c-4.43-.663-10.49 2.24-10.49 2.24s-2.19-16.577-20.69-19.967c-18.49-3.39-29.9 1.875-39.57 20.702 0 0-6.85-3.67-11.14-3.67-4.28 0-7.7 1.761-7.7 1.761s-2-3.228-9.71-3.963c-7.72-.733-14.06 3.28-18.28 4.405z"
          fill="#fff"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M1579.16 560.028l12.05 30.63-9.98 18.585-70.9 2.753-23.06-13.422V571.73l36.14-18.585 55.75 6.883z"
          fill="#3D3271"
        />
        <path
          clipRule="evenodd"
          d="M1579.15 560.026l-11.34 21.684-56.1 6.195-3.98 22.574-20.46-11.905V571.73l36.14-18.585 55.74 6.881z"
          fill={`url(#${id}-dr)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M1048.64 576.205l-28.62.104-228.461.838-45.797.168-93.188.342-22.51.082-12.686.047-48.291.173-18.339.069c4.61-1.21 9.159-2.138 13.596-2.838 25.944-4.096 47.933-.328 55.303 1.24 1.718.367 2.648.613 2.648.613s.889-1.369 3.343-2.886c1.983-1.244 5.019-2.583 9.445-3.356 7.432-1.301 15.027-.022 19.597 1.084 2.647.644 4.273 1.231 4.273 1.231s-.644-1.866-.951-4.108c-.388-2.856-.215-6.329 2.566-7.34 4.947-1.801 11.316 0 11.316 0s8.495-12.748 29.022-14.692c19.627-1.853 35.369 1.616 36.709 1.927a.688.688 0 01.092.017c.092-.099.184-.203.276-.302a32.45 32.45 0 011.492-1.543c0-.008.021-.021.031-.03a41.395 41.395 0 014.252-3.607c8.955-6.618 23.379-11.954 44.908-10.286 29.256 2.264 32.855 18.433 32.855 18.433 33.325-6.186 59.157 5.094 59.157 5.094s13.443-2.061 26.19 2.065c6.829 2.207 9.384 6.052 10.284 9.149.286.968.409 1.867.439 2.614.379-.613 1.156-1.231 2.638-1.672.02-.009.051-.017.082-.026 4.252-1.214 11.326-.484 11.326-.484v-.008c-.041-.186-1.206 3.546 0 .008 0-11.646 21.725-20.139 40.237-20.571 19.904-.466 41.716 10.99 54.216 23.552-2.09-1.24 5.05 2.549 0 0 1.18.687 1.8 1.08 1.8 1.08 9.93-3.944 20.75 3.819 20.75 3.819z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M1589.64 713.042l24.43 62.141-20.25 37.704-143.83 5.585-46.78-27.23v-54.461l73.31-37.704 113.12 13.965z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M1589.6 713.038l-23.01 43.991-113.81 12.568-8.08 45.797-41.49-24.152v-54.461l73.31-37.704 113.08 13.961z"
          fill={`url(#${id}-ds)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M749.341 717.824c28.187 15.284-193.271 61.123-438.135 56.365-244.865-4.758-303.149-35.385-294.33-56.649 8.818-21.263 99.981-54.669 294.33-54.669s274.067 10.925 294.621 18.567c20.553 7.642-30.803 11.54-30.419 14.839.339 2.937 145.747 6.264 173.933 21.547z"
          fill={`url(#${id}-dt)`}
          fillRule="evenodd"
        />
        <ellipse
          cx="238.635"
          cy="706.909"
          fill={`url(#${id}-du)`}
          rx="124.615"
          ry="10.896"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="598.965"
          cy="720.207"
          fill={`url(#${id}-dv)`}
          rx="112.46"
          ry="10.408"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M166.201 548.485c15.778-9.253 32.772-5.635 39.297-2.669l4.597 64.062-44.784-1.038.89-60.355z"
          fill="#CCDAFF"
        />
        <path
          d="M214.643 598.761h-51.699m51.699-11.946h-51.699m51.699-11.946h-51.699m51.699-11.945h-51.699"
          stroke="#4D0D54"
          strokeWidth="3.285"
        />
        <path
          d="M214.643 550.978h-51.699"
          stroke="#CCDAFF"
          strokeWidth="3.285"
        />
        <path
          d="M178.728 546.649c6.283 17.857 15.11 7.441 18.738 0l1.103-6.2h-20.667l.826 6.2z"
          fill="#CE5E60"
        />
        <path
          d="M167.286 622.346h39.271v42.655h-10.846l-3.268-5.436-1.521 5.436h-23.636v-42.655z"
          fill="#1E4C95"
        />
        <path
          d="M255.732 546.189l-13.665 25.854c-1.379 4.672-2.938 15.627 1.858 22.08l.759-.543a19.734 19.734 0 007.26-9.846l10.821-32.644 6.628-8.592a7.89 7.89 0 00-.299-10.005l-2.381-2.732a1.972 1.972 0 00-3.268.447l-4.354 9.138-1.093-4.216a2.117 2.117 0 00-4.131.914l1.865 10.145zM114.418 606.85l12.039-5.284c4.802.071 15.573 1.816 20.241 8.222l-.839.636a19.453 19.453 0 01-11.157 3.942l-17.732.542-10.032 3.722a7.784 7.784 0 01-9.332-3.215l-1.874-3.043a1.945 1.945 0 011.38-2.946l9.878-1.42-3.648-2.265a2.087 2.087 0 012.072-3.621l9.004 4.73z"
          fill="#F3898A"
        />
        <path
          d="M166.493 608.227h43.63l5.4 62.413h-15.301l-10.943-45.198-16.176 45.198h-14.196l7.586-62.413zm-8.068 83.726V672.67h16.451a42.125 42.125 0 01-3.038 10.735l-3.671 8.475c-.173.4-.163.855.029 1.247l.366.749a1.489 1.489 0 01-.492 1.88l-.136.094a1.49 1.49 0 00-.576 1.67l.401 1.282c.09.288.135.584.149.884.103 2.119.687 8.597-.55 8.888h-23.935a2.042 2.042 0 01-1.896-2.8 5.45 5.45 0 012.421-2.743l11.786-6.516a5.214 5.214 0 002.691-4.562zm50.887-10.822h-3.179a6.43 6.43 0 01-6.431-6.431v-.406a2.718 2.718 0 012.718-2.718h11.139a2.654 2.654 0 012.654 2.654 6.9 6.9 0 01-6.901 6.901z"
          fill="#4D0D54"
        />
        <path
          d="M211.211 707.33l-5.662-27.823a2.49 2.49 0 114.908-.831l3.817 28.135a1.554 1.554 0 01-3.063.519z"
          fill="#4D0D54"
        />
        <path
          d="M216.608 664.718h-19.93l1.611 10.003h19.93l-1.611-10.003zm-59.1 0h19.929l-1.611 10.003h-19.93l1.612-10.003z"
          fill="#1E4C95"
        />
        <path
          d="M171.092 571.38v-26.383l-16.081 9.297-21.554 40.971 17.282 8.026 9.548-12.061 1.508 13.82-11.056 62.064h9.548l10.805-95.734zm48.197-20.309l-17.764-7.671v29.472l13.323 94.874h19.782l-12.111-51.272-3.23-33.913 15.341 11.117 2.802-24.487-18.143-18.12z"
          fill="#3469BA"
        />
        <path
          d="M130.493 590.015l25.918 15.33-7.152 8.104-22.309-12.017 3.543-11.417z"
          fill="#1E4C95"
        />
        <path d="M209.02 608.227h-43.321v10.16h43.321z" fill="#0C8EA8" />
        <path
          d="M204.72 608.227h-34.721l-.544 10.16h36.352l-1.087-10.16z"
          fill="#09A8C8"
        />
        <path
          d="M235.426 563.407l8.181 5.182c0 12.872 2.727 23.544 4.091 27.271l-12.272 2.727c-3.054-3.49-1.273-24.908 0-35.18zm-18.835-13.937l-20.067-8.878v6.139a17.13 17.13 0 013.796 9.587l1.129 15.805 9.524 67.729-3.78-56.996 5.276-23.553h-5.276l5.826-2.748 3.572-7.085zm-58.464.995l15.142-6.484 4.84-1.255a22.885 22.885 0 00-4.84 14.074v15.492l-10.106 68.633 4.362-58.291-5.276-22.695h5.276l-5.826-2.647-3.572-6.827z"
          fill="#1E4C95"
        />
        <rect
          height="5.531"
          rx="1.311"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.324"
          transform="matrix(-1 0 0 1 192.477 609.956)"
          width="8.601"
          x="-0.662"
          y="0.662"
        />
        <path
          d="M201.201 505.545l-28.708-.455-.688 3.637a45.368 45.368 0 00.423 18.846l1.776 7.531h27.197v-29.559z"
          fill="#F3898A"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.841"
          ry="2.047"
          transform="matrix(-1 0 0 1 187.72 521.047)"
        />
        <path
          d="M186.019 613.383h-3.205"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.324"
        />
        <path
          d="M194.596 508.538v6.191c0 1.59.193 3.175.573 4.719l.856 3.476a.1.1 0 00-.155-.085c-1.967 1.251-4.716 2.572-7.554 3.199-5.56 1.229-14.197.542-15.921-1.429-.985 2.599-3.064 14.06-3.494 19.651-.431 5.592 5.914 8.244 9.14 8.871l2.957-2.688s7.08 1.869 11.022 0c3.941-1.868 10.216-6.183 11.29-11.559.764-3.822-.554-8.778-1.831-12.322l3.212-16.37-10.095-1.654z"
          fill="#4D0D54"
        />
        <path
          d="M180.105 535.425c1.025-1.624 7.336-1.37 8.948-.866-3.043-2.815-7.523-5.462-8.948.866z"
          fill="#fff"
        />
        <path
          d="M191.514 513.649c-1.222-.201-4.193-.194-6.309 1.432m-13.234-1.422c1.095-.253 3.738-.382 5.556 1.122"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="0.87"
        />
        <path
          d="M214.534 509.326l-11.129 9.449c-16.316-12.409-28.247-9.001-32.173-5.745l-4.844-7.751c-1.643-2.628.247-6.037 3.346-6.037h3.796l8.501-9.425c2.461-2.728 6.787-2.579 9.054.313l12.32 15.719h9.852c1.837 0 2.677 2.288 1.277 3.477z"
          fill="#BA3491"
        />
        <path
          d="M169.382 510.07l-2.994-4.791c-1.643-2.628.247-6.037 3.346-6.037a20.205 20.205 0 007.468-4.665l4.829-4.76c2.461-2.728 6.787-2.579 9.054.313l6.492 6.994a28.98 28.98 0 0015.68 8.725c1.837 0 2.677 2.288 1.277 3.477l-7.812 6.632c-18.772-13.446-32.513-9.695-37.34-5.888z"
          fill="#4D0D54"
        />
        <ellipse
          fill="#F3898A"
          rx="3.479"
          ry="5.762"
          transform="scale(-1 1) rotate(-18.403 1509.428 889.227)"
        />
        <path
          d="M200.656 525.615c.175-2.148 1.447-6.429 5.14-6.359"
          stroke="#CE5E60"
          strokeLinecap="round"
          strokeWidth="0.544"
        />
        <ellipse
          fill="#4D0D54"
          rx="3.479"
          ry="4.208"
          transform="scale(-1 1) rotate(-58.069 381.34 418.128)"
        />
        <path
          d="M194.664 513.213l-23.673 8.793"
          stroke="#4D0D54"
          strokeWidth="0.986"
        />
        <path
          d="M87.462 509.512c-16.163 9.769 7.513 68.2 13.456 93.243l5.011-.402-16.297-79.19-1.212-2.76a17.057 17.057 0 01-.959-10.891z"
          fill="#fff"
        />
        <path
          d="M103.046 602.584l2.883-.231-16.297-79.19-1.212-2.76a17.06 17.06 0 01-.958-10.892c-.411.249-.8.522-1.167.818-6.87 10.348 9.778 68.294 16.751 92.255z"
          fill="#CCDAFF"
        />
        <path
          d="M109.045 623.588l-3-21.043-5.36-.175 6.239 21.187 2.121.031z"
          fill="#4D0D54"
        />
        <path
          d="M109.88 615.53c0 1.108-4.047 2.237-6.07 2.663-.817-2.875-2.429-9.244-2.343-11.715.085-2.471 4.011-2.591 5.964-2.343.816 3.337 2.449 10.288 2.449 11.395z"
          fill="#F3898A"
        />
        <path
          d="M115.205 600.055c-8.468 3.452-22.46 12.744-10.689 22.293-11.24 3.461-24.406-21.077 10.689-22.293z"
          fill="#F3A21A"
        />
        <circle
          cx="108.369"
          cy="625.947"
          fill="#F3A21A"
          r="3.597"
          transform="rotate(148.848 108.369 625.947)"
        />
        <path
          d="M632.15 654.003c3.99 9.895-2.533 21.911-5.858 27.165l-87.948-21.105 18.964-10.371 52.299-9.254c6.737 0 18.553 3.67 22.543 13.565z"
          fill="#FFFEFC"
        />
        <path
          clipRule="evenodd"
          d="M608.111 640.703c-12.48 2.832-19.61 12.082-19.61 12.082 1.038 6.788 2.964 15.006 5.832 22.309l31.959 6.074c3.325-5.253 9.848-17.27 5.858-27.165-3.99-9.894-15.806-13.565-22.543-13.565l-1.496.265z"
          fill="#CACFF5"
          fillRule="evenodd"
        />
        <path
          d="M588.783 652.387l37.337 29.583h-63.656l-24.127-21.929 50.446-7.654z"
          fill="#4D0D54"
        />
        <path
          d="M562.52 670.587l26.009 15.866H538.92l16.701-15.206a5.777 5.777 0 016.899-.66z"
          fill="#C77F17"
        />
        <path
          d="M591.41 666.735l26.009 15.866H567.81l16.701-15.205a5.779 5.779 0 016.899-.661z"
          fill={`url(#${id}-dw)`}
        />
        <path
          clipRule="evenodd"
          d="M591.086 666.552c1.779 1.4 3.038 3.115 1.826 4.613-2.45 3.026-5.32 8.15 3.059 11.436h21.448l-26.009-15.865a6.543 6.543 0 00-.324-.184z"
          fill="#C77F17"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M594.608 643.092c-2.997 1.691-5.704 4.144-7.793 6.581l-35.253 6.056 11.318-7.023 31.728-5.614z"
          fill="#74205E"
          fillRule="evenodd"
        />
        <path
          d="M598.124 653.837c7.747 6.693 25.483 21.303 25.483 21.303 14.881-19.469-5.607-40.568-25.483-21.303z"
          fill="#4D0D54"
        />
        <path
          d="M626.262 680.887v42.041H518.479l10.158-35.551 48.248-6.49h49.377z"
          fill="#CACFF5"
        />
        <path
          clipRule="evenodd"
          d="M566.164 722.929h-47.685l10.158-35.552 48.081-6.467-10.554 42.019z"
          fill={`url(#${id}-dx)`}
          fillRule="evenodd"
        />
        <path
          d="M571.012 685.636l-8.405 32.964h-37.745l6.795-28.468 39.355-4.496z"
          fill="#74205E"
        />
        <path
          clipRule="evenodd"
          d="M530.46 695.148l38.846-2.823-.296 1.163-38.828 2.822.278-1.162zm-1.866 7.817l38.437-1.715-.294 1.152-38.418 1.715.275-1.152zm-2.011 8.425l38-.541-.291 1.143-37.982.541.273-1.143z"
          fill="#FBF4EB"
          fillRule="evenodd"
          opacity="0.4"
        />
        <path
          d="M581.439 684.623l-8.365 37.132h49.776v-37.132h-41.411z"
          fill="#4D0D54"
        />
        <path
          d="M668.933 723.075c-8.945-4.386-24.817-12.739-33.94-19.119-3.834-2.681-9.41-3.389-13.509-1.134-14.676 8.075-40.651 18.562-69.985 20.253h-16.002c5.411.324 10.76.302 16.002 0h117.434z"
          fill={`url(#${id}-dy)`}
        />
        <path
          clipRule="evenodd"
          d="M627.822 701.498c-3.135 3.288-6.401 8.389-3.087 11.703 2.263 2.263 7.255 4.78 12.241 7.294a254.5 254.5 0 015.027 2.58h26.93c-8.945-4.386-24.816-12.74-33.94-19.119-2.055-1.438-4.611-2.308-7.171-2.458z"
          fill="#C77F17"
          fillRule="evenodd"
        />
        <path
          d="M524.135 703.323c-2.88 12.862 7.173 18.405 12.852 19.525h-40.556c8.064-11.327 22.025-17.766 27.704-19.525z"
          fill={`url(#${id}-dz)`}
        />
        <ellipse
          cx="624.257"
          cy="720.175"
          fill="#C77F17"
          rx="3.072"
          ry="0.862"
        />
        <ellipse
          cx="616.421"
          cy="715.62"
          fill="#C77F17"
          rx="2.637"
          ry="0.862"
        />
        <ellipse
          cx="605.036"
          cy="721.314"
          fill="#C77F17"
          rx="2.637"
          ry="0.862"
        />
        <ellipse
          cx="514.752"
          cy="715.882"
          fill="#C77F17"
          rx="3.44"
          ry="1.124"
        />
        <ellipse
          cx="419.584"
          cy="746.511"
          fill={`url(#${id}-dA)`}
          rx="132.394"
          ry="10.549"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M397.921 741.561l-.663-37.216 10.3 4.865 1.038 32.351h-10.675zm-54.326-2.227l9.355-34.989 10.301 4.865-8.981 30.124h-10.675z"
          fill="#CE5E60"
        />
        <path
          d="M362.662 645.183c5.443-5.755 34.307-6.104 41.529-9.028 2.408 4.127 4.9 8.77 6.964 22.958 2.064 14.187-1.72 47.118-3.095 66.034h-11.998l-12.506-60.719s-14.101 41.459-20.894 60.719h-17.635s12.192-74.208 17.635-79.964z"
          fill="#4D0D54"
        />
        <path
          d="M345.987 711.022h24.42l-5.774 19.226h-24.448l5.802-19.226z"
          fill="#BA3491"
        />
        <path
          d="M356.413 733.821l-.486 16.706-37.3-1.007c-1.025-.534-2.093-3.03 1.828-8.741 3.921-5.71 13.651-3.014 18.026-.953l6.406-6.721 11.526.716z"
          fill="#4D0D54"
        />
        <path
          d="M410.381 711.508h-18.56v19.016h24.341l-5.781-19.016z"
          fill="#BA3491"
        />
        <path
          d="M385.283 568.642c-13.918 1.844-36.111 12.957-40.429 16.317 0 18.19-3.42 24.948-6.828 27.462 7.177 0 24.895-7.095 29.516-10.085 1.292 2.922 1.578-.731 1.578 5.305 0 6.035-.607 29.932-3.937 33.399 15.905 1.699 39.314 5.821 39.892 3.888 2.46-8.227 8.415-24.445 9.978-32.601l4.486 2.012 28.136 4.083c-13.421-53.562-44.993-52.086-62.392-49.78z"
          fill="#CCDAFF"
        />
        <path
          clipRule="evenodd"
          d="M413.514 618.545l-11.225-3.741c.873 8.121-.362 24.524-12.282 25.169-8.316.449 2.878 1.774 15.694 2.922.743-2.356 1.668-5.139 2.651-8.095 1.783-5.361 3.753-11.288 5.162-16.255z"
          fill="#A3B7EE"
          fillRule="evenodd"
        />
        <path
          d="M376.846 538.106c3.113-2.147 5.649-.894 8.065 0 6.763 6.227 2.818 21.291 0 28.045-4.079 3.65-9.125 3.757-11.138 3.355 3.489-1.745.676-12.018-1.068-17.922-1.396-4.724 1.861-9.632 3.023-12.226l1.118-1.252z"
          fill="#4D0D54"
        />
        <path
          d="M393.569 572.112c-1.986 3.269-10.309 5.606-10.309-2.07v-8.186c1.664-.858 8.129-1.073 10.578-1.341 0 0 1.717 8.328-.269 11.597z"
          fill="#F3898A"
        />
        <path
          clipRule="evenodd"
          d="M394.46 565.253c-3.673 1.54-8.573.46-11.2-.537v-2.86c1.234-.636 5.107-.919 8.026-1.132a81.87 81.87 0 002.552-.209s.448 2.174.622 4.738z"
          fill="#CE5E60"
          fillRule="evenodd"
        />
        <path
          d="M377.745 556.132c-.673-10.876.565-18.271 1.955-20.693 4.725-.487 16.804.167 21.598 5.077 4.793 4.91 1.51 13.688-.731 17.463-5.13 4.551-11.978 5.174-17.114 4.613-3.259-.355-5.506-3.188-5.708-6.46z"
          fill="#F3898A"
        />
        <path
          d="M383.328 550.208c-.342.809-1.027 2.69-1.027 3.736 0 1.046 1.121 1.432 1.681 1.494m1.137 3.654c.655.289 2.221.616 3.242-.389"
          stroke="#CE5E60"
          strokeLinecap="round"
          strokeWidth="1.113"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.682"
          ry="1.661"
          transform="matrix(-1 0 0 1 388.164 548.615)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.682"
          ry="1.661"
          transform="matrix(-1 0 0 1 379.258 548.615)"
        />
        <path
          d="M391.262 543.466c-.888-.47-3.175-1.234-5.224-.531m-3.656.14c-.947-.334-3.323-.751-5.244.247"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="1.113"
        />
        <path
          d="M405.848 542.703c3.129.747 11.098 4.664 17.935 14.359-3.086-.686-10.993-4.517-17.935-14.359z"
          fill="#922671"
        />
        <path
          d="M414.546 558.983c-3.847-3.022-7.009-11.439-8.11-15.269 4.531 2.066 12.419 14.323 15.796 20.194-.96-.382-3.84-1.903-7.686-4.925z"
          fill="#922671"
        />
        <path
          d="M377.499 554.626c-.434-14.061 4.243-14.181 5.112-17.337-2.087-1.701-5.378.329-6.038.925-1.176 2.979.995 18.641.926 16.412z"
          fill="#4D0D54"
        />
        <path
          d="M391.242 619.109c-.099-16.751 3.168-43.525 4.813-52.375 5.132-1.04 15.855 2.831 20.077 4.807-2.505 8.498-9.24 22.958-7.642 31.222 1.598 8.263 4.68 9.813 7.451 10.346l-2.771 13.577-21.928-7.577zm-23.75 2.888c0-3.408-1.007-34.391 2.511-48.586 1.63-1.926 9.093-5.376 12.968-5.375-4.015 15.233-2.511 50.955-2.511 50.955l-12.968 3.006z"
          fill="#3469BA"
        />
        <path
          d="M410.236 649.052c.883-1.726 1.165-4.421.102-7.175-.2-.517-.632-.909-1.148-1.112-19.201-7.579-34.717-7.664-40.534-7.743a2.182 2.182 0 00-1.317.414c-6.316 4.586-8.322 8.355-9.124 11.905-.311 1.381.884 2.591 2.299 2.532 11.211-.465 35.433 1.065 47.977 2.034.709.055 1.422-.221 1.745-.855z"
          fill="#BA3491"
        />
        <path
          d="M405.986 564.948c-3.328 5.26-12.92 5.105-17.974 5.731 6.073-8.293 4.338-17.073 3.142-23.607-3.192-2.343-7.584-9.073-7.176-12.176 4.616 0 17.803.677 22.008 4.748 3.194 6.379 3.327 20.043 0 25.304z"
          fill="#4D0D54"
        />
        <path
          d="M407.233 543.543c-8.574-5.494-24.714-4.752-31.713-3.695.038-17.523 17.349-20.05 26.294-13.043 7.155 5.606 6.049 13.419 5.419 16.738z"
          fill="#922671"
        />
        <path
          clipRule="evenodd"
          d="M400.354 540.679c-5.681-1.501-12.332-1.738-17.749-1.49a78.083 78.083 0 00-7.075-.01c.263-9.392 5.613-14.301 11.832-15.627 2.625.538 5.12 1.644 7.174 3.253 5.537 4.338 6.127 9.998 5.818 13.874z"
          fill="#BA3491"
          fillRule="evenodd"
        />
        <path
          d="M277.709 547.821l66.536.666v5.951l-68.7 13.038 2.164-19.655z"
          fill="#F3A21A"
        />
        <path
          clipRule="evenodd"
          d="M344.245 553.956v.482l-68.7 13.038.807-7.327 67.736-7.487.157 1.294z"
          fill="#D88F14"
          fillRule="evenodd"
        />
        <path
          d="M274.824 569.392l3.065-24.248h6.672l-3.607 24.248h-6.13z"
          fill="#C97718"
        />
        <path
          d="M325.398 565.566l11.903 16.573c2.991 3.26 5.842 11.454-2.869 18.189-1.894-.736-16.454-32.333-18.454-33.911-1.599-1.263-2.336-4.957-2.504-6.612l8.281-1.43c-.852-3.219 2.004-6.165 3.057-2.441 1.052 3.723 1.077 7.379.586 9.632z"
          fill="#F3898A"
        />
        <path
          d="M337.674 581.334c3.913 0 5.707 2.784 7.337 3.871.725 8.423-1.136 24.32-7.337 27.445-7.608 1.739-10.416-2.174-10.869-4.348 5.281-11.745 10.869-22.163 10.869-26.968z"
          fill="#3469BA"
        />
        <path
          d="M399.83 640.803c-1.108-4.899 15.853-16.698 24.428-24.214l16.02 5.933-29.267 18.281.449 2.687c1.273 1.368 2.612 3.612-3.613 4.913-7.78 1.627-7.65-5.977-8.017-7.6z"
          fill="#F3898A"
        />
        <path
          d="M308.219 563.713l.839-17.569h5.559l-1.034 17.569h-5.364z"
          fill="#C97718"
        />
        <path
          d="M422.207 611.129c-1.447.814-2.628 3.319-3.043 5.394 4.722 3.312 18.013 10.637 23.284 12.843 4.287.829 7.83-7.915 5.587-11.184-4.841-7.053-23.615-8.298-25.828-7.053z"
          fill="#3469BA"
        />
        <path
          d="M342.869 557.034l.838-10.89h4.446l-1.38 10.89h-3.904z"
          fill="#C97718"
        />
        <path
          d="M400.721 737.696c-6.052 1.578-7.963 9.714-6.967 13.366h20.702c.399-11.394-6.171-15.338-13.735-13.366z"
          fill="#4D0D54"
        />
        <path
          d="M397.8 735.257v4.298l11.271.786-.786-5.084H397.8zm3154.89-166.032h12.17l6.24 13.793-45.89 34.151H3364.9v-33.744l37.68-6.665v-13.91l35.35-14.78h16.81l2.61 10.723 19.7-3.478 8.12-12.171h21.44v15.649l22.32 4.057v13.91h16.8l3.48-21.445h5.22l-1.74 13.91z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M3579.49 616.953l4.79-75.09h-23.14l-3.59 42.737h-26.79v-47.53h7.59l4.39-23.319h-53.52v-29.004h-27.56v29.165h-101.11v19.498h46.23v52.318h-46.23v-33.601h-21.65l1.49 64.826h138.41l4.98-79.883h34.49l-3.57 79.883h64.79zm-108.22-84.82h-31.59v54.828h29.1l2.49-54.828z"
          fill={`url(#${id}-dB)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3586.86 616.953l4.79-75.09h-23.13l-3.6 42.737h-26.79v-47.53h7.59l4.39-23.319h-53.52v-29.004h-27.56v29.165h-54.88v103.041h72.03l4.97-79.883h34.49l-3.57 79.883h64.79zm-108.22-84.82h-31.59v54.828h29.11l2.48-54.828z"
          fill="#962760"
          fillRule="evenodd"
        />
        <path
          d="M3579.52 496.537h6.13l-4.01 45.224h-7.06l4.94-45.224z"
          fill="#fff"
        />
        <path
          d="M3558.77 513.351l34.51 7.242-1.57 4.259-32.94-5.679v-5.822zm-121.36-61.083h6.84v61.018h-6.84v-61.018z"
          fill="#fff"
        />
        <path
          d="M3461.87 471.467l-19.2 1.578v3.156h19.2v-4.734zm-10.25 19.743l-17-1.711v3.765l16.32 1.94.68-3.994z"
          fill="#fff"
        />
        <path
          d="M1702.58 789.594c-62.7-92.847-162.15 22.03-101.75 62.48 273.29-41.076 514.67-41.847 715.45-43.879 21.6-9.877 21.99-65.128-9.58-81.001-31.57-15.873-51.03 9.26-66.06 22.224-4.94-12.346-27.57-8.848-38.27-5.556-15.54-64.261-80.87-44.543-80.87 0-10.87-14.322-27.58-5.967-34.57 0-3.46-22.224-26.14-22.43-37.05-19.755-35.37-101.944-146.81-47.935-130.26 14.817-10.37-15.31-36.27 4.938-28.39 19.137-21.73-16.298-44.86-6.791-53.71 0-7.32-82.746-120.49-49.312-87.66 20.372-21.73-2.963-40.57 6.206-47.28 11.161z"
          fill="#3FC7C0"
        />
        <path
          d="M2221.14 783.415c9.67-.062 28.13-1.958 24.55-9.053-3.58-7.094-17.86 3.079-24.55 9.053z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M1853.67 803.941c-.14-33.279 34.76-48.217 67.52-7.764 5.61-13.463 23.24-11.649 31.35-9.059-.02-69.176 67.53-65.742 74.93-14.813 20.33-13.179 37.54-3.966 43.61 2.288 14.34-18.063 44.16-17.537 54.54 5.569 35-59.848 84.53-30.608 68.76 5.691 18.37-2.914 23.14 7.088 23.36 13.807-142.8 10.096-275.64 8.482-364.07 4.281zm372.99-4.925c7.83-1.758 14.23-2.149 19.42-1.505-6.49.526-12.97 1.027-19.42 1.505z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3117.71 821.988l-7.3-13.621h-30.05l-10.02-16.696h-37.4c-2.45-6.234-8.41-19.235-12.69-21.372-4.27-2.137-43.63-3.562-62.78-4.007l27.38-6.679-22.7-24.711h-48.09l30.72-6.679-22.42-18.522 2.36.627v-21.525l27.64 21.525v9.355l51.46 21.83v16.371l68.6 4.678 20.27 23.388h28.85l5.71 22.77h36.57v13.268h-46.11z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3117.68 821.988h-386.93v-44.482h-16.63l-6.1-19.622h26.05v-13.08h-14.41v-22.171h29.93l13.31-25.496h16.07l6.1-29.931h71.5l39.35 21.597v13.876l26.41 7.022 22.42 18.522-30.72 6.679h48.09l22.71 24.711-27.39 6.679c19.15.445 58.51 1.87 62.78 4.007 4.28 2.137 10.24 15.138 12.69 21.372h37.4l10.02 16.696h30.06l7.29 13.621zm-192.99-111.66v-21.525 21.525z"
          fill={`url(#${id}-dC)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M2830.34 667.206l65.58 34.576v-12.979l-39.35-21.597h-26.23z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M2369.1 632.194c-4.1 3.007-9.41 12.455-11.55 16.802l-23.44-8.888c-2.95-4.311 5.4-17.273 9.95-23.216l25.04 15.302z"
          fill="#9EC4E7"
        />
        <path
          d="M2344.09 639.22l26.09 16.443c-2.81 1.751-7.02 1.418-8.78 1.032-7.41-3.281-21.08-12.317-27.26-16.613-.09-.06-.18-.123-.27-.19.09.062.18.125.27.19 2.68 1.689 7.7.154 9.95-.862z"
          fill="#DCECFA"
        />
        <path
          d="M2408.63 705.097c1.28 9.629-11.14 13.195-17.52 13.775l-7.44-2.869c5.89-1.745 9.31-7.696 9.31-7.696l15.65-3.21z"
          fill="#9EC4E7"
        />
        <path
          d="M2380.55 701.461l-17.45 7.809c9.23 14.746 29.53 10.625 38.52 6.722-12.27 3.314-19.13-9.687-21.07-14.531z"
          fill="#DCECFA"
        />
        <path
          d="M2533.58 687.061c-3.83 4.262-10.19.054-12.89-2.582l-1.56-4.434c3.04 1.973 7.02 1.229 7.02 1.229l7.43 5.787z"
          fill="#9EC4E7"
        />
        <path
          d="M2524.46 673.08l-10.19-4.838c-3.08 9.783 6.54 17.308 11.74 19.847-6.19-4.234-2.98-12.285-1.55-15.009z"
          fill="#DCECFA"
        />
        <ellipse
          cx="3415.44"
          cy="704.508"
          fill={`url(#${id}-dD)`}
          rx="51.746"
          ry="6.618"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M3373.77 690.264c0-.132-.02-.261-.07-.384-.98-2.699-1.46-9.605 4.12-17.183 7.14-9.695 24.98-10.474 32.71-1.917 7.73 8.556 11.68 25.856-1.49 33.241-4.33 2.427-9.19 3.04-11.83 1.717-.45-.221-1.06.004-1.14.491a.616.616 0 01-.24.389 15.73 15.73 0 01-3.47 1.95c-.63.253-1.27-.267-1.21-.942l.29-3.244a.713.713 0 00-.65-.782.724.724 0 00-.78.652l-.4 4.427a.924.924 0 01-.78.835c-.64.09-1.28.137-1.92.138-.54.002-.94-.471-.89-1.005l.43-4.749a.72.72 0 00-.65-.782.712.712 0 00-.78.652l-.42 4.631c-.06.559-.58.958-1.12.812a12.05 12.05 0 01-1.12-.359c-.39-.144-.61-.535-.58-.944l.43-4.654a.727.727 0 00-.65-.782.727.727 0 00-.79.652l-.29 3.233c-.06.703-.84 1.09-1.39.653a9.997 9.997 0 01-.49-.398.912.912 0 01-.3-.778l.42-4.567a.723.723 0 00-1.44-.131l-.12 1.348c-.08.86-1.12 1.148-1.54.393a6.573 6.573 0 01-.22-.403.97.97 0 01-.1-.53c.17-1.585.45-4.407.42-4.918-.01-.317-.49-.959-1.01-1.573-.65-.752-1.04-1.699-1.01-2.689l.07-2.5z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3412.14 672.756c6.6 9.019 9.12 24.411-3.1 31.265-4.33 2.427-9.19 3.04-11.83 1.717a.867.867 0 00-.55-.068c-.19-4.144 2.72-4.975 6.81-6.143l.27-.075c4.38-1.252 4.35-9.584 4.32-16.922v-1.695c0-4.338 2.1-6.829 4.08-8.079z"
          fill="#CCDAFF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M3376.48 681.128c.82-1.434 1.98-1.881 3.01-1.896 1.32-.019 2.26 1.071 2.19 2.381-.05.783-.17 1.617-.28 2.157-1.14 8.467-3.66 8.947-5.52 7.506-1.86-1.441-1.2-7.026.6-10.148zm17.28-.356c-2.67 0-3.01 1.38-3.28 3.804l-.03.331c-.26 2.295-.49 4.426.3 7.337.82 3.05 8.53 6.189 9.45-2.167.47-4.272-3.1-9.305-6.44-9.305zm-12.81 15.086c.61-2.287 2.08-6.926 3.02-7.179 1.18-.316 1.4 2.348 1.4 3.793 0 .631.26 1.623.51 2.582.32 1.238.63 2.42.35 2.7-.5.497-2.39-.496-3.03-.993-.25-.196-.65-.195-1.05-.194-.61.001-1.2.002-1.2-.709z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M1982.8 667.086c31.07-.417 78.93-20.491 78.93-20.491s-8.86-18.679 6.83-28.011c15.68-9.333 20.74 5.078 20.74 5.078s9.76-5.935 26.57-5.078c28.03 1.435 44.21 24.915 54.83 31.855 0 0 19.51-7.253 32.51-3.844 13 3.4 11.35 4.173 26.74 7.432 15.39 3.258 67.05 9.711 67.05 9.711s-226 2.714-314.2 3.348z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M4882.67 714.824l-119.54 116.077 742.56-3.915 520.12-9.467-138.25-122.328-148.63-168.453-63.27-40.398-21.34-41.161-58.69-32.014-89.94-153.971v28.965l-21.35-23.629h-38.87l-4.57 35.063-30.49-40.399-46.11-5.21-123.01 200.968-41.58 15.592-117.81 142.064h-36.38l-119.54 90.089-43.31 12.127z"
          fill={`url(#${id}-dE)`}
        />
        <path
          clipRule="evenodd"
          d="M5054.69 829.364l-291.56 1.537 119.54-116.077 43.31-12.127 119.54-90.089h36.38l117.81-142.064 41.58-15.592 123.01-200.968 45.34 5.123-15.84 57.861v69.13l-27.25 63.812 11.51 48.43-77.04 154.837 92.78-105.535-46.56 105.535 8.48 73.182-73.95-10.785-227.08 113.79zm316.13-509.154l-123.08 171.41-148.76 271.08 156.31-173.673-7.55-43.796 123.08-225.021zm-368.14 375.274l78.01-82.347-22.75 56.343-55.26 26.004z"
          fill={`url(#${id}-dF)`}
          fillRule="evenodd"
        />
        <path
          d="M5454.64 407.046l6.04-43.041 54.22 199.734-60.26-156.693z"
          fill={`url(#${id}-dG)`}
        />
        <path
          clipRule="evenodd"
          d="M5938.37 819.111l-124.14-163.717-95.45-27.088-205.85-298.863 99.67 247.937-39.08 117.021 66.25 130.145 298.6-5.435z"
          fill={`url(#${id}-dH)`}
          fillRule="evenodd"
        />
        <path
          d="M5425.34 556.864l14.64 115.347 134.52-3.986 10.29-103.967-103.29-50.368-56.16 42.974z"
          fill={`url(#${id}-dI)`}
        />
        <path
          clipRule="evenodd"
          d="M5661.21 458.552c1.08-.375 2.17-.785 3.27-1.231 4.88 14.736 21.18 44.208 47.28 44.208 1.77 6.046 6.53 18.137 11.45 18.137 1.64 0 .37.241-2.45.778-7.78 1.476-27.33 5.189-30.33 12.258-19.12-5.668-55.73-9.749-49.18 19.27-37.16 1.253-120.48-4.666-156.48-38.362 21.67 25.687 97.4 75.349 226.99 68.499 22.26 12.815 77.7 26.541 121.41-21.068 19.12-1.959 55.46-14.188 47.81-47.431-9.56-41.553-25.95-85.762-132.5-90.296-8.65-9.446-34.69-24.938-69.66-11.335-3.64-6.613-16.26-18.137-37.57-11.336-7.69-13.787-29.28-32.481-58.96-10.225l13.34 22.841 58.69 32.013 6.89 13.28z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.9"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M5636.05 745.191l37.02 59.555 34.61 30.581h-470.8l95.77-78.869 6.44-30.581 66.8-78.065c28.32-14.164 106.23-9.121 141.64-4.828l88.52 102.207z"
          fill="#413776"
        />
        <ellipse
          cx="1204.39"
          cy="757.76"
          fill={`url(#${id}-dJ)`}
          rx="157.777"
          ry="11.329"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M1085.15 733.956c.37-.864 8.99-23.806 13.26-35.169l41.19-58.152 22.05 64.785c1.29 9.563 3.95 29.215 4.32 31.312.47 2.623 17.12 6.479 19.28 6.787 2.16.309-8.63 2.16-11.41 2.931-2.78.771 11.26 4.936 13.27 6.479 2 1.542-25.46 11.105-45.51 14.499-20.05 3.393-34.24 1.851-43.19-1.697-8.94-3.547-28.07-5.861-26.84-5.861.99 0 7.92-5.553 11.26-8.33-4.73.463-14.22 1.111-14.34 0-.16-1.388 13.26-6.941 14.34-8.021 1.08-1.079 1.85-8.483 2.32-9.563z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M1112.2 574.671c-2.66 5.901-1.11 9.507 0 10.572-3.88 0-14.12 2.445-18.76 3.667l-9.44-2.922-2.58 33.599c4.34 2.547 13.35 7.687 14.61 7.866 1.26.18 9.53-3.08 13.51-4.733 2.58 3.396.4 20.143-1.01 28.092-6.13 13.742-18.31 41.793-17.99 44.057.41 2.829 33.95 30.314 35.37 29.102 1.13-.971 4.4-20.272 13.14-48.561l16.32 43.148c2.35-.117 11.12-13.722 15.21-20.51l-9.38-19.763c.15-6.862-6.49-31.462-9.83-42.904 2.29.972 15.73 6.437 21.17 8.461 12.4-4.66 14.75-25.652 6.39-29.2-2.35-1.988-11.66-9.032-12.99-10.181-1.65-1.435-2.65-.22-5.74-2.65-3.09-2.429-7.07-13.803-7.4-15.349-.26-1.237-4.12-2.795-6.02-3.42 3.68-3.565 3.68-5.458-1-12.03-4.68-6.572-5.22-16.226-6.73-17.949-1.21-1.378-3.73-1.039-4.84-.697-2.03-1.5-5.48-1.712-6.95-1.631-1.42-.448-4.5-1.458-5.54-1.914-1.29-.569-8.95 1.656-9.52 4.242-.46 2.069-4.05 7.317-5.78 9.683.98 1.573 3.28.082 4.3-.861-.49 4.426.78 10.368 1.48 12.786z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M1081.89 619.862l.82-17.074 1.29-16.8 9.44 2.922c4.64-1.222 14.88-3.667 18.76-3.667-1.11-1.065-2.66-4.671 0-10.572-.7-2.418-1.97-8.36-1.48-12.786-1.02.943-3.32 2.434-4.3.861 1.73-2.366 5.32-7.614 5.78-9.683.57-2.586 8.23-4.811 9.52-4.242 1.04.456 4.12 1.466 5.54 1.914 1.47-.081 4.92.131 6.95 1.631 1.11-.342 3.63-.681 4.84.697.56.643.99 2.393 1.55 4.675.94 3.829 2.25 9.156 5.18 13.274.45.642.87 1.239 1.24 1.798l-.24.232c.15.05.32.107.5.17 3.12 4.857 2.73 6.698-.5 9.83 1.9.625 5.76 2.183 6.02 3.42.33 1.546 4.31 12.92 7.4 15.349 1.74 1.364 2.81 1.58 3.71 1.76.71.141 1.31.261 2.03.89.62.532 2.94 2.327 5.49 4.299 2.97 2.288 6.24 4.814 7.5 5.882 7.36 3.124 6.42 19.767-2.37 26.885-6.07-2.4-13.53-5.444-15.19-6.146.42 1.444.73 2.939.96 4.462-4.91-1.968-9.68-3.918-10.96-4.462 3.34 11.442 9.98 36.042 9.83 42.904l6.7 14.108c-4.44 7.02-10.62 16.07-12.53 16.165l-16.32-43.148c-5.22 16.904-8.49 30.599-10.52 39.091-1.36 5.72-2.17 9.079-2.62 9.47-1.2 1.026-25.43-18.52-33.08-26.255 3.77-9.776 11.29-27.032 15.7-36.904.7-3.975 1.6-10.149 2-15.754.12-.175.19-.302.21-.436.01-.132-.03-.271-.15-.467.33-5.236.17-9.829-1.05-11.435-3.98 1.653-12.25 4.913-13.51 4.733-1.22-.173-9.65-4.968-14.14-7.591z"
          fill={`url(#${id}-dK)`}
          fillRule="evenodd"
        />
        <path d="M1134.21 592.822l4.97 83.229" stroke="#fff" />
        <path
          clipRule="evenodd"
          d="M1182.49 632.754c-10.99-2.67-27.04-9.938-32.88-15.33l1.68 17.418 2 1.337c4.54 1.863 14.69 5.969 19.25 7.663 4.9-1.841 8.23-6.231 9.95-11.088zm-76.35 23.448c10.84-12.567 5.98-72.264 5.98-61.137 0 8.945-9.52 27.145-16.11 32.297a.798.798 0 00-.11.063c.05.013.09.023.13.028 1.26.18 9.53-3.08 13.51-4.733 2.58 3.396.4 20.143-1.01 28.092-.73 1.62-1.53 3.438-2.39 5.39zm-19.83-33.793c5.05-12.485 1.43-29.811.2-35.641l-2.84 3.575-2.25 29.244c1.32.773 3.06 1.784 4.89 2.822z"
          fill="#17677C"
          fillRule="evenodd"
        />
        <path
          d="M1191.01 577.495l3.86 12.943v5.034l-9.18 35.716-3.38 39.279v30.062l-8.95 46.665 3.66 2.238 8.67-48.903 1.96-26.401 6.91-13.417c-.11-1.695-.52-5.086-1.3-5.086s-4.07 5.724-5.61 8.586l1.49-12.13v-11.382c1.65-7.887 4.95-24.111 4.95-25.908 0-1.797 4.41-13.628 6.61-19.319v-7.547l2.97-6.841c3.86-3.156 11.66-9.787 12-11.073.34-1.286-.63-1.742-1.16-1.809l-8.69 3.855c0-1.262 9.45-8.044 14.18-11.278.53-1.334 1.51-4.099 1.22-4.487-.29-.388-10.39 5.255-15.4 8.125-1.86-1.658-5.78-5.142-6.55-5.821-.78-.679-2.43 2.061-3.16 3.517l2.43 7.397-2.43 9.943c-.41-1.131-1.55-3.589-2.78-4.365-1.24-.776-2.07 1.281-2.32 2.407z"
          fill={`url(#${id}-dL)`}
        />
        <path
          d="M1079.83 579.833l-4.77-3.938c-8.34-.941-12.74 20.527-13.24 30.371-.5 9.843 3.78 19.19 6.36 19.886 2.07.556 4.58-1.426 5.57-2.486l6.08 2.486c1.62-2.718 5.3-9.923 7.05-17.003 1.75-7.079-.73-21.775-2.19-28.238l-4.86-1.078z"
          fill="#fff"
        />
        <path
          d="M1191.25 614.219c-1.14-.978-4.16-.407-5.54 0-.46 2.315 1.31 8.254 2.26 10.933.36.579 1.73 1.685 4.3 1.48 3.22-.258 5.09-11.448 4.31-12.413-.61-.772-3.81-.322-5.33 0z"
          fill="#4D0D54"
        />
        <path
          d="M1077.39 601.128c.9-3.666-.82-17.326-1.78-23.697-5.82 0-9.51 20.455-9.62 26.156-.11 5.701.78 18.444 3.13 18.444 2.35 0 7.16-16.32 8.27-20.903z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M1177.77 610.447c-.73.081-1.92.909-2.43 1.313 1.92 2.525 5.58 9.15 4.85 15.452-.73 6.301-6.5 14.609-9.29 17.976 1.01.336 3.19 1.01 3.84 1.01.64 0 2.29 1.279 3.03 1.918 5.75-.908 8.98-14.744 9.99-22.217 1.01-7.474-3.23-13.634-3.93-13.533-.71.101-5.15-2.02-6.06-1.919z"
          fill="#fff"
        />
        <path
          d="M1065.72 572.012c.61 0 6.65 3.928 9.6 5.892 3.06 2.004 2.73 10.43 2.18 14.392l-8.92-12.54-4.46 2.188c-2.92-.196-8.97-.589-9.85-.589-1.09 0-5.38-4.377-5.38-6.397 0-2.02 3.36-.168 4.29 0 .74.135 4.46-.841 6.23-1.346-4.71-.842-4.71-2.694-3.12-3.031 1.6-.336 8.67 1.431 9.43 1.431z"
          fill="#4D0D54"
        />
        <path
          d="M1122.7 561.761c-5.91 6.774-9.55 19.495-7.39 22.054 1.13 1.328 10.78 6.37 18.42 4.726 7.08-1.525 12.24-9.674 11.81-10.338-.71-1.103-5.68-15.031-8.07-21.858-2.46-1.017-8.86-1.359-14.77 5.416z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M1121.81 589.947c-1.08-6.602 1.05-13.431 6.52-18.185 2.52-2.193 5.62-1.654 8.39.049 6.15 3.794 6.69 11.949 7.78 19.094 3.57 23.289 15.91 23.436 22.78 37.308 7.8 15.757-4.55 25.014 2.1 31.813 6.66 6.799 10.73 2.151 12.98 0-1.94 2.678-9.81 7.184-14.08 4.597-4.26-2.586-5.35-3.546-5.35-19.903s-20.26-28.512-22.66-30.763c-2.4-2.251-17.11-15.756-18.46-24.01z"
          fill="#fff"
        />
        <g filter={`url(#${id}-dM)`}>
          <path
            d="M1028.18 585.112c3.6 8.104 15.38 9.004 20.82 8.441 7.69-1.501 23.41-6.078 24.76-12.38 1.69-7.879-5.62-12.381-10.41-14.351-4.78-1.969-2.53-6.19 4.79-9.285 7.31-3.095 10.69-6.827 5.62-15.757-5.06-8.93-16.32-14.069-16.03-9.285.28 4.783-5.91 11.536-10.7 9.285-4.78-2.251-1.68-7.316-1.68-11.536 0-3.377-1.51-6.097-2.26-7.035.29 5.065-17.72 15.195-17.72 23.073 0 7.879 9 10.692 9.85 14.35.84 3.658-11.54.282-9.85 3.94 1.69 3.658-1.69 10.411 2.81 20.54z"
            fill={`url(#${id}-dN)`}
            shapeRendering="crispEdges"
          />
        </g>
        <g filter={`url(#${id}-dO)`}>
          <path
            d="M1072.08 566.823c3.37-1.595 9.84-8.385 8.72-17.164 1.31 6.846 1.41 19.865-8.72 17.164z"
            fill="#2AF5C4"
          />
        </g>
        <path
          clipRule="evenodd"
          d="M5405.69 648.044l-54.81 114.265 29.16-84.287-40.95 47.855-6.44 30.581-95.2 78.4 16.59.469h62.19l77.45-23.484 65.56-127.805 64.14-11.277 24.3-29.602-.15-.175c-35.41-4.293-113.32-9.336-141.64 4.828l-.2.232z"
          fill={`url(#${id}-dP)`}
          fillRule="evenodd"
        />
        <path
          d="M4354.53 790.833c-51.63-76.443-133.5 18.137-83.78 51.44 225.01-33.818 423.74-34.453 589.04-36.126 17.79-8.132 18.11-53.621-7.88-66.689-25.99-13.069-42.02 7.624-54.38 18.297-4.07-10.165-22.71-7.285-31.52-4.574-12.79-52.907-66.58-36.674-66.58 0-8.95-11.792-22.7-4.913-28.46 0-2.85-18.298-21.52-18.467-30.5-16.265-29.12-83.933-120.88-39.466-107.24 12.199-8.54-12.605-29.87 4.066-23.38 15.756-17.9-13.419-36.94-5.591-44.22 0-6.03-68.127-99.2-40.599-72.18 16.772-17.89-2.439-33.4 5.11-38.92 9.19z"
          fill="#3FC7C0"
        />
        <path
          d="M4781.46 785.745c7.97-.051 23.16-1.612 20.22-7.453-2.95-5.841-14.71 2.535-20.22 7.453z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M4478.93 802.645c-.12-27.4 28.61-39.699 55.59-6.393 4.61-11.084 19.13-9.59 25.81-7.458-.02-56.954 55.6-54.127 61.69-12.196 16.73-10.85 30.9-3.265 35.9 1.884 11.8-14.872 36.36-14.439 44.91 4.585 28.81-49.274 69.59-25.2 56.61 4.685 15.12-2.399 19.05 5.836 19.23 11.368-117.57 8.312-226.94 6.983-299.74 3.525zm307.08-4.056c6.45-1.447 11.72-1.769 15.99-1.239-5.34.434-10.67.846-15.99 1.239z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <g filter={`url(#${id}-dQ)`}>
          <path
            clipRule="evenodd"
            d="M2275.08 114.069c-1.7.226-3.43.342-5.19.342-21.56 0-39.04-17.479-39.04-39.04 0-14.334 7.72-26.864 19.23-33.654a49 49 0 00-.21 0c-22.4 0-40.56 18.162-40.56 40.565 0 22.404 18.16 40.566 40.56 40.566 9.53 0 18.28-3.283 25.21-8.779z"
            fill={`url(#${id}-dR)`}
            fillRule="evenodd"
          />
        </g>
        <g filter={`url(#${id}-dS)`}>
          <path
            clipRule="evenodd"
            d="M3015.26 8.602l-21.61 59.794-7.48-8.969-17.94 14.969-36.09 7.8 11.4 45.261-6.44-42.414 34.04-7.164 15.07-12.573 10.22 12.252 19.96-55.682c2.92 28.841 10.29 82.776 14.53 112.452l-9.27 22.229 33.35 68.707-17.41-59.938v-42.622c-6.92-15.983-10.87-75.477-11.98-103.226l29.39 26.64 44.53 3.995 80.58 35.558c15.99 34.631 10.88 67.668 6 79.655l-6 26.639c4-3.774 12.39-14.385 13.99-26.639 1.6-12.254-4.66-63.267-7.99-87.242-23.45-3.197-67.49-24.863-86.58-35.297L3055 34.795c-8.64-9.983-23.12-25.384-32.04-31.264l.39-1.084-2.92-8.166-2.49 6.9c-1.63-.242-2.63.504-2.77 2.557-.07 1.042-.04 2.694.09 4.864zm238.26 14.55l-74.16-14.787 61.46 26.74 3.15 31.836 9.55-43.79zM2861.4 65.803l26.26-8.741 4.71-6.057 25.64-6.98-22.11-5.24-7.25 9.318-27.25 17.7z"
            fill="#2AF5C4"
            fillRule="evenodd"
          />
        </g>
        <path
          d="M3482.43 639.036c-41.85 11.158-64.28 11.158-64.28 11.158h226.28c-10.93-3.746-40.06-7.343-40.06-7.343s.78-4.553-4.36-5.323c-4.43-.663-10.49 2.24-10.49 2.24s-2.19-16.577-20.69-19.967c-18.49-3.39-29.9 1.875-39.57 20.702 0 0-6.85-3.67-11.14-3.67-4.28 0-7.7 1.761-7.7 1.761s-2.01-3.228-9.71-3.964c-7.72-.732-14.06 3.281-18.28 4.406z"
          fill="#fff"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <ellipse
          cx="1044.52"
          cy="692.834"
          fill="#4D0D54"
          rx="2.991"
          ry="3.963"
          transform="rotate(-20.248 1044.52 692.834)"
        />
        <ellipse
          cx="1044.82"
          cy="688.339"
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="rotate(-5.25 1044.82 688.339)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="scale(-1 1) rotate(35.246 -1606.129 -1294.323)"
        />
        <path
          d="M1057.76 677.252c-8.97 4.707-11.1 11.708-11.03 14.866 0 .007.01.015.01.022.01.115.09.212.13.32l.5 1.364c.03.108.09.225.21.249.09.02.2-.011.27-.09 1.69-1.807 4.72-2.425 6.13-2.354.25.013.43-.279.31-.499-1.66-3.13.7-5.156 2.39-5.917a.31.31 0 00.15-.407c-1.17-2.6.03-5.271 1.35-7.009.19-.257-.13-.695-.42-.545zm-33.41 12.327c9.87-2.245 16.04 1.69 18.03 4.143.01.006.01.012.02.018.06.096.06.222.11.33l.5 1.359c.04.108.08.235.01.326a.317.317 0 01-.27.113c-2.46-.277-5.17 1.219-6.19 2.186-.18.171-.51.07-.56-.173-.78-3.458-3.88-3.469-5.66-2.951a.31.31 0 01-.38-.21c-.8-2.738-3.45-3.988-5.58-4.455-.31-.07-.35-.615-.03-.686z"
          fill="#4D0D54"
        />
        <ellipse
          cx="1133.56"
          cy="421.244"
          fill="#4D0D54"
          rx="2.991"
          ry="3.963"
          transform="rotate(24.772 1133.56 421.244)"
        />
        <ellipse
          cx="1136.94"
          cy="418.276"
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="rotate(39.77 1136.94 418.276)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="scale(-1 1) rotate(-9.774 1870.14 6837.312)"
        />
        <path
          d="M1153.93 419.592c-9.66-3.016-16.13.42-18.31 2.708 0 .006-.01.012-.01.017-.07.091-.08.216-.13.321l-.62 1.315c-.05.104-.09.227-.02.324.05.083.15.137.26.134 2.47-.082 5.05 1.623 5.99 2.667.17.185.5.11.58-.128 1.04-3.387 4.14-3.152 5.87-2.496a.3.3 0 00.39-.179c1.02-2.666 3.76-3.703 5.91-4.002.32-.044.4-.585.09-.681zm-32.34-14.923c8.57 5.4 10.15 12.547 9.82 15.689v.023c-.02.113-.11.203-.16.308l-.6 1.321c-.05.105-.11.217-.23.231a.302.302 0 01-.27-.111c-1.54-1.935-4.51-2.79-5.92-2.83-.25-.007-.41-.312-.27-.522 1.9-2.989-.29-5.195-1.91-6.087a.3.3 0 01-.12-.418c1.37-2.5.38-5.257-.8-7.094-.17-.271.19-.682.46-.51z"
          fill="#4D0D54"
        />
        <ellipse
          cx="829.083"
          cy="333.72"
          fill="#4D0D54"
          rx="3.829"
          ry="5.074"
          transform="rotate(-12.305 829.083 333.72)"
        />
        <ellipse
          cx="830.254"
          cy="328.073"
          fill="#4D0D54"
          rx="0.863"
          ry="1.899"
          transform="rotate(2.693 830.254 328.073)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.863"
          ry="1.899"
          transform="scale(-1 1) rotate(27.302 -1090.297 -1535.26)"
        />
        <path
          d="M848.624 316.304c-12.204 4.382-16.154 12.88-16.612 16.899a.33.33 0 000 .077c.014.115.075.22.1.333l.408 1.913c.024.113.064.232.167.285a.382.382 0 00.413-.045c2.464-1.993 6.411-2.24 8.181-1.901.313.06.6-.277.491-.577-1.551-4.262 1.794-6.414 4.071-7.08a.396.396 0 00.266-.489c-1.024-3.505.974-6.679 2.948-8.65.292-.291-.044-.905-.433-.765zm-44.552 9.718c12.921-1.098 20.051 4.983 22.141 8.446a.35.35 0 01.032.071c.035.11.023.231.048.343l.425 1.909c.026.113.039.238-.033.329a.384.384 0 01-.395.132c-3.069-.786-6.761.633-8.229 1.678-.259.185-.661-.002-.686-.32-.365-4.521-4.303-5.085-6.65-4.742a.395.395 0 01-.445-.334c-.529-3.613-3.667-5.666-6.283-6.636-.387-.143-.336-.841.075-.876z"
          fill="#4D0D54"
        />
        <path d="M0 0h6000v616H0V0z" fill={`url(#${id}-dT)`} opacity="0.3" />
        <ellipse
          cx="5291.79"
          cy="156.557"
          fill="#56115B"
          rx="1.763"
          ry="0.738"
          transform="rotate(23.244 5291.79 156.557)"
        />
        <path d="M0 0h6000v616H0V0z" fill={`url(#${id}-dU)`} opacity="0.5" />
        <path
          d="M5861.75 272.531c14.71 42.994-10.9 57.919-23.56 60.307l-8.91 25.965c46.73-11.609 63.7-66.265 43.39-91.515-18.9-23.493-77.9-30.695-107.29-52.643-4.21-3.149-7.57-7.706-7.79-12.963-.26-6.299 3.44-8.116 4.83-11.361 1.48-3.442-.61-9.878-1.85-12.666 3.7 12.808-5.59 5.835-6.4 8.539-.65 2.163.27 6.52.81 8.428-11.12 46.072 95.76 45.757 106.77 77.909z"
          fill="#4D0D54"
        />
        <path
          d="M5828.38 294.131c-14.07 18.762-51.85 32.88-68.98 37.593l48.98 8.278c26.35-19.392 44.24-20.187 65.53-2.415 14.14-17.244 20.69-45.525 51.04-50.009 4.42-40.56 23.68-63.116 32.77-69.324-6.07-28.419 21.41-51.701 27.28-56.759-41.46 2.859-96.72 15.602-117.99 23.305l-36.56 28.626c5.17 19.084 12 61.943-2.07 80.705z"
          fill={`url(#${id}-dV)`}
        />
        <path
          clipRule="evenodd"
          d="M5900.77 175.264c-18.2 25.699-31.95 52.652-43.88 76.033-20.07 39.352-34.98 68.583-57.28 64.679l.01-.078c11.67-6.071 22.54-13.465 28.76-21.767 14.07-18.763 7.25-61.621 2.07-80.705l36.56-28.627c7.62-2.76 19.61-6.167 33.76-9.535z"
          fill="#DE6924"
          fillRule="evenodd"
        />
        <path
          d="M5847.93 208.341c18.42-5.52 69.33-10.831 110.32 10.294m-113.11-2.893l25 7.13c2.73.781 5.22 2.257 7.18 4.316 16.57 17.369 45.45 50.075 48.66 63.59"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.058"
        />
        <path
          d="M5732.81 358.597l1.76-15.692 12.39 10.633-5.47 15.796c-5.86 2.229-29.52-3.539-40.36-7.668l-2.24 6.923c-.15.444-.56.745-1.03.745-.59 0-1.07-.482-1.07-1.076v-8.113l-9.05-1.384a1.267 1.267 0 01-1.07-1.248c0-.746.65-1.329 1.39-1.255l7.9.79-5.68-6.596c-.4-.472-.38-1.177.06-1.617a1.186 1.186 0 011.6-.073l7.84 6.531 3.68-5.794a.823.823 0 011.47.724l-2.16 5.896c9.75.546 26.21 1.722 30.04 2.478z"
          fill={`url(#${id}-dW)`}
        />
        <path
          d="M5732.81 358.597l1.76-15.692 12.39 10.633-5.47 15.796c-5.86 2.229-29.52-3.539-40.36-7.668l-2.24 6.923c-.15.444-.56.745-1.03.745-.59 0-1.07-.482-1.07-1.076v-8.113l-9.05-1.384a1.267 1.267 0 01-1.07-1.248c0-.746.65-1.329 1.39-1.255l7.9.79-5.68-6.596c-.4-.472-.38-1.177.06-1.617a1.186 1.186 0 011.6-.073l7.84 6.531 3.68-5.794a.823.823 0 011.47.724l-2.16 5.896c9.75.546 26.21 1.722 30.04 2.478z"
          fill={`url(#${id}-dX)`}
        />
        <path
          d="M5840.87 303.043l-65.57 32.024h-21.35c27.79-10.097 83.65-31.307 84.78-35.379 1.14-4.071 1.9-30.771 2.14-43.613v-16.774c5.85 7.32 6.71 45.545 6.4 63.742h-6.4z"
          fill="#4D0D54"
        />
        <path
          d="M5843.99 218.448l19.41 26.455c.69.93 1.27 1.921 1.7 2.992 7.43 18.582 14.82 69.495 8.54 89.381"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.058"
        />
        <path
          d="M5728.5 231.932c2.87 4.735 11.99 9.138 16.2 10.748v5.764c-12.59-3.988-16.04-12.67-16.2-16.512z"
          fill="#4D0D54"
        />
        <path
          d="M5684.06 272.424c6.3 26.08 31.85 53.333 43.84 63.699l7.89 12.519c-6.87-3.4-22.85-11.698-31.84-17.693-11.24-7.493-18.32-19.983-26.23-25.603-6.33-4.496-17.9-1.041-22.9 1.249-10.49-42.296-26.43-55.368-33.09-56.617-4.67-45.461-16.52-66.401-21.86-71.189 5.49-21.814-2.29-42.949-6.87-50.789 30.14 13.655 56.83 35.108 66.4 44.128l24.66 35.099c-2.62 10.866-6.29 39.118 0 65.197z"
          fill={`url(#${id}-dY)`}
        />
        <path
          clipRule="evenodd"
          d="M5696.19 299.215c-5.45-8.569-9.94-17.75-12.13-26.79-6.29-26.079-2.62-54.331 0-65.198l-24.66-35.098c-4.04-3.811-11.14-9.841-20.27-16.565 5.97 13.504 16.48 41.39 16.48 58.433 0 17.857 27.16 66.593 40.73 88.728l-.15-3.51z"
          fill="#DE6924"
          fillRule="evenodd"
        />
        <path
          d="M5672.25 199.96c-10.07-9.704-38.89-27.464-73.61-20.873m76.18 26.706h-13.23c-4.11 0-8.09 1.537-10.99 4.45-9.82 9.84-24.58 26.563-29.41 39.29m53.91-40.32c-4.53 5.989-13.7 18.505-14.15 20.655-.57 2.688-7.5 34.944-5.8 82.054"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.058"
        />
        <path
          d="M5672.66 284.382l2.6-53.262 3.75 3.746-1.79 46.909c1.04 4.17 22.37 25.735 32.9 35.997l6.84 10.098c-7.95-4.17-29.81-29.209-39.74-41.208l-4.56-2.28z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M5727.9 336.124c-11.99-10.367-37.54-37.62-43.84-63.699-6.29-26.079-2.62-54.332 0-65.198l-24.66-35.098c-.37-.351-.77-.72-1.19-1.107l16.59 38.782c-2.22 8.465-3.99 32.93 6.67 63.071 10.3 29.141 34.34 56.998 49.09 67.467l-2.66-4.218z"
          fill="#872A81"
          fillRule="evenodd"
        />
        <path
          d="M5702.12 308.375c8.07 10.091 20.06 12.854 25.04 12.974 4.93 7.808 13.13 24.663 4.48 20.194-8.65-4.469-23.46-24.759-29.52-33.168z"
          fill="#872A81"
        />
        <path
          d="M5760.52 234.494c1.33 4.326.56 8.365 0 9.844l3.47 3.328c.33-7.986-2.17-12.109-3.47-13.172z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M5766.27 329.665c18.87-6.058 49.7-18.991 62.11-35.534 14.07-18.762 7.24-61.621 2.07-80.705l36.56-28.626c.6-.218 1.22-.441 1.87-.668-1.92 5.631-8.12 13.369-13.68 20.309-3.85 4.794-7.38 9.207-8.99 12.284-1.6 3.049-2.09 10.669-2.72 20.331-1.11 17.041-2.62 40.434-11.33 56.311-10.33 18.834-47.83 31.788-65.89 36.298z"
          fill="#872A81"
          fillRule="evenodd"
        />
        <path
          d="M5807.64 311.405c-46.22 24.53-54.78 13.49-59.25 9.602l6.86 14.928s-2.14 13.38 17.15 0 35.24-24.53 35.24-24.53z"
          fill="#872A81"
        />
        <path
          d="M5815.22 392.627c-6.2-2.531-13.76-10.333-16.76-13.918 3.82-2.525 12.36-7.069 15.93-5.037 4.46 2.539 10.17 11.858 10.91 15.976.59 3.294 5.2 7.549 7.43 9.265l-2.43 24.789h3.73c.93 0 1.74.62 1.98 1.513a2.052 2.052 0 01-1.24 2.447l-3.43 1.325.28 7.275a1.865 1.865 0 01-1.86 1.921c-1.02 0-1.85-.829-1.85-1.852v-5.903l-6.27 7.303a2.314 2.314 0 01-2.85.538 2.319 2.319 0 01-.64-3.598l3.11-3.488h-6.39a1.554 1.554 0 01-.16-3.101l10.47-1.086s1.29-23.023-.78-26.62l-.06-.089c-2.04-3.535-2.97-5.151-9.12-7.66z"
          fill={`url(#${id}-dZ)`}
        />
        <path
          d="M5815.22 392.627c-6.2-2.531-13.76-10.333-16.76-13.918 3.82-2.525 12.36-7.069 15.93-5.037 4.46 2.539 10.17 11.858 10.91 15.976.59 3.294 5.2 7.549 7.43 9.265l-2.43 24.789h3.73c.93 0 1.74.62 1.98 1.513a2.052 2.052 0 01-1.24 2.447l-3.43 1.325.28 7.275a1.865 1.865 0 01-1.86 1.921c-1.02 0-1.85-.829-1.85-1.852v-5.903l-6.27 7.303a2.314 2.314 0 01-2.85.538 2.319 2.319 0 01-.64-3.598l3.11-3.488h-6.39a1.554 1.554 0 01-.16-3.101l10.47-1.086s1.29-23.023-.78-26.62l-.06-.089c-2.04-3.535-2.97-5.151-9.12-7.66z"
          fill={`url(#${id}-ea)`}
        />
        <path
          d="M5768.46 264.281c-1.23-1.64-.51-4.669 0-5.295h-11.1l1.53 8.2 19.65 7.858 3.76-3.929c-4.1-1.595-12.61-5.194-13.84-6.834z"
          fill={`url(#${id}-eb)`}
        />
        <path
          d="M5787.98 271.032c-.69-.801-18.45-7.984-20.05-8.989 5.68 2.841 25.28 9.423 26.74 9.642 1.83.274 1.78 2.321 1.96 2.96.19.64 4.05 1.735 4.8 1.05.74-.684-.37-2.784.77-4.062 1.14-1.278 1.37-.183 2.06.685.68.867.91.593 1.66.593.74 0 2.59.274 3.14-.32.54-.593-1.06-2.647 0-3.058 1.05-.411 8.55 1.06 10.26 2.1 1.72 1.04 2.7 3.289 4.61 6.25 1.91 2.96.74 7.213.6 8.259-.14 1.047-2.41 2.049-3.18 2.049-.78 0-4.55-1.32-5.01-2.458-.45-1.138-1.55-1.684-2.73-1.502-1.19.182-.05 1.001 0 1.502.04.5-.93 1.916-4.55.865-3.63-1.052-5.15-3.144-5.15-4.237 0-1.092-2.5-2.002-3.23-2.002s.96 3.095 0 3.095c-.95 0-3 .913-5.19-.907-2.18-1.821-.41-2.094 0-3.095.41-1.001-.73-1.457-1.41-2.094-.68-.637-1.14-3.322-1.59-4.005-.46-.683-3.64-1.32-4.51-2.321z"
          fill={`url(#${id}-ec)`}
        />
        <path
          d="M5767.51 261.531l-1.71-1.806c3.21-1.406 11.28-.13 14.45.683l-3.46 2.001-2.3-2.392-2.44 1.806-2.34-1.806-2.2 1.514zm-4.23 4.314l-2.73 1.459c-.51 6.091 12.81 6.983 17.96 6.271l-1.44-2.122-2.37 1.43-.86-2.654-2.42 1.558-.7-2.596-2.77 1.673-.63-3.057-2.85 1.384-1.19-3.346z"
          fill="#FFFBFB"
        />
        <path
          clipRule="evenodd"
          d="M5865.02 336.413c-4.56 15.457-38.23 55.678-79.85 50.905-48.71-5.586-58.38-48.832-60.41-66.129-6.09-14.779-12.27-48.626 11.7-65.777 2.39-1.222 7.06-4.196 6.56-6.319s.41-5.255.93-6.556c0 0 14.72-1.246 17.8 0 3.08 1.245 3.59 2.81 3.59 2.81l7.74 3.746c4.37 2.081 12.17 7.566 12.09 8.898-.25 3.996-4.58 3.851-6.72 3.278-4.06-.728-13.08-1.748-16.7 0-3.62 1.749.88 5.828 3.59 7.649l11.28 3.358c1.19.352 2.46.281 3.59-.201l2.1-.89c-.38.797-.76 2.005-1.16 3.262-.81 2.518-1.67 5.234-2.7 5.242-.59.005-1.12-.617-1.8-1.428-1.08-1.282-2.55-3.034-5.32-3.512-1.51-.26-3.67-.303-5.89-.348-3.13-.063-6.37-.129-8.06-.8-2.9-1.147-4.22-4.683-4.22-4.683-6.62 15.914-11.29 49.995 5.57 59.698 20.97 12.065 70.14 8.893 79.47 4.315l3.36 18.821c9.5-4.422 17.28-9.633 23.46-15.339zm-24.16-4.219c-.97.213-1.72.406-2.16.541.69-.144 1.41-.324 2.16-.541z"
          fill={`url(#${id}-ed)`}
          fillRule="evenodd"
        />
        <path
          d="M5758.21 247.437c1.34.124 2.31.922 2.82 1.598.23.312.08.744-.3.823-1.32.272-2.66-.594-3.74-1.473-.46-.381-.28-1.054.32-1.018.25.014.54.037.9.07z"
          fill="#FFFBFB"
        />
        <path
          clipRule="evenodd"
          d="M5771.61 384.551c17.95-4.546 22.58-18.757 22.63-25.361l-.74-.006c-.05 6.37-4.55 20.301-22.25 24.696l.15.605.21.066zm-22.29-12.12c13.51-2.121 20.06-11.91 21.75-17.318l-.7-.221c-1.65 5.277-8.17 15.03-21.78 16.898.24.215.49.428.73.641zm-13.89-17.153c12.32 1.041 20.72-5.738 23.8-10.116l-.6-.426c-3 4.265-11.35 11-23.63 9.757.14.262.29.523.43.785zm-7.64-18.709c11.7 1.198 20.05-4.897 23.26-8.99l-.58-.457c-3.12 3.965-11.33 9.977-22.89 8.679.06.255.14.511.21.768zm-4.82-20.341c11.47 3.888 21.07-.379 25.35-3.898l-.18-.822c-4 3.476-13.74 8.039-25.45 3.84.09.297.19.59.28.88zm-3.7-25.478c11.15 8.322 22.73 6.15 28.12 3.438.03-.291.05-.582.08-.873-5.05 2.733-16.85 5.246-28.16-3.469-.02.302-.03.603-.04.904zm77.59 96.856c-.61.04-1.22.071-1.84.094 16.33-7.76 18.04-22.209 16.86-28.444l.73-.137c1.19 6.284-.46 20.397-15.75 28.487zm27.64-7.778c-.59.297-1.18.587-1.78.872 9.66-10.18 8.48-22.064 6.37-27.245l.68-.279c2.1 5.156 3.28 16.55-5.27 26.652z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M5725.47 325.498c-2.01-16.903 3.19-44.343 24.27-61.437 7.65-6.207 2.98-11.268-1.61-16.241-1.59-1.717-3.17-3.425-4.22-5.165-.53 1.364-1.38 4.377-.89 6.438.5 2.123-4.17 5.098-6.56 6.319-23.97 17.151-17.79 50.998-11.7 65.778.16 1.333.39 2.777.71 4.308z"
          fill={`url(#${id}-ee)`}
          fillRule="evenodd"
        />
        <path
          d="M5753.89 260.098c-4.26-4.051-13.77-12.182-17.76-12.307-4.98-.155 3.12 17.136 17.76 12.307z"
          fill="#FFFBFB"
        />
        <path
          clipRule="evenodd"
          d="M5843.81 350.607c1.71-3.418 2.85-6.669 3.49-9.44-3.21-8.328-7.31-9.009-8.95-8.308-8.96 4.617-58.54 7.886-79.62-4.243-6.75-3.884-10.05-11.675-11.15-20.644-.2 12.225 2.32 26.539 10.63 37.122.95 6.718 4 18.27 10.76 24.636-3.03 5.387-7.97 15.453-9.25 18.31-.71 1.573-5.51 7.771-8.19 10.582l-2.7-3.089a1.185 1.185 0 00-1.66-.119 1.189 1.189 0 00-.17 1.615l2.3 2.999-7.66 2.208a1.05 1.05 0 00.43 2.048l7.23-.949-3.78 5.747a1.27 1.27 0 00.33 1.738c.51.355 1.21.287 1.64-.161l6.55-6.804 4.71 2.74c.43.252.97.195 1.35-.139.49-.443.5-1.206.03-1.67l-4.82-4.758 22.94-23.037a8.49 8.49 0 002.21-8.105l-2.72-10.67c2.82.846 5.87 1.467 9.19 1.829a109.12 109.12 0 0030.12-.908c3.25 3.759 7.52 7.263 12.85 9.225l5.97 5.969 2.05 23.364h-4.24a.886.886 0 00-.43 1.656l2.12 1.199-8.15 2.111a1.804 1.804 0 00-1.24 2.354c.3.834 1.16 1.325 2.03 1.159l7.72-1.472-2.2 5.908a1.97 1.97 0 001.25 2.576c.99.311 2.04-.188 2.43-1.144l2.49-6.153 2.34 5.199a1.718 1.718 0 003.23-1.133l-2.56-9.932 2.2-27.506c-2.31-1.981-7.17-6.979-8.13-11.117-.4-1.671-.84-4.323-1.27-7.182a82.751 82.751 0 008.3-3.611z"
          fill={`url(#${id}-ef)`}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="3000"
          x2="3000"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-r`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-s`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-t`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-u`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-v`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-w`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-x`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-y`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-z`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-A`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-B`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-C`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-D`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-E`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-F`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-G`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-H`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-I`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-J`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-K`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-L`}
          x1="2323.55"
          x2="2316.27"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-O`}
          x1="3468.33"
          x2="3468.33"
          y1="153.702"
          y2="613.284"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-P`}
          x1="4328.92"
          x2="4328.92"
          y1="245.18"
          y2="579.322"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Q`}
          x1="4173.63"
          x2="4173.63"
          y1="270.051"
          y2="580.254"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-R`}
          x1="4052.98"
          x2="4052.98"
          y1="135.307"
          y2="582.274"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-S`}
          x1="3650.84"
          x2="3650.84"
          y1="394.902"
          y2="583.284"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-T`}
          x1="3915.32"
          x2="3915.32"
          y1="310.553"
          y2="583.284"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-U`}
          x1="3785.74"
          x2="3785.74"
          y1="253.618"
          y2="583.284"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-V`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-W`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-X`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Y`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Z`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aa`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ab`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ac`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ad`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ae`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-af`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ag`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ah`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ai`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aj`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ak`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-al`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-am`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-an`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ao`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ap`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aq`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ar`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-as`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-at`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-au`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-av`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aw`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ax`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ay`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-az`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aA`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aB`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aC`}
          x1="3392.09"
          x2="3384.81"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aD`}
          x1="1119.18"
          x2="1119.18"
          y1="-45.14"
          y2="604.832"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aE`}
          x1="948.876"
          x2="907.384"
          y1="574.116"
          y2="378.958"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aF`}
          x1="920.65"
          x2="920.65"
          y1="407.28"
          y2="448.444"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aG`}
          x1="1018.74"
          x2="977.967"
          y1="560.985"
          y2="374.637"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aH`}
          x1="1026.36"
          x2="1026.36"
          y1="407.28"
          y2="448.444"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aI`}
          x1="972.256"
          x2="915.994"
          y1="517.81"
          y2="337.657"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aJ`}
          x1="975.18"
          x2="975.18"
          y1="337.507"
          y2="393.37"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aK`}
          x1="975.997"
          x2="952.931"
          y1="381.949"
          y2="240.352"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aL`}
          x1="1000.95"
          x2="963.114"
          y1="678.957"
          y2="416.626"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aM`}
          x1="1002.7"
          x2="1002.7"
          y1="536.874"
          y2="608.164"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aN`}
          x1="936.88"
          x2="899.515"
          y1="637.886"
          y2="503.802"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aO`}
          x1="971.595"
          x2="971.595"
          y1="521.719"
          y2="557.076"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aP`}
          x1="1034.12"
          x2="1034.12"
          y1="521.719"
          y2="557.076"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aQ`}
          x1="1027.87"
          x2="1004.33"
          y1="379.94"
          y2="359.353"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aR`}
          x1="964.374"
          x2="940.841"
          y1="256.738"
          y2="236.151"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aS`}
          x1="914.023"
          x2="890.49"
          y1="378.421"
          y2="357.834"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aT`}
          x1="4769.84"
          x2="4769.84"
          y1="37.731"
          y2="687.704"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aU`}
          x1="1745.9"
          x2="1745.9"
          y1="-2.268"
          y2="647.704"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aV`}
          x1="2898.14"
          x2="2898.14"
          y1="-22.269"
          y2="627.704"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ba`}
          x1="385.768"
          x2="438.33"
          y1="390.513"
          y2="525.537"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bc`}
          x1="426.293"
          x2="426.287"
          y1="402.46"
          y2="401.008"
        >
          <stop stopColor="#B999CB" />
          <stop offset="1" stopColor="#DD8398" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bd`}
          x1="407.136"
          x2="337.228"
          y1="628.232"
          y2="387.235"
        >
          <stop stopColor="#0D3F54" />
          <stop offset="1" stopColor="#35C4B0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-be`}
          x1="294.859"
          x2="225.855"
          y1="618.429"
          y2="496.063"
        >
          <stop stopColor="#0D3F54" />
          <stop offset="1" stopColor="#35C4B0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bf`}
          x1="289.249"
          x2="289.242"
          y1="503.43"
          y2="501.615"
        >
          <stop stopColor="#BC66AC" />
          <stop offset="1" stopColor="#E59F8A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bg`}
          x1="302.606"
          x2="302.592"
          y1="568.526"
          y2="565.272"
        >
          <stop stopColor="#BC66AC" />
          <stop offset="1" stopColor="#E59F8A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bh`}
          x1="381.481"
          x2="383.968"
          y1="538.749"
          y2="538.738"
        >
          <stop stopColor="#65445B" />
          <stop offset="1" stopColor="#7F6C7D" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bi`}
          x1="485.733"
          x2="485.733"
          y1="542.372"
          y2="570.944"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bj`}
          x1="1930.08"
          x2="2001.74"
          y1="227.076"
          y2="532.151"
        >
          <stop stopColor="#CA96FD" />
          <stop offset="1" stopColor="#8036C9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bk`}
          x1="2025.17"
          x2="2025.17"
          y1="295.689"
          y2="689.685"
        >
          <stop stopColor="#943DEA" />
          <stop offset="1" stopColor="#B97BF7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bl`}
          x1="1981.93"
          x2="1981.93"
          y1="363.534"
          y2="413.499"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bm`}
          x1="1981.93"
          x2="1981.93"
          y1="466.059"
          y2="516.024"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bn`}
          x1="1979.19"
          x2="1979.19"
          y1="579.37"
          y2="632.497"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bo`}
          x1="2025.17"
          x2="2025.17"
          y1="363.534"
          y2="413.499"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bp`}
          x1="2025.17"
          x2="2025.17"
          y1="466.059"
          y2="516.024"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bq`}
          x1="2025.17"
          x2="2025.17"
          y1="579.37"
          y2="632.497"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-br`}
          x1="2068.41"
          x2="2068.41"
          y1="363.534"
          y2="413.499"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bs`}
          x1="2068.41"
          x2="2068.41"
          y1="466.059"
          y2="516.024"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bt`}
          x1="2168.35"
          x2="2211.96"
          y1="281.884"
          y2="532.21"
        >
          <stop stopColor="#70E7FF" />
          <stop offset="1" stopColor="#8036C9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bu`}
          x1="2245.93"
          x2="2246.77"
          y1="179.457"
          y2="754.044"
        >
          <stop stopColor="#1E69B1" />
          <stop offset="1" stopColor="#0EBDDC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bv`}
          x1="2261.22"
          x2="2261.22"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bw`}
          x1="2213.75"
          x2="2213.75"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bx`}
          x1="2261.27"
          x2="2261.27"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-by`}
          x1="2261.29"
          x2="2261.29"
          y1="568.639"
          y2="634.919"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bz`}
          x1="2214.87"
          x2="2214.87"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bA`}
          x1="2304.67"
          x2="2304.67"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bB`}
          x1="2309.93"
          x2="2309.93"
          y1="568.639"
          y2="634.919"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bC`}
          x1="2308.79"
          x2="2308.79"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bD`}
          x1="2400.62"
          x2="2448.05"
          y1="297.427"
          y2="549.884"
        >
          <stop stopColor="#F16FCE" />
          <stop offset="1" stopColor="#8036C9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bE`}
          x1="2560.3"
          x2="2368.77"
          y1="868.513"
          y2="845.307"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bF`}
          x1="2442.09"
          x2="2442.09"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bG`}
          x1="2486.53"
          x2="2486.53"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bH`}
          x1="2530.98"
          x2="2530.98"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bI`}
          x1="2443.41"
          x2="2443.41"
          y1="392.922"
          y2="441.184"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bJ`}
          x1="2486.74"
          x2="2486.74"
          y1="392.921"
          y2="441.183"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bK`}
          x1="2486.76"
          x2="2486.76"
          y1="577.024"
          y2="630.151"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bL`}
          x1="2534.75"
          x2="2534.75"
          y1="392.922"
          y2="441.184"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bM`}
          x1="2532.74"
          x2="2532.74"
          y1="577.024"
          y2="630.151"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bN`}
          x1="1247.96"
          x2="1247.96"
          y1="575.721"
          y2="858.567"
        >
          <stop stopColor="#FF9860" />
          <stop offset="1" stopColor="#FFE2B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bO`}
          x1="4700.52"
          x2="4700.52"
          y1="545.002"
          y2="884.895"
        >
          <stop stopColor="#FF9860" />
          <stop offset="1" stopColor="#FFE2B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bP`}
          x1="4725.43"
          x2="4725.43"
          y1="164.882"
          y2="175.796"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bQ`}
          x1="4990.23"
          x2="4025.54"
          y1="186.504"
          y2="549.068"
        >
          <stop stopColor="#FFBB68" />
          <stop offset="1" stopColor="#FFD168" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bR`}
          x1="4716.73"
          x2="4716.73"
          y1="216.435"
          y2="678.907"
        >
          <stop stopColor="#1F63C0" />
          <stop offset="1" stopColor="#3688F8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bS`}
          x1="4847.28"
          x2="4725.74"
          y1="495.708"
          y2="807.771"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bT`}
          x1="4647.11"
          x2="4597.32"
          y1="553.671"
          y2="711.536"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bU`}
          x1="4647.11"
          x2="4597.32"
          y1="553.671"
          y2="711.536"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bV`}
          x1="4466.3"
          x2="4350.42"
          y1="355.995"
          y2="676.824"
        >
          <stop stopColor="#FFBB68" />
          <stop offset="1" stopColor="#FFD168" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bW`}
          x1="4492.12"
          x2="4492.12"
          y1="527.818"
          y2="834.718"
        >
          <stop stopColor="#F4F2FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bX`}
          x1="3737.53"
          x2="3813.42"
          y1="496.131"
          y2="833.699"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bY`}
          x1="3716.27"
          x2="3740.25"
          y1="351.846"
          y2="514.406"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-bZ`}
          x1="3669.7"
          x2="3669.7"
          y1="714.263"
          y2="830.579"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ca`}
          x1="4394.81"
          x2="3934.83"
          y1="763.676"
          y2="693.248"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cb`}
          x1="3769.72"
          x2="2669.97"
          y1="660.824"
          y2="517.239"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cc`}
          x1="4968.82"
          x2="2471.23"
          y1="799.309"
          y2="579.997"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cd`}
          x1="4064.54"
          x2="4471.43"
          y1="525.02"
          y2="776.275"
        >
          <stop stopColor="#576FEF" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ce`}
          x1="4038.17"
          x2="3916.9"
          y1="616.753"
          y2="554.362"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cf`}
          x1="3985.74"
          x2="3985.74"
          y1="634.424"
          y2="705.311"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cg`}
          x1="3992.56"
          x2="3992.56"
          y1="500.02"
          y2="555.948"
        >
          <stop stopColor="#8A7FC7" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ch`}
          x1="4206.73"
          x2="4206.73"
          y1="630.228"
          y2="691.178"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ci`}
          x1="2939.73"
          x2="2939.73"
          y1="443.678"
          y2="608.092"
        >
          <stop stopColor="#1F63C0" />
          <stop offset="1" stopColor="#3688F8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cj`}
          x1="2754.28"
          x2="1804.19"
          y1="757.775"
          y2="632.578"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ck`}
          x1="2450.53"
          x2="2451.97"
          y1="500.829"
          y2="520.152"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#7D2587" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cl`}
          x1="3106.28"
          x2="2176.37"
          y1="664.852"
          y2="517.556"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cm`}
          x1="1526.44"
          x2="1440.94"
          y1="527.987"
          y2="413.808"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cn`}
          x1="1526.44"
          x2="1440.94"
          y1="527.987"
          y2="413.808"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cq`}
          x1="1629.18"
          x2="1543.68"
          y1="527.987"
          y2="413.808"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cr`}
          x1="1629.18"
          x2="1543.68"
          y1="527.987"
          y2="413.808"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cu`}
          x1="1552.28"
          x2="1546.88"
          y1="464.383"
          y2="388.446"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cv`}
          x1="1655.32"
          x2="1541.17"
          y1="662.017"
          y2="389.659"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cw`}
          x1="1496.28"
          x2="1371.49"
          y1="645.451"
          y2="457.53"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cx`}
          x1="1496.28"
          x2="1371.49"
          y1="645.451"
          y2="457.53"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cz`}
          x1="1709.2"
          x2="1584.41"
          y1="645.451"
          y2="457.53"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cA`}
          x1="1709.2"
          x2="1584.41"
          y1="645.451"
          y2="457.53"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cD`}
          x1="1678.61"
          x2="1677.57"
          y1="393.136"
          y2="406.629"
        >
          <stop stopColor="#CE5E60" />
          <stop offset="1" stopColor="#F3898A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cE`}
          x1="1681.77"
          x2="1681.77"
          y1="217.092"
          y2="623.129"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cF`}
          x1="1524.77"
          x2="1542.74"
          y1="494.227"
          y2="554.789"
        >
          <stop stopColor="#89233E" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cG`}
          x1="3553.11"
          x2="2523.25"
          y1="785.309"
          y2="649.6"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cI`}
          x1="3302.35"
          x2="3302.35"
          y1="535.666"
          y2="588.16"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cJ`}
          x1="3120.22"
          x2="3120.22"
          y1="535.666"
          y2="588.16"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cK`}
          x1="3180.48"
          x2="3180.48"
          y1="709.063"
          y2="741.335"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cL`}
          x1="3249.12"
          x2="3249.12"
          y1="708.054"
          y2="740.327"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cM`}
          x1="3244.41"
          x2="3244.41"
          y1="626.03"
          y2="655.29"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cN`}
          x1="3215.84"
          x2="3215.84"
          y1="538.566"
          y2="599.006"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cO`}
          x1="3213.17"
          x2="3213.17"
          y1="488.993"
          y2="531.838"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cP`}
          x1="3166.44"
          x2="3166.44"
          y1="548.63"
          y2="575.455"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cQ`}
          x1="3210.41"
          x2="3210.41"
          y1="625.576"
          y2="647.536"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cR`}
          x1="3187.23"
          x2="3187.23"
          y1="625.369"
          y2="657.646"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cS`}
          x1="3188.2"
          x2="3188.2"
          y1="665.087"
          y2="688.65"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cT`}
          x1="3249.12"
          x2="3249.12"
          y1="665.087"
          y2="688.65"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cX`}
          x1="1422.56"
          x2="873.382"
          y1="743.608"
          y2="702.71"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cY`}
          x1="2164.25"
          x2="1249.66"
          y1="774.503"
          y2="653.984"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-cZ`}
          x1="1830.24"
          x2="1830.24"
          y1="546.719"
          y2="568.311"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-da`}
          x1="1820.15"
          x2="1820.15"
          y1="563.24"
          y2="583.532"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-db`}
          x1="1808.64"
          x2="1808.64"
          y1="579.029"
          y2="594.538"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dc`}
          x1="1800.07"
          x2="1800.07"
          y1="576.316"
          y2="604.545"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dd`}
          x1="1877.42"
          x2="1805.63"
          y1="599.598"
          y2="654.08"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-de`}
          x1="1872.82"
          x2="1826.69"
          y1="623.318"
          y2="663.76"
        >
          <stop stopColor="#56180E" />
          <stop offset="1" stopColor="#87572A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-df`}
          x1="1864.29"
          x2="1786.86"
          y1="488.286"
          y2="666.225"
        >
          <stop stopColor="#893729" />
          <stop offset="1" stopColor="#87572A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dg`}
          x1="1852.89"
          x2="1852.89"
          y1="615.725"
          y2="651.575"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dh`}
          x1="1876.04"
          x2="1876.04"
          y1="507.832"
          y2="588.909"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-di`}
          x1="1858.72"
          x2="1858.72"
          y1="501.687"
          y2="518.39"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dj`}
          x1="1852.69"
          x2="1852.69"
          y1="579.918"
          y2="618.714"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dk`}
          x1="1869.46"
          x2="1869.46"
          y1="490.486"
          y2="512.02"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dl`}
          x1="1859.16"
          x2="1859.16"
          y1="474.568"
          y2="495.352"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dm`}
          x1="1852.4"
          x2="1852.4"
          y1="475.924"
          y2="505.13"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dn`}
          x1="1849.62"
          x2="1849.62"
          y1="567.779"
          y2="601.049"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-do`}
          x1="1266.03"
          x2="1266.03"
          y1="581.184"
          y2="629.862"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dp`}
          x1="1262.77"
          x2="1262.77"
          y1="634.06"
          y2="705.66"
        >
          <stop stopColor="#7785F1" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dq`}
          x1="1780.79"
          x2="1003.73"
          y1="676.824"
          y2="635.614"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dr`}
          x1="1533.21"
          x2="1533.21"
          y1="553.145"
          y2="610.479"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ds`}
          x1="1496.41"
          x2="1496.41"
          y1="699.077"
          y2="815.394"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dt`}
          x1="383.904"
          x2="383.904"
          y1="662.871"
          y2="774.533"
        >
          <stop stopColor="#FF9860" />
          <stop offset="1" stopColor="#FFE2B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-du`}
          x1="488.562"
          x2="-347.751"
          y1="652.65"
          y2="588.841"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dv`}
          x1="824.512"
          x2="69.309"
          y1="668.375"
          y2="613.94"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dw`}
          x1="564.766"
          x2="598.466"
          y1="682.601"
          y2="651.309"
        >
          <stop stopColor="#FAC118" />
          <stop offset="1" stopColor="#EF901B" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dx`}
          x1="547.599"
          x2="540.727"
          y1="683.047"
          y2="727.734"
        >
          <stop stopColor="#FFFEFC" />
          <stop offset="1" stopColor="#FFFEFC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dy`}
          x1="527.308"
          x2="563.581"
          y1="723.31"
          y2="653.976"
        >
          <stop stopColor="#FAC118" />
          <stop offset="1" stopColor="#EF901B" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dz`}
          x1="539.476"
          x2="503.4"
          y1="722.848"
          y2="699.409"
        >
          <stop stopColor="#FAC118" />
          <stop offset="1" stopColor="#EF901B" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dA`}
          x1="685.112"
          x2="-202.357"
          y1="693.979"
          y2="619.674"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dB`}
          x1="3131.87"
          x2="3160.68"
          y1="702.616"
          y2="450.381"
        >
          <stop stopColor="#FF7EA6" />
          <stop offset="1" stopColor="#8A2164" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dC`}
          x1="3463.32"
          x2="3433.12"
          y1="922.279"
          y2="570.363"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dD`}
          x1="3490.33"
          x2="3168.09"
          y1="730.911"
          y2="710.692"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dE`}
          x1="5394.47"
          x2="5394.47"
          y1="90.926"
          y2="1041.95"
        >
          <stop stopColor="#2C235E" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dF`}
          x1="5086.38"
          x2="5184.29"
          y1="345.087"
          y2="830.901"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dG`}
          x1="5487.86"
          x2="5487.86"
          y1="364.005"
          y2="610.168"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dH`}
          x1="5512.93"
          x2="5725.65"
          y1="189.585"
          y2="824.546"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dI`}
          x1="5511.89"
          x2="5505.06"
          y1="555.923"
          y2="784.767"
        >
          <stop stopColor="#292151" />
          <stop offset="1" stopColor="#2C235E" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dJ`}
          x1="1432.73"
          x2="458.523"
          y1="802.954"
          y2="694.068"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dK`}
          x1="1132.88"
          x2="1132.88"
          y1="548.732"
          y2="706.298"
        >
          <stop stopColor="#2891C5" />
          <stop offset="1" stopColor="#166576" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dL`}
          x1="1197.31"
          x2="1197.31"
          y1="556.273"
          y2="749.432"
        >
          <stop stopColor="#AE6328" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dN`}
          x1="1050.7"
          x2="1050.7"
          y1="551.122"
          y2="622.76"
        >
          <stop stopColor="#2AF5C4" />
          <stop offset="1" stopColor="#2AF5C4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dP`}
          x1="5514.55"
          x2="5398.57"
          y1="457.429"
          y2="850.943"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dR`}
          x1="2242.19"
          x2="2242.19"
          y1="-29.084"
          y2="122.848"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dT`}
          x1="3000"
          x2="3000"
          y1="187.221"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dU`}
          x1="3000"
          x2="3000"
          y1="187.221"
          y2="616"
        >
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dV`}
          x1="5872.2"
          x2="5872.2"
          y1="161.495"
          y2="340.002"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dW`}
          x1="5725.17"
          x2="5716.82"
          y1="311.443"
          y2="369.749"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dX`}
          x1="5716.82"
          x2="5714.36"
          y1="347.714"
          y2="369.555"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#C83EBF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dY`}
          x1="5664.4"
          x2="5664.4"
          y1="128"
          y2="348.642"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-dZ`}
          x1="5822.74"
          x2="5760.5"
          y1="295.831"
          y2="407.346"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ea`}
          x1="5817.47"
          x2="5797.61"
          y1="384.947"
          y2="430.481"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#C83EBF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-eb`}
          x1="5769.83"
          x2="5769.83"
          y1="258.986"
          y2="275.044"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ec`}
          x1="5802.71"
          x2="5770.45"
          y1="269.094"
          y2="267.015"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ed`}
          x1="5784.8"
          x2="5866.76"
          y1="241.983"
          y2="416.645"
        >
          <stop stopColor="#BA3491" />
          <stop offset="1" stopColor="#D2573D" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ee`}
          x1="5740.43"
          x2="5726.1"
          y1="255.855"
          y2="325.82"
        >
          <stop stopColor="#792374" />
          <stop offset="1" stopColor="#872A81" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ef`}
          x1="5794.1"
          x2="5773.83"
          y1="326.78"
          y2="408.236"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#C83EBF" />
        </linearGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="rotate(22.432 -846.862 1186.895) scale(61.2516 69.6791)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-aW`}
          r="1"
        >
          <stop stopColor="#246174" />
          <stop offset="1" stopColor="#092F46" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(41.72285 16.73223 -18.84493 46.991 372.895 484.68)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-aX`}
          r="1"
        >
          <stop stopColor="#246174" />
          <stop offset="1" stopColor="#0D4254" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(57.39633 14.38459 -11.01942 43.96889 372.895 484.68)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-aY`}
          r="1"
        >
          <stop stopColor="#246174" />
          <stop offset="1" stopColor="#092F46" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(42.5467 41.6891 -47.58112 48.55992 346.913 425.961)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-aZ`}
          r="1"
        >
          <stop stopColor="#246174" />
          <stop offset="1" stopColor="#092F46" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(41.63783 28.15512 -34.53193 51.06831 415.296 333.999)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-bb`}
          r="1"
        >
          <stop stopColor="#246174" />
          <stop offset="1" stopColor="#092F46" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 1483.98 344.685)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-co`}
          r="1"
        >
          <stop stopColor="#75337C" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 1483.98 344.685)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-cp`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 1586.7 344.685)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-cs`}
          r="1"
        >
          <stop stopColor="#75337C" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 1586.7 344.685)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-ct`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(13.77108 30.59061 -37.00356 16.65801 1422.51 381.783)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-cy`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(13.77108 30.59061 -37.00356 16.65801 1635.36 383.106)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-cB`}
          r="1"
        >
          <stop stopColor="#75337C" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(13.77108 30.59061 -37.00356 16.65801 1635.36 383.106)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-cC`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2750.87"
          id={`${id}-c`}
          width="2746.77"
          x="-223.037"
          y="-1069.63"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5091_45784"
            stdDeviation="392.625"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2978.22"
          id={`${id}-d`}
          width="3012.83"
          x="840.477"
          y="-1068.65"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5091_45784"
            stdDeviation="400"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2622.38"
          id={`${id}-M`}
          width="2622.6"
          x="2044.18"
          y="-1092.72"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5091_45784"
            stdDeviation="369.477"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2944.47"
          id={`${id}-N`}
          width="2944.69"
          x="2891.38"
          y="-1253.76"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5091_45784"
            stdDeviation="450"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="63.318"
          id={`${id}-cH`}
          width="79.973"
          x="3259.62"
          y="629.395"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="221.87"
          id={`${id}-cU`}
          width="244.624"
          x="3093.41"
          y="439.253"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="86.204"
          id={`${id}-cV`}
          width="57.768"
          x="3034.44"
          y="431.895"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="72.127"
          id={`${id}-cW`}
          width="45.307"
          x="3344.73"
          y="432.694"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="83.658"
          id={`${id}-dM`}
          width="64.153"
          x="1018.62"
          y="516.62"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="30.707"
          id={`${id}-dO`}
          width="22.522"
          x="1065.49"
          y="543.069"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="145.131"
          id={`${id}-dQ`}
          width="129.77"
          x="2177.31"
          y="9.717"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.682208 0 0 0 0 0.395833 0 0 0 0.93 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="244.163"
          id={`${id}-dS`}
          width="405.295"
          x="2854.81"
          y="-12.309"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5091_45784"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5091_45784"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h6000v793.658H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
